import * as i0 from '@angular/core';
import { Injectable, NgModule, Component, EventEmitter, forwardRef, ChangeDetectionStrategy, Input, Pipe, Directive, Output, ViewEncapsulation, HostListener, ViewChild, ContentChildren } from '@angular/core';
import * as i1 from '@capturum/api';
import { ApiService } from '@capturum/api';
import { Subject, from, concat, Observable, BehaviorSubject, of, map as map$1, shareReplay, take as take$1, tap as tap$1, filter, forkJoin, merge, fromEvent, interval, throwError } from 'rxjs';
import { format, isDate } from 'date-fns';
import { map, tap, catchError, switchMap, delay, takeUntil, mergeMap, take, finalize, filter as filter$1, skip } from 'rxjs/operators';
import * as i3 from '@angular/common';
import { CommonModule, KeyValuePipe } from '@angular/common';
import * as i1$1 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i1$2 from '@ngx-translate/core';
import { TranslateModule, TranslatePipe, TranslateService, TranslateDefaultParser } from '@ngx-translate/core';
import * as i2 from 'ngx-permissions';
import { NgxPermissionsModule, NgxPermissionsService, NgxPermissionsGuard } from 'ngx-permissions';
import * as i4$2 from '@capturum/ui/api';
import { ToastService, CapturumSharedModule, FilterMatchMode, CapturumTemplateDirective, DateFormat } from '@capturum/ui/api';
import * as i5$3 from '@capturum/ui/dropdown';
import { CapturumDropdownModule } from '@capturum/ui/dropdown';
import * as i2$2 from '@angular/forms';
import { FormsModule, ReactiveFormsModule, FormGroup, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validators } from '@angular/forms';
import * as i3$2 from '@capturum/shared';
import { SharedModule as SharedModule$1, BaseDetailComponent, DestroyBase } from '@capturum/shared';
import { ToastModule } from 'primeng/toast';
import * as i4$1 from '@ngx-formly/core';
import { FormlyModule } from '@ngx-formly/core';
import { FormModule, FormField, emailValidator, passwordValidator } from '@capturum/formly';
import * as i2$1 from '@capturum/auth';
import { TwoFactorMethod } from '@capturum/auth';
import * as i4 from '@capturum/ui/button';
import { CapturumButtonModule } from '@capturum/ui/button';
import * as i6 from 'primeng/dropdown';
import { DropdownModule } from 'primeng/dropdown';
import * as i14 from 'primeng/confirmdialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import * as i5$1 from '@capturum/ui/loader';
import { CapturumLoaderModule } from '@capturum/ui/loader';
import * as i5$4 from '@capturum/ui/layout';
import { CapturumLayoutModule, CapturumLayoutDetailsModule } from '@capturum/ui/layout';
import { CapturumTableModule } from '@capturum/ui/table';
import * as i3$1 from 'primeng/progressspinner';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { v4 } from 'uuid';
import * as i5 from 'primeng/dynamicdialog';
import * as i1$3 from '@angular/common/http';
import { HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import * as i6$1 from '@capturum/ui/input-switch';
import { CapturumInputSwitchModule } from '@capturum/ui/input-switch';
import * as i5$2 from '@capturum/ui/input';
import { CapturumInputModule } from '@capturum/ui/input';
import jwtDecode from 'jwt-decode';
import * as i4$3 from 'primeng/api';
import Dexie from 'dexie';
import * as i6$2 from '@capturum/ui/input-code';
import { CapturumInputCodeComponent, CapturumInputCodeModule } from '@capturum/ui/input-code';
import { KeyFilterModule } from 'primeng/keyfilter';
import * as i6$3 from '@capturum/ui/info-table';
import { InfoTableColumnType, CapturumInfoTableModule } from '@capturum/ui/info-table';
import { captureException } from '@sentry/angular-ivy';

/**
 * Abstract class for models
 * Contains base methods for data logic and defines properties used for database setup (Dexie)
 *
 * A model can contain these default fields:
 * '++id'         field is unique and autoincremented
 * '*_remote_id'  field contains the id of the backend record.
 * 'updated_at'   field contains timestamp when record was updated locally
 * 'synced_at'    field contains timestamp when record was synced
 * 'sync_message' field contains message if sync failed
 */
function ConfigOverviewComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3)(1, "div", 4)(2, "div", 5)(3, "div", 6)(4, "h5");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 7)(8, "div", 3)(9, "div", 8)(10, "div", 9);
    i0.ɵɵelement(11, "i", 10);
    i0.ɵɵelementStart(12, "div", 11);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "translate");
    i0.ɵɵelementEnd()()()()()()()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 2, "config.overview.title"), " ");
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(14, 4, "config.setting-overview.label"), " ");
  }
}
function ConfigOverviewComponent_ng_template_2_ng_container_9_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16);
    i0.ɵɵlistener("click", function ConfigOverviewComponent_ng_template_2_ng_container_9_ng_template_1_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r8);
      const configItem_r4 = i0.ɵɵnextContext().$implicit;
      const ctx_r6 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r6.onConfigItemClick(configItem_r4));
    });
    i0.ɵɵelement(2, "i");
    i0.ɵɵelementStart(3, "div", 11);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const configItem_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵclassProp("disabled", configItem_r4.disabled);
    i0.ɵɵadvance(2);
    i0.ɵɵclassMap(configItem_r4.iconClass);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 5, configItem_r4.titleTranslationKey), " ");
  }
}
function ConfigOverviewComponent_ng_template_2_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ConfigOverviewComponent_ng_template_2_ng_container_9_ng_template_1_Template, 6, 7, "ng-template", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const configItem_r4 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngxPermissionsOnly", configItem_r4.permission);
  }
}
function ConfigOverviewComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 13)(2, "div", 5)(3, "div", 6)(4, "h5");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 7)(8, "div", 3);
    i0.ɵɵtemplate(9, ConfigOverviewComponent_ng_template_2_ng_container_9_Template, 2, 1, "ng-container", 14);
    i0.ɵɵpipe(10, "async");
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(6, 2, "config.manage.title"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(10, 4, ctx_r1.configItems$));
  }
}
function ConfigOverviewComponent_ng_template_4_ng_container_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15)(2, "div", 17);
    i0.ɵɵelement(3, "i", 18);
    i0.ɵɵelementStart(4, "div", 11);
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const baseDataKey_r11 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("routerLink", "/admin/base-data/", baseDataKey_r11.id, "/values");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 2, baseDataKey_r11.key), " ");
  }
}
function ConfigOverviewComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 12)(1, "div", 4)(2, "div", 5)(3, "div", 6)(4, "h5");
    i0.ɵɵtext(5);
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 7)(8, "div", 3);
    i0.ɵɵtemplate(9, ConfigOverviewComponent_ng_template_4_ng_container_9_Template, 7, 4, "ng-container", 14);
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(6, 2, "config.base_data.title"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r2.baseDataKeys);
  }
}
const _c0 = function () {
  return ["setting.manage", "setting.manage.tenant"];
};
function EditTranslationDialogComponent_form_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 6);
    i0.ɵɵlistener("ngSubmit", function EditTranslationDialogComponent_form_3_Template_form_ngSubmit_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.submit());
    });
    i0.ɵɵelement(1, "emc-translation-form", 7);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("locales", i0.ɵɵpipeBind1(2, 3, ctx_r0.locales$))("model", ctx_r0.model);
  }
}
const _c1 = function (a0) {
  return {
    submitting: a0
  };
};
function EditTranslationsTogglerComponent_cap_loader_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "cap-loader");
  }
}
function AuthSmsComponent_h6_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 7);
    i0.ɵɵelement(1, "i", 8);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "auth.2fa." + ctx_r0.method + ".send"), " ");
  }
}
function AuthEmailComponent_h6_13_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h6", 7);
    i0.ɵɵelement(1, "i", 8);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 1, "auth.2fa." + ctx_r0.method + ".send"), " ");
  }
}
function AuthAuthenticatorComponent_ng_container_21_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "img", 7);
    i0.ɵɵelementStart(2, "p", 8);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelement(5, "br");
    i0.ɵɵelementStart(6, "strong", 9);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const qrCodeData_r3 = ctx.ngIf;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("src", qrCodeData_r3 == null ? null : qrCodeData_r3.qrCode, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 3, "auth.2fa." + ctx_r0.method + ".qr.fail-scan-message"), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(qrCodeData_r3 == null ? null : qrCodeData_r3.secret);
  }
}
function AuthAuthenticatorComponent_ng_template_23_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "p-progressSpinner", 10);
  }
}
const _c2 = function (a0) {
  return {
    "method": a0
  };
};
function UserProfileComponent_div_16_h5_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h5");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", i0.ɵɵpipeBind1(2, 2, "user.profile.current_role"), ": ", ctx_r1.currentUser.current_role.name, " ");
  }
}
function UserProfileComponent_div_16_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, UserProfileComponent_div_16_h5_2_Template, 3, 4, "h5", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 2);
    i0.ɵɵelement(4, "emc-role-selector");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.currentUser.current_role);
  }
}
function UserFormComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "formly-form", 1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("fields", ctx_r0.fields)("form", ctx_r0.form);
  }
}
function MultiFactorFormComponent_form_0_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, item_r6.label), " ");
  }
}
function MultiFactorFormComponent_form_0_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const item_r7 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, item_r7.label), " ");
  }
}
function MultiFactorFormComponent_form_0_emc_auth_authenticator_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "emc-auth-authenticator", 16);
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("method", ctx_r3.controlMethod.value);
  }
}
function MultiFactorFormComponent_form_0_emc_auth_email_15_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "emc-auth-email", 17);
    i0.ɵɵlistener("emailCodeEvent", function MultiFactorFormComponent_form_0_emc_auth_email_15_Template_emc_auth_email_emailCodeEvent_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r8 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r8.showAndFocusInputCode());
    });
    i0.ɵɵelementEnd();
  }
}
function MultiFactorFormComponent_form_0_emc_auth_sms_16_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "emc-auth-sms", 18);
    i0.ɵɵlistener("smsCodeEvent", function MultiFactorFormComponent_form_0_emc_auth_sms_16_Template_emc_auth_sms_smsCodeEvent_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r10 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r10.showAndFocusInputCode());
    });
    i0.ɵɵelementEnd();
  }
}
function MultiFactorFormComponent_form_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 1)(1, "div", 2)(2, "section", 3)(3, "h5", 4);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 5)(7, "cap-dropdown", 6);
    i0.ɵɵlistener("change", function MultiFactorFormComponent_form_0_Template_cap_dropdown_change_7_listener($event) {
      i0.ɵɵrestoreView(_r13);
      const ctx_r12 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r12.changeMethodAuth($event.value));
    });
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵtemplate(10, MultiFactorFormComponent_form_0_ng_template_10_Template, 2, 3, "ng-template", 7);
    i0.ɵɵtemplate(11, MultiFactorFormComponent_form_0_ng_template_11_Template, 2, 3, "ng-template", 8);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(12, "section", 3);
    i0.ɵɵelementContainerStart(13, 9);
    i0.ɵɵtemplate(14, MultiFactorFormComponent_form_0_emc_auth_authenticator_14_Template, 1, 1, "emc-auth-authenticator", 10);
    i0.ɵɵtemplate(15, MultiFactorFormComponent_form_0_emc_auth_email_15_Template, 1, 0, "emc-auth-email", 11);
    i0.ɵɵtemplate(16, MultiFactorFormComponent_form_0_emc_auth_sms_16_Template, 1, 0, "emc-auth-sms", 12);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "section", 3)(18, "h5", 4);
    i0.ɵɵtext(19);
    i0.ɵɵpipe(20, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(21, "p", 13);
    i0.ɵɵtext(22);
    i0.ɵɵpipe(23, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 14)(25, "cap-input-code", 15);
    i0.ɵɵlistener("valuesFilled", function MultiFactorFormComponent_form_0_Template_cap_input_code_valuesFilled_25_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r14 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r14.appInputCodeFilled());
    });
    i0.ɵɵelementEnd()()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.form);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" 1. ", i0.ɵɵpipeBind1(5, 13, "auth.2fa.types.select"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", i0.ɵɵpipeBind1(8, 15, ctx_r0.types$))("placeholder", i0.ɵɵpipeBind1(9, 17, "auth.2fa.types.select"));
    i0.ɵɵadvance(6);
    i0.ɵɵproperty("ngSwitch", ctx_r0.controlMethod.value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.TwoFactorMethod.google || ctx_r0.TwoFactorMethod.microsoft);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.TwoFactorMethod.email);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r0.TwoFactorMethod.sms);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("visibility", ctx_r0.showCode ? "visible" : "hidden");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", ctx_r0.controlMethod.value === ctx_r0.TwoFactorMethod.google ? "4" : "3", " . ", i0.ɵɵpipeBind1(20, 19, "auth.2fa.code.title"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(23, 21, "auth.2fa." + ctx_r0.controlMethod.value + ".code.description"), " ");
  }
}
function MultiFactorEnableFormComponent_form_0_section_2_ng_template_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const item_r5 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, item_r5.label), " ");
  }
}
function MultiFactorEnableFormComponent_form_0_section_2_ng_template_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(1, 1, item_r6.label), " ");
  }
}
function MultiFactorEnableFormComponent_form_0_section_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 4)(1, "h5", 5)(2, "span");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 8)(7, "cap-dropdown", 9);
    i0.ɵɵpipe(8, "async");
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵtemplate(10, MultiFactorEnableFormComponent_form_0_section_2_ng_template_10_Template, 2, 3, "ng-template", 10);
    i0.ɵɵtemplate(11, MultiFactorEnableFormComponent_form_0_section_2_ng_template_11_Template, 2, 3, "ng-template", 11);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r1.paragraphNumbers == null ? null : ctx_r1.paragraphNumbers.method, ".");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\xA0", i0.ɵɵpipeBind1(5, 4, "auth.2fa.types.select"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("options", i0.ɵɵpipeBind1(8, 6, ctx_r1.types$))("placeholder", i0.ɵɵpipeBind1(9, 8, "auth.2fa.types.select"));
  }
}
function MultiFactorEnableFormComponent_form_0_section_3_emc_auth_email_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "emc-auth-email", 16);
    i0.ɵɵlistener("emailCodeEvent", function MultiFactorEnableFormComponent_form_0_section_3_emc_auth_email_2_Template_emc_auth_email_emailCodeEvent_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r10 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r10.showAndFocusInputCode());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("paragraphNumbers", ctx_r7.paragraphNumbers)("method", ctx_r7.controlMethod.value);
  }
}
function MultiFactorEnableFormComponent_form_0_section_3_emc_auth_sms_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "emc-auth-sms", 17);
    i0.ɵɵlistener("smsCodeEvent", function MultiFactorEnableFormComponent_form_0_section_3_emc_auth_sms_3_Template_emc_auth_sms_smsCodeEvent_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r12 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r12.showAndFocusInputCode());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("paragraphNumbers", ctx_r8.paragraphNumbers)("method", ctx_r8.controlMethod.value);
  }
}
function MultiFactorEnableFormComponent_form_0_section_3_emc_auth_authenticator_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "emc-auth-authenticator", 18);
  }
  if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("paragraphNumbers", ctx_r9.paragraphNumbers)("method", ctx_r9.controlMethod.value);
  }
}
function MultiFactorEnableFormComponent_form_0_section_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "section", 4);
    i0.ɵɵelementContainerStart(1, 12);
    i0.ɵɵtemplate(2, MultiFactorEnableFormComponent_form_0_section_3_emc_auth_email_2_Template, 1, 2, "emc-auth-email", 13);
    i0.ɵɵtemplate(3, MultiFactorEnableFormComponent_form_0_section_3_emc_auth_sms_3_Template, 1, 2, "emc-auth-sms", 14);
    i0.ɵɵtemplate(4, MultiFactorEnableFormComponent_form_0_section_3_emc_auth_authenticator_4_Template, 1, 2, "emc-auth-authenticator", 15);
    i0.ɵɵelementContainerEnd();
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitch", ctx_r2.controlMethod.value);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.TwoFactorMethod.email);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", ctx_r2.TwoFactorMethod.sms);
  }
}
function MultiFactorEnableFormComponent_form_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, MultiFactorEnableFormComponent_form_0_section_2_Template, 12, 10, "section", 3);
    i0.ɵɵtemplate(3, MultiFactorEnableFormComponent_form_0_section_3_Template, 5, 3, "section", 3);
    i0.ɵɵelementStart(4, "section", 4)(5, "h5", 5)(6, "span");
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵtext(8);
    i0.ɵɵpipe(9, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "p", 6);
    i0.ɵɵtext(11);
    i0.ɵɵpipe(12, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "cap-input-code", 7);
    i0.ɵɵlistener("valuesFilled", function MultiFactorEnableFormComponent_form_0_Template_cap_input_code_valuesFilled_13_listener() {
      i0.ɵɵrestoreView(_r15);
      const ctx_r14 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r14.appInputCodeFilled());
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r0.canSelectMethod);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.controlMethod.value);
    i0.ɵɵadvance(1);
    i0.ɵɵstyleProp("visibility", !!ctx_r0.controlMethod.value ? "visible" : "hidden");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r0.paragraphNumbers == null ? null : ctx_r0.paragraphNumbers.code, ".");
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1("\xA0", i0.ɵɵpipeBind1(9, 8, "auth.2fa.code.title"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(12, 10, "auth.2fa." + ctx_r0.controlMethod.value + ".code.description"), " ");
  }
}
function MultiFactorDisableFormComponent_form_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "form", 1)(1, "div", 2)(2, "section", 3)(3, "h5", 4);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "p", 5);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "cap-input-code", 6);
    i0.ɵɵlistener("valuesFilled", function MultiFactorDisableFormComponent_form_0_Template_cap_input_code_valuesFilled_9_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.appInputCodeFilled());
    });
    i0.ɵɵelementEnd()()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r0.formGroup);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", ctx_r0.paragraphNumbers == null ? null : ctx_r0.paragraphNumbers.code, ". ", i0.ɵɵpipeBind1(5, 4, "auth.2fa.code.title"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 6, "auth.2fa." + ctx_r0.controlMethod.value + ".code.description"), " ");
  }
}
const _c3 = ".multi-factor-form--section-title{font-size:1.25rem;margin-bottom:.5rem;font-weight:600}.multi-factor-form--section-description{font-size:.9rem;margin-bottom:.75rem}.multi-factor-form--section{margin:1rem 0}.multi-factor-form--section:first-of-type{margin-top:0}.multi-factor-form--section:last-of-type{margin-bottom:0}\n";
function MultiFactorDialogComponent_emc_multi_factor_enable_form_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "emc-multi-factor-enable-form", 6);
    i0.ɵɵlistener("currentForm", function MultiFactorDialogComponent_emc_multi_factor_enable_form_0_Template_emc_multi_factor_enable_form_currentForm_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.updateCode($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("canSelectMethod", ctx_r0.canSelectMethod)("selectedMethod", ctx_r0.selectedMethod);
  }
}
function MultiFactorDialogComponent_emc_multi_factor_disable_form_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "emc-multi-factor-disable-form", 7);
    i0.ɵɵlistener("currentForm", function MultiFactorDialogComponent_emc_multi_factor_disable_form_1_Template_emc_multi_factor_disable_form_currentForm_0_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.updateCode($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("selectedMethod", ctx_r1.selectedMethod);
  }
}
function ModelLogTimelineComponent_ng_container_0_ng_container_3_ng_container_1_div_2_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c4 = function (a0) {
  return {
    user: a0
  };
};
const _c5 = function (a0, a1) {
  return {
    user: a0,
    date: a1
  };
};
function ModelLogTimelineComponent_ng_container_0_ng_container_3_ng_container_1_div_2_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵpipe(2, "lowercase");
    i0.ɵɵelementStart(3, "div", 14);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵpipe(6, "date");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r14 = i0.ɵɵnextContext(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(1, 2, i0.ɵɵpipeBind1(2, 5, "model-log.action." + item_r11.action), i0.ɵɵpureFunction1(13, _c4, item_r11.user.name)), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(5, 7, "model-log.created-by", i0.ɵɵpureFunction2(15, _c5, item_r11.user.name, i0.ɵɵpipeBind2(6, 10, item_r11.created_on, ctx_r14.headerDateFormat))), " ");
  }
}
function ModelLogTimelineComponent_ng_container_0_ng_container_3_ng_container_1_div_2_ng_container_6_div_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c6 = function (a0, a1) {
  return {
    diff: a0,
    item: a1
  };
};
function ModelLogTimelineComponent_ng_container_0_ng_container_3_ng_container_1_div_2_ng_container_6_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 17);
    i0.ɵɵtemplate(1, ModelLogTimelineComponent_ng_container_0_ng_container_3_ng_container_1_div_2_ng_container_6_div_3_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const diff_r20 = ctx.$implicit;
    const item_r11 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r18 = i0.ɵɵnextContext(4);
    const _r1 = i0.ɵɵreference(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r18.bodyTemplate || _r1)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c6, diff_r20, item_r11));
  }
}
function ModelLogTimelineComponent_ng_container_0_ng_container_3_ng_container_1_div_2_ng_container_6_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "hr");
    i0.ɵɵelementStart(2, "div", 18)(3, "div", 19);
    i0.ɵɵtext(4);
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 20);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const item_r11 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(5, 2, "model-log.comment"), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", item_r11.comment ? item_r11.comment : item_r11.reason, " ");
  }
}
function ModelLogTimelineComponent_ng_container_0_ng_container_3_ng_container_1_div_2_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵelement(2, "hr");
    i0.ɵɵtemplate(3, ModelLogTimelineComponent_ng_container_0_ng_container_3_ng_container_1_div_2_ng_container_6_div_3_Template, 2, 5, "div", 16);
    i0.ɵɵtemplate(4, ModelLogTimelineComponent_ng_container_0_ng_container_3_ng_container_1_div_2_ng_container_6_ng_container_4_Template, 8, 4, "ng-container", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const diffArray_r17 = ctx.ngIf;
    const item_r11 = i0.ɵɵnextContext().$implicit;
    const ctx_r15 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", diffArray_r17)("ngForTrackBy", ctx_r15.trackByIndex);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r11.comment || item_r11.reason);
  }
}
const _c7 = function (a0) {
  return {
    $implicit: a0
  };
};
function ModelLogTimelineComponent_ng_container_0_ng_container_3_ng_container_1_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9)(1, "div", 10);
    i0.ɵɵtemplate(2, ModelLogTimelineComponent_ng_container_0_ng_container_3_ng_container_1_div_2_ng_container_2_Template, 1, 0, "ng-container", 11);
    i0.ɵɵtemplate(3, ModelLogTimelineComponent_ng_container_0_ng_container_3_ng_container_1_div_2_ng_template_3_Template, 7, 18, "ng-template", null, 12, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 13);
    i0.ɵɵtemplate(6, ModelLogTimelineComponent_ng_container_0_ng_container_3_ng_container_1_div_2_ng_container_6_Template, 5, 3, "ng-container", 6);
    i0.ɵɵpipe(7, "keyvalue");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const item_r11 = ctx.$implicit;
    const _r13 = i0.ɵɵreference(4);
    const ctx_r10 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r10.headerTemplate || _r13)("ngTemplateOutletContext", i0.ɵɵpureFunction1(5, _c7, item_r11));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(7, 3, item_r11 == null ? null : item_r11.diffs));
  }
}
function ModelLogTimelineComponent_ng_container_0_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵtemplate(2, ModelLogTimelineComponent_ng_container_0_ng_container_3_ng_container_1_div_2_Template, 8, 7, "div", 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const logs_r9 = ctx.ngIf;
    const ctx_r8 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", logs_r9)("ngForTrackBy", ctx_r8.trackByIndex);
  }
}
function ModelLogTimelineComponent_ng_container_0_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ModelLogTimelineComponent_ng_container_0_ng_container_3_ng_container_1_Template, 3, 2, "ng-container", 6);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const historyItem_r6 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", historyItem_r6.value == null ? null : historyItem_r6.value.modelLogs);
  }
}
function ModelLogTimelineComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "div", 4);
    i0.ɵɵtemplate(3, ModelLogTimelineComponent_ng_container_0_ng_container_3_Template, 2, 1, "ng-container", 5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r0.historyItemsArray)("ngForTrackBy", ctx_r0.trackByIndex);
  }
}
function ModelLogTimelineComponent_ng_template_1_ng_container_0_ng_container_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "cacModelLogDiff");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const diff_r25 = i0.ɵɵnextContext(2).diff;
    const ctx_r28 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(3, 1, diff_r25.value.new, ctx_r28.dateFormat || i0.ɵɵpipeBind1(4, 4, "model-log.empty")), " ");
  }
}
function ModelLogTimelineComponent_ng_template_1_ng_container_0_ng_container_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "br");
    i0.ɵɵelementStart(2, "span", 22);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "cacModelLogDiff");
    i0.ɵɵpipe(5, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const diff_r25 = i0.ɵɵnextContext(2).diff;
    const ctx_r29 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(4, 1, diff_r25.value.old, ctx_r29.dateFormat || i0.ɵɵpipeBind1(5, 4, "model-log.empty")), " ");
  }
}
function ModelLogTimelineComponent_ng_template_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 21);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "lowercase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 20);
    i0.ɵɵtemplate(6, ModelLogTimelineComponent_ng_template_1_ng_container_0_ng_container_6_Template, 5, 6, "ng-container", 6);
    i0.ɵɵtemplate(7, ModelLogTimelineComponent_ng_template_1_ng_container_0_ng_container_7_Template, 6, 6, "ng-container", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext();
    const item_r26 = ctx_r32.item;
    const diff_r25 = ctx_r32.diff;
    const ctx_r27 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 3, (ctx_r27.translationKeyPrefix ? ctx_r27.translationKeyPrefix + "." : "") + i0.ɵɵpipeBind1(4, 5, item_r26.entity_key + "." + diff_r25.key + ".label")), " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", diff_r25.value.hideNew === undefined || !(diff_r25.value.hideNew === true));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", diff_r25.value.hideOld === undefined || !(diff_r25.value.hideOld === true));
  }
}
function ModelLogTimelineComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ModelLogTimelineComponent_ng_template_1_ng_container_0_Template, 8, 7, "ng-container", 6);
  }
  if (rf & 2) {
    const diff_r25 = ctx.diff;
    i0.ɵɵproperty("ngIf", diff_r25.value.hideNew === undefined || !(diff_r25.value.hideNew === true) || diff_r25.value.hideOld === undefined || !(diff_r25.value.hideOld === true));
  }
}
function ModelLogTimelineComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 1, ctx_r4.emptyResultsTranslationKey), " ");
  }
}
function JobsListComponent_ng_template_7_ng_template_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
    i0.ɵɵpipe(1, "date");
  }
  if (rf & 2) {
    const item_r3 = ctx.item;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(1, 1, item_r3.failed_at, ctx_r2.dateFormat.generalWithTime), " ");
  }
}
function JobsListComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5)(1, "h4", 6);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "h4", 6);
    i0.ɵɵtext(6);
    i0.ɵɵpipe(7, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "cap-info-table", 7, 8);
    i0.ɵɵlistener("onLazyLoad", function JobsListComponent_ng_template_7_Template_cap_info_table_onLazyLoad_8_listener($event) {
      i0.ɵɵrestoreView(_r5);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.loadTableData($event));
    });
    i0.ɵɵpipe(10, "async");
    i0.ɵɵpipe(11, "async");
    i0.ɵɵtemplate(12, JobsListComponent_ng_template_7_ng_template_12_Template, 2, 4, "ng-template", 9);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind1(3, 10, "jobs.pending.label"), ": ", i0.ɵɵpipeBind1(4, 12, ctx_r0.pendingJobsCount$), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(7, 14, "jobs.failed.label"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("columns", ctx_r0.tableColumns)("stateKey", "failed-jobs-list")("data", i0.ɵɵpipeBind1(10, 16, ctx_r0.data$))("sortable", true)("loading", ctx_r0.loading)("paginator", i0.ɵɵpipeBind1(11, 18, ctx_r0.paginator$))("lazyLoading", true);
  }
}
let IndexedDbModel = /*#__PURE__*/(() => {
  class IndexedDbModel {
    static {
      this.store = null;
    }
    /**
     * Get a Dexie table instance
     *
     * @return - dexie table instance
     */
    static query() {
      const self = this;
      return IndexedDbModel.store[new self(null).table];
    }
    constructor(attributes) {
      /**
       * Set if model should be synchronised with server
       */
      this.sync = false;
      for (const attributeName in attributes) {
        if (attributes.hasOwnProperty(attributeName)) {
          this[attributeName] = attributes[attributeName];
        }
      }
      // Generate negative unique id if not set
      if (!this.id) {
        this.id = -Date.now();
      }
    }
    /**
     * Get the instance of the current class
     *
     * @return - An instance of the current class
     */
    getInstance() {
      return new this({});
    }
    /**
     * Initialize the model
     */
    async init() {}
    /**
     * Returns the object representation suitable for the backend
     *
     * @return - data for the backend
     */
    getData() {
      const data = JSON.parse(JSON.stringify(this));
      delete data.entity;
      delete data.table;
      delete data.schema;
      delete data.synced_at;
      delete data.synced_message;
      delete data.sync;
      data.created_at = this.formatDate(data.created_at);
      data.updated_at = this.formatDate(data.updated_at);
      data.deleted_at = this.formatDate(data.deleted_at);
      return data;
    }
    /**
     * Format the date to YYYYY-MM-DD HH:mm:ss format
     *
     * @param date - The date to be formatted
     *
     * @return - The formatted date
     */
    formatDate(date) {
      return date ? format(date, 'yyyy-MM-dd HH:mm:ss') : null;
    }
  }
  return IndexedDbModel;
})();
let SettingIndexedDbModel = /*#__PURE__*/(() => {
  class SettingIndexedDbModel extends IndexedDbModel {
    static {
      this.settings = [];
    }
    /**
     * Load current setting in static cache
     */
    static async loadSettings() {
      SettingIndexedDbModel.settings = await SettingIndexedDbModel.query().toArray();
    }
    /**
     * Get the setting by name
     *
     * @param name
     */
    static getValue(name) {
      if (!SettingIndexedDbModel.settings) {
        return undefined;
      }
      const currentSetting = SettingIndexedDbModel.settings.find(setting => setting.id === name);
      return currentSetting ? currentSetting.value : null;
    }
    /**
     * Get the boolean value of a setting
     *
     * @param name
     */
    static getBooleanValueByName(name) {
      if (!SettingIndexedDbModel.settings) {
        return false;
      }
      return SettingIndexedDbModel.getValue(name) === 'true' || SettingIndexedDbModel.getValue(name) === true;
    }
    // Constructor
    constructor(attributes) {
      super(attributes);
      // Configuration
      this.entity = 'setting';
      this.table = 'settings';
      this.schema = '++id, tenant_id, name';
      this.sync = false;
    }
  }
  return SettingIndexedDbModel;
})();
let SettingService = /*#__PURE__*/(() => {
  class SettingService extends ApiService {
    constructor() {
      super(...arguments);
      this.settingsChanged$ = new Subject();
      this.endpoint = 'setting';
      this.settingResolverEndpoint = '/role/setting';
    }
    /**
     * Retrieve the settings and store them in de local database
     */
    async loadAll() {
      const settings = await this.apiHttp.get(this.settingResolverEndpoint).pipe(map(response => response.data)).toPromise();
      if (settings) {
        await SettingIndexedDbModel.query().clear();
        const settingRecords = [];
        for (const key in settings) {
          if (settings.hasOwnProperty(key)) {
            settingRecords.push({
              id: key,
              value: settings[key]
            });
          }
        }
        await SettingIndexedDbModel.query().bulkAdd(settingRecords);
        await SettingIndexedDbModel.loadSettings();
        this.setGlobalStyles();
        this.settingsChanged$.next(null);
      }
      return Promise.resolve(settings);
    }
    /**
     * Set global styles
     */
    setGlobalStyles() {
      const colorSettings = SettingIndexedDbModel.settings.filter(setting => setting.id.includes('color'));
      for (const setting of colorSettings) {
        let key = setting.id;
        if (key.includes('general.tenant_')) {
          key = key.split('general.tenant_')[1];
        }
        document.documentElement.style.setProperty(`--cap-${key.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/[\s_]+/g, '-').toLowerCase()}`, setting.value);
        document.documentElement.style.setProperty(`--${key.replace(/([a-z])([A-Z])/g, '$1-$2').replace(/[\s_]+/g, '-').toLowerCase()}`, setting.value);
      }
    }
    /**
     * Set a setting for a tenant
     */
    set(settingId, data) {
      if (typeof data.value !== 'string') {
        data.value = JSON.stringify(data.value);
      }
      this.settingsChanged$.next();
      return this.apiHttp.post(`/setting/set/${settingId}`, data).pipe(tap(response => {
        SettingIndexedDbModel.query().put({
          id: response.data.key,
          value: response.data.value
        });
        SettingIndexedDbModel.loadSettings().then(() => {
          this.settingsChanged$.next();
          this.setGlobalStyles();
        });
      }));
    }
    /**
     * Get a setting value
     *
     * @param setting: string
     * @return any
     */
    getValue(setting) {
      return SettingIndexedDbModel.getBooleanValueByName(setting);
    }
    /**
     * Get a setting value
     *
     * @param setting: string
     * @return any
     */
    getValueString(setting) {
      return SettingIndexedDbModel.getValue(setting);
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵSettingService_BaseFactory;
        return function SettingService_Factory(t) {
          return (ɵSettingService_BaseFactory || (ɵSettingService_BaseFactory = i0.ɵɵgetInheritedFactory(SettingService)))(t || SettingService);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SettingService,
        factory: SettingService.ɵfac
      });
    }
  }
  return SettingService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PublicSettingService = /*#__PURE__*/(() => {
  class PublicSettingService extends SettingService {
    constructor() {
      super(...arguments);
      this.settingResolverEndpoint = '/setting/tenant';
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵPublicSettingService_BaseFactory;
        return function PublicSettingService_Factory(t) {
          return (ɵPublicSettingService_BaseFactory || (ɵPublicSettingService_BaseFactory = i0.ɵɵgetInheritedFactory(PublicSettingService)))(t || PublicSettingService);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PublicSettingService,
        factory: PublicSettingService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PublicSettingService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PublicSettingResolver = /*#__PURE__*/(() => {
  class PublicSettingResolver {
    constructor(publicSettingService) {
      this.publicSettingService = publicSettingService;
    }
    resolve(route, state) {
      return this.publicSettingService.loadAll();
    }
    static {
      this.ɵfac = function PublicSettingResolver_Factory(t) {
        return new (t || PublicSettingResolver)(i0.ɵɵinject(PublicSettingService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PublicSettingResolver,
        factory: PublicSettingResolver.ɵfac
      });
    }
  }
  return PublicSettingResolver;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PermissionIndexedDbModel = /*#__PURE__*/(() => {
  class PermissionIndexedDbModel extends IndexedDbModel {
    static {
      this.permissions = [];
    }
    /**
     * Load current permissions in static cache
     */
    static async loadPermissions() {
      PermissionIndexedDbModel.permissions = await PermissionIndexedDbModel.query().toArray();
    }
    /**
     * Get the permission by name
     *
     * @param name - the name of the permission
     *
     * @return the permission
     */
    static getByName(name) {
      if (!PermissionIndexedDbModel.permissions) {
        return undefined;
      }
      return PermissionIndexedDbModel.permissions.find(module => module.name === name);
    }
    // Constructor
    constructor(attributes) {
      super(attributes);
      // Configuration
      this.entity = 'permission';
      this.table = 'permissions';
      this.schema = '++id, module_id';
      this.sync = false;
    }
  }
  return PermissionIndexedDbModel;
})();
let PermissionService = /*#__PURE__*/(() => {
  class PermissionService extends ApiService {
    constructor(api, ngxPermissionService) {
      super(api);
      this.api = api;
      this.ngxPermissionService = ngxPermissionService;
      this.endpoint = 'permission';
    }
    /**
     * Retrieve all permissions of the current tenant
     */
    getPermissionsOfCurrentTenant() {
      return this.apiHttp.get('/tenant/permission').pipe(map(response => response.data));
    }
    /**
     * Load the permissions of the current user
     */
    loadPermissions() {
      return this.apiHttp.get(`/role/${this.endpoint}`).pipe(catchError(error => {
        return from(PermissionIndexedDbModel.query().toArray()).pipe(map(permissions => {
          return {
            data: permissions.map(permission => permission.name)
          };
        }));
      }), map(response => response.data), switchMap(permissions => {
        const permissionData = permissions.map(permission => {
          return {
            name: permission
          };
        });
        return concat(from(PermissionIndexedDbModel.query().clear()), from(PermissionIndexedDbModel.query().bulkAdd(permissionData)), from(PermissionIndexedDbModel.loadPermissions())).pipe(tap(() => {
          this.ngxPermissionService.flushPermissions();
          this.ngxPermissionService.loadPermissions(permissions);
        }));
      }), map(() => {
        return true;
      }));
    }
    static {
      this.ɵfac = function PermissionService_Factory(t) {
        return new (t || PermissionService)(i0.ɵɵinject(i1.ApiHttpService), i0.ɵɵinject(i2.NgxPermissionsService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PermissionService,
        factory: PermissionService.ɵfac
      });
    }
  }
  return PermissionService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PermissionModule = /*#__PURE__*/(() => {
  class PermissionModule {
    static {
      this.ɵfac = function PermissionModule_Factory(t) {
        return new (t || PermissionModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: PermissionModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return PermissionModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PermissionGuard = /*#__PURE__*/(() => {
  class PermissionGuard {
    constructor(permissionService) {
      this.permissionService = permissionService;
    }
    /**
     * Make sure permissions are loaded before accessing the route
     *
     * @param route - activated route
     * @param state - current state of the router
     */
    canActivate(route, state) {
      return this.permissionService.loadPermissions();
    }
    static {
      this.ɵfac = function PermissionGuard_Factory(t) {
        return new (t || PermissionGuard)(i0.ɵɵinject(PermissionService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PermissionGuard,
        factory: PermissionGuard.ɵfac
      });
    }
  }
  return PermissionGuard;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PermissionResolver = /*#__PURE__*/(() => {
  class PermissionResolver {
    constructor(permissionService) {
      this.permissionService = permissionService;
    }
    /**
     * Make sure the settings are loaded before accessing the route
     */
    resolve(route, state) {
      return this.permissionService.loadPermissions();
    }
    static {
      this.ɵfac = function PermissionResolver_Factory(t) {
        return new (t || PermissionResolver)(i0.ɵɵinject(PermissionService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PermissionResolver,
        factory: PermissionResolver.ɵfac
      });
    }
  }
  return PermissionResolver;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class CompleteConfig {
  constructor() {
    this.databaseName = 'capturum-complete-db';
    this.indexedDbModels = [];
    this.version = 1;
    this.userSpecificDb = true;
    this.syncConfig = {
      syncUrl: 'sync',
      syncModels: [{
        modelClass: PermissionIndexedDbModel,
        include: []
      }]
    };
    this.loaderImage = '';
    this.loaderText = 'Loading...';
    this.useTranslatedLoaderText = false;
    this.tableStateKey = 'capturum-complete';
    this.configPage = {
      route: '/admin/config',
      except: []
    };
    this.toastService = ToastService;
  }
}
let TenantService = /*#__PURE__*/(() => {
  class TenantService extends ApiService {
    constructor(httpService) {
      super(httpService);
      this.httpService = httpService;
      this.endpoint = 'tenant';
    }
    static {
      this.ɵfac = function TenantService_Factory(t) {
        return new (t || TenantService)(i0.ɵɵinject(i1.ApiHttpService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TenantService,
        factory: TenantService.ɵfac
      });
    }
  }
  return TenantService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// @dynamic
let ModuleIndexedDbModel = /*#__PURE__*/(() => {
  class ModuleIndexedDbModel extends IndexedDbModel {
    static {
      this.modules = [];
    }
    /**
     * Load current modules in static cache
     */
    static async loadModules() {
      ModuleIndexedDbModel.modules = await ModuleIndexedDbModel.query().toArray();
    }
    /**
     * Get module by given name
     */
    static getByName(name) {
      if (!ModuleIndexedDbModel.modules) {
        return undefined;
      }
      return ModuleIndexedDbModel.modules.find(module => module.name === name);
    }
    /**
     * Get the active modules
     *
     * @return list of modules
     */
    static async getModules() {
      return await ModuleIndexedDbModel.query().toArray();
    }
    // Constructor
    constructor(attributes) {
      super(attributes);
      // Configuration
      this.entity = 'module';
      this.table = 'modules';
      this.schema = '++id, name';
      this.sync = false;
    }
  }
  return ModuleIndexedDbModel;
})();
let ModuleService = /*#__PURE__*/(() => {
  class ModuleService extends ApiService {
    constructor(api) {
      super(api);
      this.api = api;
      this.endpoint = 'role/module';
    }
    /**
     * Get the modules of the user and store them in the indexedDB
     */
    loadModules() {
      return new Observable(observer => {
        this.apiHttp.get(`/${this.endpoint}`).pipe(map(response => response.data)).subscribe(async modules => {
          await ModuleIndexedDbModel.query().clear();
          await ModuleIndexedDbModel.query().bulkAdd(modules);
          await ModuleIndexedDbModel.loadModules();
          observer.next(true);
          observer.complete();
        }, async () => {
          await ModuleIndexedDbModel.loadModules();
          observer.next(true);
          observer.complete();
        });
      });
    }
    /**
     * Retrieve all modules
     */
    getModuleList() {
      return this.apiHttp.get('/module/list').pipe(map(response => response.data));
    }
    static {
      this.ɵfac = function ModuleService_Factory(t) {
        return new (t || ModuleService)(i0.ɵɵinject(i1.ApiHttpService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ModuleService,
        factory: ModuleService.ɵfac
      });
    }
  }
  return ModuleService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RoleService = /*#__PURE__*/(() => {
  class RoleService extends ApiService {
    constructor(httpService, authService, settingService, moduleService, permissionService) {
      super(httpService);
      this.httpService = httpService;
      this.authService = authService;
      this.settingService = settingService;
      this.moduleService = moduleService;
      this.permissionService = permissionService;
      this.endpoint = 'role';
    }
    /**
     * Set the current role of the user
     *
     * @param role - The role to switch to
     */
    setUserRole(role) {
      return this.apiHttp.post('/user/role', {
        role_id: role.id
      }).pipe(tap(() => {
        const user = this.authService.getUser();
        user.current_role = role;
        localStorage.setItem('user', JSON.stringify(user));
        // Refresh the settings/modules/translations
        this.settingService.loadAll();
        this.permissionService.loadPermissions().subscribe();
        this.moduleService.loadModules();
      }));
    }
    static {
      this.ɵfac = function RoleService_Factory(t) {
        return new (t || RoleService)(i0.ɵɵinject(i1.ApiHttpService), i0.ɵɵinject(i2$1.AuthService), i0.ɵɵinject(SettingService), i0.ɵɵinject(ModuleService), i0.ɵɵinject(PermissionService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: RoleService,
        factory: RoleService.ɵfac
      });
    }
  }
  return RoleService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RoleSelectorComponent = /*#__PURE__*/(() => {
  class RoleSelectorComponent {
    constructor(authService, roleService, router) {
      this.authService = authService;
      this.roleService = roleService;
      this.router = router;
    }
    ngOnInit() {
      const user = this.authService.getUser();
      if (user) {
        this.roles = user.roles;
        if (user.currentRole) {
          this.selectedRole = user.currentRole;
        }
      } else {
        this.roles = [];
      }
    }
    /**
     * Set the current user role
     */
    selectRole() {
      if (this.selectedRole) {
        this.roleService.setUserRole(this.selectedRole).subscribe(() => {
          this.router.navigate(['/']).then(() => {
            this.router.navigateByUrl('/admin/users/profile');
          });
        });
      }
    }
    /**
     * Hide role selector popup
     */
    onCancel() {
      this.router.navigateByUrl('/admin/users/profile');
    }
    static {
      this.ɵfac = function RoleSelectorComponent_Factory(t) {
        return new (t || RoleSelectorComponent)(i0.ɵɵdirectiveInject(i2$1.AuthService), i0.ɵɵdirectiveInject(RoleService), i0.ɵɵdirectiveInject(i1$1.Router));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RoleSelectorComponent,
        selectors: [["emc-role-selector"]],
        decls: 10,
        vars: 11,
        consts: [[1, "ibox"], [1, "ibox-title"], [1, "ibox-content"], ["dataKey", "id", "optionLabel", "name", 3, "ngModel", "options", "placeholder", "ngModelChange"], ["icon", "fa fa-user-tag", 1, "mt-3", 3, "label", "click"]],
        template: function RoleSelectorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "h5");
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "div", 2)(6, "p-dropdown", 3);
            i0.ɵɵlistener("ngModelChange", function RoleSelectorComponent_Template_p_dropdown_ngModelChange_6_listener($event) {
              return ctx.selectedRole = $event;
            });
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "cap-button", 4);
            i0.ɵɵlistener("click", function RoleSelectorComponent_Template_cap_button_click_8_listener() {
              return ctx.selectRole();
            });
            i0.ɵɵpipe(9, "translate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 5, "role.select-role.title"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngModel", ctx.selectedRole)("options", ctx.roles)("placeholder", i0.ɵɵpipeBind1(7, 7, "role.select-role.placeholder"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(9, 9, "role.select-role.title"));
          }
        },
        dependencies: [i2$2.NgControlStatus, i2$2.NgModel, i4.CapturumButtonComponent, i6.Dropdown, i1$2.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return RoleSelectorComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SharedModule = /*#__PURE__*/(() => {
  class SharedModule {
    static {
      this.ɵfac = function SharedModule_Factory(t) {
        return new (t || SharedModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SharedModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [TranslateService, TenantService],
        imports: [CommonModule, FormsModule, ReactiveFormsModule, FormModule, FormlyModule, FormlyModule, ToastModule, TranslateModule, NgxPermissionsModule, SharedModule$1, CapturumTableModule, CapturumLayoutModule, CapturumTableModule, CapturumLoaderModule, DropdownModule, ConfirmDialogModule, FormsModule, ReactiveFormsModule, FormModule, FormlyModule, TranslateModule, SharedModule$1, NgxPermissionsModule, CapturumSharedModule, CapturumLayoutModule, CapturumTableModule, CapturumLoaderModule, CapturumDropdownModule, DropdownModule, ConfirmDialogModule]
      });
    }
  }
  return SharedModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CompleteBaseForm = /*#__PURE__*/(() => {
  class CompleteBaseForm {
    constructor(cdr) {
      this.cdr = cdr;
      this.form = new FormGroup({});
      this.formChanged = new EventEmitter();
      this.updateForm = new BehaviorSubject(null);
      this.updateForm$ = this.updateForm.asObservable();
    }
    listenToFormChanges() {
      this.formSubscription = this.onFormChange().pipe(delay(0)).subscribe(value => {
        this.formChanged.emit(value);
      });
    }
    onFormChange() {
      return this.form.valueChanges;
    }
    registerOnChange(fn) {
      this.formChanged.subscribe(fn);
    }
    writeValue(value) {
      this.updateForm.next(value);
    }
    /**
     * Trigger form value update
     */
    updateFormValue() {
      // Add the delay to make sure formly has created it's formGroup
      this.updateForm$.pipe(delay(0)).subscribe(value => {
        this.form.patchValue({
          ...value
        }, {
          emitEvent: true
        });
        this.cdr.detectChanges();
      });
    }
    registerOnTouched(fn) {}
    validate({
      value
    }) {
      return this.form.invalid && {
        invalid: true
      };
    }
    ngOnDestroy() {
      if (this.formSubscription) {
        this.formSubscription.unsubscribe();
      }
    }
    static {
      this.ɵfac = function CompleteBaseForm_Factory(t) {
        return new (t || CompleteBaseForm)(i0.ɵɵinject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CompleteBaseForm,
        factory: CompleteBaseForm.ɵfac
      });
    }
  }
  return CompleteBaseForm;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SettingFormComponent = /*#__PURE__*/(() => {
  class SettingFormComponent extends CompleteBaseForm {
    constructor(changeDetectorRef, translateService) {
      super(changeDetectorRef);
      this.changeDetectorRef = changeDetectorRef;
      this.translateService = translateService;
    }
    ngAfterViewInit() {
      this.listenToFormChanges();
      this.createForm();
      this.changeDetectorRef.detectChanges();
    }
    createForm() {
      const field = new FormField({
        key: 'value',
        type: 'input',
        props: {
          label: this.translateService.instant('setting.overview.value')
        }
      });
      // Change the input type based on the type of setting
      switch (this.settingType) {
        case 'boolean':
          field.type = 'inputSwitch';
          break;
        case 'number':
          field.props.type = 'number';
          break;
        case 'hex_color':
          field.type = 'colorPicker';
          field.props.selectedColorLabel = this.translateService.instant('color.selected.label');
          break;
        case 'image':
          field.type = 'image';
          field.props.placeholder = this.translateService.instant('button.upload-image');
          break;
        case 'array':
          field.type = 'chips';
          break;
        case 'date':
          field.type = 'calendar';
          field.props.dataType = 'string';
          break;
        case 'dateTime':
          field.type = 'calendar';
          field.props.dataType = 'string';
          field.props.showTime = true;
          break;
      }
      this.fields = [field];
      this.changeDetectorRef.detectChanges();
      this.updateFormValue();
    }
    static {
      this.ɵfac = function SettingFormComponent_Factory(t) {
        return new (t || SettingFormComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.TranslateService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: SettingFormComponent,
        selectors: [["emc-setting-form"]],
        inputs: {
          settingType: "settingType"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => SettingFormComponent),
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: forwardRef(() => SettingFormComponent),
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 2,
        consts: [[3, "fields", "form"]],
        template: function SettingFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "formly-form", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("fields", ctx.fields)("form", ctx.form);
          }
        },
        dependencies: [i4$1.FormlyForm],
        styles: ["[_nghost-%COMP%]     cap-validator{display:none}"],
        changeDetection: 0
      });
    }
  }
  return SettingFormComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SettingModule = /*#__PURE__*/(() => {
  class SettingModule {
    static {
      this.ɵfac = function SettingModule_Factory(t) {
        return new (t || SettingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: SettingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, RouterModule, SharedModule]
      });
    }
  }
  return SettingModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Retrieves tenant or module setting
 * Usage:
 *   settingName | setting:'module name or "tenant"'
 * Example:
 *   {{ name | setting:'tenant' }}
 *   formats to: "Tenant B.V."
 */
let SettingPipe = /*#__PURE__*/(() => {
  class SettingPipe {
    transform(settingName,
    /**
     * @deprecated just ignore this parameter
     */
    moduleName) {
      return SettingIndexedDbModel.getValue(settingName);
    }
    static {
      this.ɵfac = function SettingPipe_Factory(t) {
        return new (t || SettingPipe)();
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "setting",
        type: SettingPipe,
        pure: false
      });
    }
  }
  return SettingPipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IfSettingDirective = /*#__PURE__*/(() => {
  class IfSettingDirective {
    set capIfSetting(value) {
      this.setting = value;
    }
    get capIfSetting() {
      return this.setting;
    }
    constructor(templateRef, viewContainer, settingService) {
      this.templateRef = templateRef;
      this.viewContainer = viewContainer;
      this.settingService = settingService;
      this.hasView = false;
      this.destroy$ = new Subject();
    }
    ngOnInit() {
      this.changeDisplay();
      this.settingService.settingsChanged$.pipe(takeUntil(this.destroy$)).subscribe(() => this.changeDisplay());
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    /**
     * Toggle the display of the element
     *
     * @return void
     */
    changeDisplay() {
      const display = this.settingService.getValue(this.setting);
      if (display && !this.hasView) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.hasView = true;
      } else if (!display && this.hasView) {
        this.viewContainer.clear();
        this.hasView = false;
      }
    }
    static {
      this.ɵfac = function IfSettingDirective_Factory(t) {
        return new (t || IfSettingDirective)(i0.ɵɵdirectiveInject(i0.TemplateRef), i0.ɵɵdirectiveInject(i0.ViewContainerRef), i0.ɵɵdirectiveInject(SettingService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: IfSettingDirective,
        selectors: [["", "capIfSetting", ""]],
        inputs: {
          capIfSetting: "capIfSetting"
        }
      });
    }
  }
  return IfSettingDirective;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Directive to apply color styling based on given setting
 */
let SettingColorDirective = /*#__PURE__*/(() => {
  class SettingColorDirective {
    constructor(element, settingService) {
      this.element = element;
      this.settingService = settingService;
      this.styleProperty = 'backgroundColor';
      this.destroy$ = new Subject();
    }
    ngAfterViewInit() {
      this.changeStyleAttribute();
      this.settingService.settingsChanged$.pipe(takeUntil(this.destroy$)).subscribe(() => this.changeStyleAttribute());
    }
    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }
    /**
     * Set the given style attribute to the given setting color
     *
     * @return void
     */
    changeStyleAttribute() {
      const settingColor = this.settingService.getValueString(this.emcSettingColor) || '#00999c';
      if (this.childSelector) {
        this.element.nativeElement.querySelector('.ui-dropdown').style[this.styleProperty] = settingColor;
      } else {
        this.element.nativeElement.style[this.styleProperty] = settingColor;
      }
    }
    static {
      this.ɵfac = function SettingColorDirective_Factory(t) {
        return new (t || SettingColorDirective)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(SettingService));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SettingColorDirective,
        selectors: [["", "capSettingColor", ""]],
        inputs: {
          emcSettingColor: "emcSettingColor",
          styleProperty: "styleProperty",
          childSelector: "childSelector"
        }
      });
    }
  }
  return SettingColorDirective;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IndexedDbModule = /*#__PURE__*/(() => {
  class IndexedDbModule {
    static {
      this.ɵfac = function IndexedDbModule_Factory(t) {
        return new (t || IndexedDbModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: IndexedDbModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
    }
  }
  return IndexedDbModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BaseDataKeyService = /*#__PURE__*/(() => {
  class BaseDataKeyService extends ApiService {
    constructor() {
      super(...arguments);
      this.baseDataKeys = [];
      this.endpoint = 'base-data-key';
      this.includes = ['properties', 'values.propertyValues', 'values', 'values.translations'];
    }
    getBaseDataKeyValues(key) {
      return this.getBaseDataKeyByKey(key).pipe(mergeMap(base => this.getBaseDataKeyValuesByLocale(base.id, this.user.locale_id)));
    }
    getBaseDataKeyByKey(key) {
      if (!!this.baseDataKeys.length) {
        return of(this.baseDataKeys.find(item => item.key === key));
      } else {
        return this.index().pipe(map(response => response.data.find(item => item.key === key)), take(1));
      }
    }
    getBaseDataKeyValuesByLocale(id, localeId, options, parents = false, parentValue) {
      let url = id;
      if (options) {
        url += this.getOptionsQuery(options);
      } else {
        const defaultOptions = {
          include: this.includes
        };
        url += this.getOptionsQuery(defaultOptions);
      }
      return this.get(url).pipe(map(response => {
        return response.values && localeId ? this.getMapItems(localeId, response.values, parents, parentValue) : [];
      }));
    }
    extractBaseDataKeys(user) {
      const options = {
        perPage: 99999
      };
      this.index(options).subscribe(response => {
        this.baseDataKeys = response.data;
      });
      if (user) {
        this.user = user;
      }
    }
    getTranslation(localeId, translations) {
      return translations?.find(item => item.locale_id === localeId);
    }
    getBaseMapItem(baseItem, localeId) {
      const translate = this.getTranslation(localeId, baseItem?.translations)?.translation;
      return {
        label: this.getTranslation(localeId, baseItem?.translations) ? translate : baseItem?.value,
        value: baseItem.id,
        key: baseItem.value
      };
    }
    getMapItems(localeId, values, parents, parentValue) {
      let baseList = values;
      if (parents) {
        baseList = values.filter(item => item.parent_id === null);
      } else if (parentValue) {
        baseList = values.filter(item => item.parent_id === parentValue);
      }
      return baseList.map(item => this.getBaseMapItem(item, localeId));
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵBaseDataKeyService_BaseFactory;
        return function BaseDataKeyService_Factory(t) {
          return (ɵBaseDataKeyService_BaseFactory || (ɵBaseDataKeyService_BaseFactory = i0.ɵɵgetInheritedFactory(BaseDataKeyService)))(t || BaseDataKeyService);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BaseDataKeyService,
        factory: BaseDataKeyService.ɵfac
      });
    }
  }
  return BaseDataKeyService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CompleteConfigService = /*#__PURE__*/(() => {
  class CompleteConfigService {
    constructor() {
      this.defaultConfigItems = [{
        titleTranslationKey: 'config.manage.users',
        iconClass: 'fas fa-user',
        routerLink: '/admin/users',
        permission: 'user.manage.tenant'
      }, {
        titleTranslationKey: 'config.manage.companies',
        iconClass: 'fas fa-building',
        routerLink: '/admin/tenants',
        permission: 'tenant.manage'
      }, {
        titleTranslationKey: 'config.manage.translations',
        iconClass: 'fas fa-language',
        routerLink: '/admin/translations',
        permission: 'translation.manage.tenant'
      }, {
        titleTranslationKey: 'config.manage.roles',
        iconClass: 'fas fa-users',
        routerLink: '/admin/roles',
        permission: 'role.manage.tenant'
      }];
      this.defaultAllowedPermissions = ['user.manage.tenant', 'tenant.manage', 'module.manage.tenant', 'translation.manage.tenant', 'role.manage.tenant'];
      this._configOverviewItems = new BehaviorSubject(this.defaultConfigItems);
      this._allowedPermissions = new BehaviorSubject(this.defaultAllowedPermissions);
    }
    getConfigOverviewItems() {
      return this._configOverviewItems.asObservable();
    }
    setAdditionalConfigOverviewItems(configItems) {
      this._configOverviewItems.next([...this.defaultConfigItems, ...configItems]);
    }
    getAllowedPermissions() {
      return this._allowedPermissions.asObservable();
    }
    setAdditionalAllowedPermissions(permissions) {
      this._allowedPermissions.next([...this.defaultAllowedPermissions, ...permissions]);
    }
    static {
      this.ɵfac = function CompleteConfigService_Factory(t) {
        return new (t || CompleteConfigService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CompleteConfigService,
        factory: CompleteConfigService.ɵfac
      });
    }
  }
  return CompleteConfigService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ConfigOverviewComponent = /*#__PURE__*/(() => {
  class ConfigOverviewComponent {
    constructor(router, baseDataKeyService, completeConfigService) {
      this.router = router;
      this.baseDataKeyService = baseDataKeyService;
      this.completeConfigService = completeConfigService;
    }
    ngOnInit() {
      this.getBaseDataKeys();
      this.configItems$ = this.completeConfigService.getConfigOverviewItems();
      this.allowedPermissions$ = this.completeConfigService.getAllowedPermissions();
    }
    onConfigItemClick(configItem) {
      if (configItem.routerLink) {
        this.router.navigate([configItem.routerLink]);
      } else if (configItem.callback) {
        configItem.callback();
      }
    }
    getBaseDataKeys() {
      const options = {
        perPage: 99999
      };
      this.baseDataKeyService.index(options).subscribe(async response => {
        this.baseDataKeys = response.data.map(baseDataKey => {
          const module = ModuleIndexedDbModel.modules.find(moduleModel => moduleModel.id === baseDataKey.module_id);
          if (module) {
            baseDataKey.key = `${module.name}.base-data.${baseDataKey.key.replace(/_/g, '-')}`;
          }
          return baseDataKey;
        });
      });
    }
    static {
      this.ɵfac = function ConfigOverviewComponent_Factory(t) {
        return new (t || ConfigOverviewComponent)(i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(BaseDataKeyService), i0.ɵɵdirectiveInject(CompleteConfigService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ConfigOverviewComponent,
        selectors: [["emc-config-overview"]],
        decls: 5,
        vars: 5,
        consts: [[1, "wrapper", "wrapper-content"], [3, "ngxPermissionsOnly"], ["ngxPermissionsOnly", "base-data-value.manage.tenant"], [1, "row"], [1, "col-12"], [1, "ibox"], [1, "ibox-title"], [1, "ibox-content"], [1, "col-12", "col-sm-6", "col-lg-3", "col-xl-2", "mb-4", "mb-xl-0"], ["routerLink", "/admin/settings", 1, "config-card"], [1, "fas", "fa-sliders-h"], [1, "title"], [1, "row", "mt-3"], [1, "col-lg-12"], [4, "ngFor", "ngForOf"], [1, "col-12", "col-sm-6", "col-lg-3", "col-xl-2", "mb-4"], [1, "config-card", 3, "click"], [1, "config-card", 3, "routerLink"], [1, "fas", "fa-database"]],
        template: function ConfigOverviewComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ConfigOverviewComponent_ng_template_1_Template, 15, 6, "ng-template", 1);
            i0.ɵɵtemplate(2, ConfigOverviewComponent_ng_template_2_Template, 11, 6, "ng-template", 1);
            i0.ɵɵpipe(3, "async");
            i0.ɵɵtemplate(4, ConfigOverviewComponent_ng_template_4_Template, 10, 4, "ng-template", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngxPermissionsOnly", i0.ɵɵpureFunction0(4, _c0));
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngxPermissionsOnly", i0.ɵɵpipeBind1(3, 2, ctx.allowedPermissions$));
          }
        },
        dependencies: [i2.NgxPermissionsDirective, i3.NgForOf, i1$1.RouterLink, i1$2.TranslatePipe, i3.AsyncPipe],
        styles: [".settings-menu-item[_ngcontent-%COMP%]{margin:5px;padding:10px;background-color:#707070;border-color:#515151}.settings-menu-item[_ngcontent-%COMP%]:hover{background-color:#515151}.settings-menu-item[_ngcontent-%COMP%]     .ui-button-icon-left{margin-left:1em}.settings-menu-item[_ngcontent-%COMP%]     .ui-button-text{margin-left:.5em}.config-card[_ngcontent-%COMP%]{width:100%;text-align:center;height:150px;border-radius:5px;box-shadow:0 5px 13px #0000001a;background-color:#fff;color:var(--primary-color);display:flex;justify-content:center;flex-direction:column;cursor:pointer}.config-card.disabled[_ngcontent-%COMP%]{color:#ddd;cursor:not-allowed;pointer-events:none}.config-card[_ngcontent-%COMP%]:hover   [_ngcontent-%COMP%]:not(i){text-decoration:underline}.config-card[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-weight:600;margin-top:10px}.config-card[_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{font-size:25px}.disabled[_ngcontent-%COMP%]{cursor:not-allowed;pointer-events:none}.disabled[_ngcontent-%COMP%]   .config-card[_ngcontent-%COMP%], .disabled[_ngcontent-%COMP%]   .config-card[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{color:#ddd}.ibox[_ngcontent-%COMP%]{padding:20px}h5[_ngcontent-%COMP%]{color:#333;border-bottom:1px solid #ddd;padding-bottom:20px;margin-bottom:20px}"]
      });
    }
  }
  return ConfigOverviewComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * All default complete routes with lazy loaded modules
 */
const routes$1 = [{
  path: 'config',
  component: ConfigOverviewComponent
}];
let CompleteRoutingModule = /*#__PURE__*/(() => {
  class CompleteRoutingModule {
    static {
      this.ɵfac = function CompleteRoutingModule_Factory(t) {
        return new (t || CompleteRoutingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CompleteRoutingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [RouterModule.forChild(routes$1)]
      });
    }
  }
  return CompleteRoutingModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UtilService = /*#__PURE__*/(() => {
  class UtilService {
    constructor(translateService) {
      this.translateService = translateService;
    }
    /**
     * Map array to SelectItem array
     *
     * @param array any[]
     * @param value string
     * @param label string
     * @param translate boolean
     * @param translateProperty string
     * @param translationKeyPrefix string
     * @return array
     */
    mapToSelectItem(array, value, label, translate = false, translateProperty = 'key', translationKeyPrefix = '') {
      return array.map(item => {
        let selectItemLabel = item[label];
        if (translate) {
          selectItemLabel = this.translateService.instant(`${translationKeyPrefix}.${item[translateProperty]}`);
        }
        return {
          value: item[value],
          label: selectItemLabel
        };
      });
    }
    /**
     * Set date in expected format for the sync
     *
     * @param value string|Date
     * @return string
     */
    toDateTime(value) {
      const date = isDate(value) ? value : new Date(value);
      return format(date, 'yyyy-MM-dd HH:mm:ss');
    }
    /**
     * Set date in expected format for (grid) presentation
     *
     * @param value string|Date
     * @return string
     */
    toDateString(value) {
      const date = isDate(value) ? value : new Date(value);
      return format(date, 'dd-MM-yyyy');
    }
    /**
     * Convert an (associative) array to object array
     *
     * @param inputArray any
     * @return any
     */
    convertArrayToObject(inputArray) {
      let objectArray = {};
      if (inputArray && typeof inputArray === 'object') {
        for (const inputArrayItem of Object.keys(inputArray)) {
          objectArray[inputArrayItem] = this.convertArrayToObject(inputArray[inputArrayItem]);
        }
      } else {
        objectArray = inputArray;
      }
      return objectArray;
    }
    static {
      this.ɵfac = function UtilService_Factory(t) {
        return new (t || UtilService)(i0.ɵɵinject(i1$2.TranslateService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UtilService,
        factory: UtilService.ɵfac
      });
    }
  }
  return UtilService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModuleResolver = /*#__PURE__*/(() => {
  class ModuleResolver {
    constructor(moduleService) {
      this.moduleService = moduleService;
    }
    /**
     * Make sure the modules are loaded before accessing the route
     */
    resolve(route, state) {
      return this.moduleService.loadModules();
    }
    static {
      this.ɵfac = function ModuleResolver_Factory(t) {
        return new (t || ModuleResolver)(i0.ɵɵinject(ModuleService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ModuleResolver,
        factory: ModuleResolver.ɵfac
      });
    }
  }
  return ModuleResolver;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TenantFormComponent = /*#__PURE__*/(() => {
  class TenantFormComponent extends CompleteBaseForm {
    constructor(translateService, utilService, changeDetectorRef, moduleService) {
      super(changeDetectorRef);
      this.translateService = translateService;
      this.utilService = utilService;
      this.changeDetectorRef = changeDetectorRef;
      this.moduleService = moduleService;
    }
    ngAfterViewInit() {
      this.listenToFormChanges();
      this.fields = [{
        key: 'name',
        type: 'input',
        props: {
          translateLabel: this.translateService.stream('tenant.name'),
          required: true
        }
      }, {
        key: 'modules',
        type: 'multiSelect',
        props: {
          options: this.moduleService.getModuleList().pipe(map(response => this.utilService.mapToSelectItem(response, 'key', 'label'))),
          filter: true,
          styleClass: 'w-100',
          defaultLabel: this.translateService.instant('placeholder.select'),
          translateLabel: this.translateService.stream('tenant.modules'),
          translatePlaceholder: this.translateService.stream('placeholder.select'),
          required: false,
          appendTo: 'body'
        }
      }];
      this.updateFormValue();
      this.changeDetectorRef.detectChanges();
    }
    static {
      this.ɵfac = function TenantFormComponent_Factory(t) {
        return new (t || TenantFormComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(UtilService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(ModuleService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TenantFormComponent,
        selectors: [["emc-tenant-form"]],
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => TenantFormComponent),
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: forwardRef(() => TenantFormComponent),
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 2,
        consts: [[3, "form", "fields"]],
        template: function TenantFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "formly-form", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("form", ctx.form)("fields", ctx.fields);
          }
        },
        dependencies: [i4$1.FormlyForm],
        styles: ["[_nghost-%COMP%]     cap-validator{display:none}"],
        changeDetection: 0
      });
    }
  }
  return TenantFormComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TenantModule = /*#__PURE__*/(() => {
  class TenantModule {
    static {
      this.ɵfac = function TenantModule_Factory(t) {
        return new (t || TenantModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TenantModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, SharedModule, RouterModule, FormsModule, FormModule, ReactiveFormsModule]
      });
    }
  }
  return TenantModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class BaseDataValueIndexedDbModel extends IndexedDbModel {
  /**
   * Get the base-data-values by base-data-key
   *
   * @param key
   *
   * @return list of base-data-values
   */
  static getByBaseDataKey(key) {
    return BaseDataValueIndexedDbModel.query().where({
      base_data_key: key
    }).toArray();
  }
  /**
   * Return base data into Select items by key
   *
   * @param key
   */
  static async getBaseDataList(key) {
    const values = await BaseDataValueIndexedDbModel.getByBaseDataKey(key);
    return values.map(value => {
      return {
        label: value.id,
        value: value.id
      };
    });
  }
  // Constructor
  constructor(attributes) {
    super(attributes);
    // Configuration
    this.entity = 'base-data-value';
    this.table = 'base_data_value';
    this.schema = '++id, base_data_key, parent_id, value';
    this.sync = true;
  }
}
let BaseDataFormComponent = /*#__PURE__*/(() => {
  class BaseDataFormComponent {
    constructor(utilService, translateService) {
      this.utilService = utilService;
      this.translateService = translateService;
      this.updateObject = {};
      this.modelChange = new EventEmitter();
      this.formGroup = new FormGroup({});
    }
    async ngOnInit() {
      await this.initForm();
      this.updateForm();
    }
    /**
     * Create the fields for the formly-fom
     */
    async initForm() {
      const field = {
        key: 'base_data_values',
        fieldGroup: []
      };
      for (const mainBaseDataKey of this.mainBaseDataKeys) {
        this.baseDataValues = await BaseDataValueIndexedDbModel.getByBaseDataKey(mainBaseDataKey);
        const inventoryItemTypes = this.utilService.mapToSelectItem(this.baseDataValues.filter(value => !value.parent_id), 'id', 'id', true, 'id', 'base-data');
        field.fieldGroup.push({
          type: 'dropdown',
          key: mainBaseDataKey.replace('.', '-'),
          props: {
            options: inventoryItemTypes,
            appendTo: 'body',
            required: true,
            label: this.translateService.instant(mainBaseDataKey),
            placeholder: 'select',
            change: (dropdownField, event) => {
              this.onDropdownChange(event.value);
            }
          }
        });
      }
      this.fields = [field, ...this.additionalFields];
      return;
    }
    /**
     * Add or remove fields based on the selected option
     */
    onDropdownChange(value) {
      this.removeAllChildrenFields(value);
      this.createCompleteFields(value);
      this.modelChange.emit(this.model);
    }
    /**
     * Update the form with given this.model uuid's
     */
    async updateForm() {
      if (!this.model.length) {
        return;
      }
      await this.getNestedValues(this.model);
      if (this.formGroup.get('base_data_values')) {
        this.formGroup.get('base_data_values').patchValue(this.updateObject);
      }
      this.updateObject = {};
      return;
    }
    /**
     * Recursively retrieve all the baseDataValues given in this.model
     * 1. Retrieve all values
     * 2. Put them in our this.updateObject
     * 3. Update our form
     * 4. Generate fields for all values
     */
    async getNestedValues(values) {
      const nested = [];
      for (const value of values) {
        const baseDataRecord = await BaseDataValueIndexedDbModel.query().get(value);
        let key = baseDataRecord.base_data_key.replace('.', '-');
        if (baseDataRecord.parent_id) {
          key = baseDataRecord.parent_id;
          nested.push(key);
        }
        if (!this.updateObject[key]) {
          this.updateObject[key] = value;
          if (!baseDataRecord.parent_id) {
            await this.generateNestedFields(value);
          }
        }
      }
      if (nested.length > 0) {
        await this.getNestedValues(nested);
      }
    }
    /**
     * Recursively retrieve all the nested fields:
     * 1. Start at the top level, the baseDataValue without a parent_id
     * 2. Recursively search for the dropdown children of the top level value
     * 3. Create fields for each found child
     */
    async generateNestedFields(value) {
      const selectedValue = this.baseDataValues.find(baseDataValue => baseDataValue.id === value);
      const fieldOptions = this.baseDataValues.filter(baseDataValue => baseDataValue.parent_id === selectedValue.id);
      for (const option of fieldOptions) {
        // Get the direct child of the field option
        const directChildren = this.baseDataValues.filter(baseDataValue => baseDataValue.parent_id === option.id);
        if (directChildren.length > 0) {
          this.createCompleteFields(value);
          for (const child of directChildren) {
            this.generateNestedFields(child.id);
          }
        }
      }
    }
    /**
     * Creates fields based on given baseDataValue and their children (options)
     */
    async createCompleteFields(value) {
      // Check if the options has children
      const childValues = this.baseDataValues.filter(baseDataValue => baseDataValue.parent_id === value);
      if (childValues) {
        // Create a formly field for every child
        for (const childValue of childValues) {
          const childOptions = this.baseDataValues.filter(baseDataValue => baseDataValue.parent_id === childValue.id);
          if (childOptions && childOptions.length > 0) {
            this.addField(childValue.id, childOptions);
          }
        }
      }
    }
    /**
     * Add dropdown for given ID
     */
    addField(childvalueId, childOptions) {
      const field = {
        type: 'dropdown',
        key: childvalueId,
        props: {
          options: this.utilService.mapToSelectItem(childOptions, 'id', 'id', true, 'id', 'base-data'),
          label: this.translateService.instant(`base-data.${childvalueId}`),
          placeholder: this.translateService.instant('placeholder.select'),
          appendTo: 'body',
          required: true,
          change: (dropdownField, event) => {
            this.onDropdownChange(event.value);
          }
        }
      };
      const baseDataField = this.fields.find(formField => formField.key === 'base_data_values');
      baseDataField.fieldGroup = [...baseDataField.fieldGroup, field];
      // Add the field to the formly fields
      this.fields = this.fields.map(formField => {
        if (formField.key === 'base_data_values') {
          return baseDataField;
        }
        return formField;
      });
    }
    /**
     * Remove all child fields
     */
    removeAllChildrenFields(id) {
      // Get the selected value
      const selectedValue = this.baseDataValues.find(baseDataValue => baseDataValue.id === id);
      // Get all the options of the parent of the selected value
      const fieldOptions = this.baseDataValues.filter(baseDataValue => baseDataValue.id === selectedValue.parent_id);
      let baseDataFields = this.fields.find(formField => formField.key === 'base_data_values').fieldGroup;
      if (fieldOptions.length > 0) {
        for (const option of fieldOptions) {
          // Get the direct child of the field option
          const directChildren = this.baseDataValues.filter(baseDataValue => baseDataValue.parent_id === option.id);
          if (directChildren.length > 0) {
            for (const child of directChildren) {
              if (this.model.base_data_values.hasOwnProperty(child.id)) {
                this.model.base_data_values[child.id] = null;
              }
              // Remove the field belonging to the directChild
              baseDataFields = baseDataFields.filter(field => field.key !== child.id);
              const childOptions = this.baseDataValues.filter(baseDataValue => baseDataValue.parent_id === child.id);
              // Set the updates fieldGroup
              this.fields = this.fields.map(formField => {
                if (formField.key === 'base_data_values') {
                  formField.fieldGroup = baseDataFields;
                }
                return formField;
              });
              // Remove any other children
              for (const childValue of childOptions) {
                this.removeAllChildrenFields(childValue.id);
              }
            }
          }
        }
      }
    }
    static {
      this.ɵfac = function BaseDataFormComponent_Factory(t) {
        return new (t || BaseDataFormComponent)(i0.ɵɵdirectiveInject(UtilService), i0.ɵɵdirectiveInject(i1$2.TranslateService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BaseDataFormComponent,
        selectors: [["emc-base-data-form"]],
        inputs: {
          mainBaseDataKeys: "mainBaseDataKeys",
          model: "model",
          additionalFields: "additionalFields"
        },
        outputs: {
          modelChange: "modelChange"
        },
        decls: 2,
        vars: 4,
        consts: [["id", "form-base-data", 3, "formGroup"], [3, "fields", "form", "model"]],
        template: function BaseDataFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "form", 0);
            i0.ɵɵelement(1, "formly-form", 1);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("formGroup", ctx.formGroup);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("fields", ctx.fields)("form", ctx.formGroup)("model", ctx.model);
          }
        },
        dependencies: [i2$2.ɵNgNoValidate, i2$2.NgControlStatusGroup, i2$2.FormGroupDirective, i4$1.FormlyForm],
        encapsulation: 2
      });
    }
  }
  return BaseDataFormComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BaseDataValueFormComponent = /*#__PURE__*/(() => {
  class BaseDataValueFormComponent extends CompleteBaseForm {
    get locales() {
      return this._locales;
    }
    set locales(value) {
      this._locales = value;
    }
    constructor(changeDetectorRef, translateService) {
      super(changeDetectorRef);
      this.changeDetectorRef = changeDetectorRef;
      this.translateService = translateService;
      this.updateValue$ = new BehaviorSubject({});
      this.formModel = {};
    }
    ngAfterViewInit() {
      this.listenToFormChanges();
      this.changeDetectorRef.detectChanges();
    }
    ngOnChanges(changes) {
      if (this.locales && this.baseDataAttributes && this.parentOptions && !this.fields) {
        this.populateFormlyFieldsConfigs();
      }
    }
    writeValue(value) {
      this.formModel = value;
    }
    /**
     * Set formly fields
     */
    populateFormlyFieldsConfigs() {
      this.fields = [{
        key: 'value',
        type: 'input',
        props: {
          translateLabel: this.translateService.stream('base-data-form.value'),
          required: true,
          disabled: !this.isEditable
        }
      }, {
        key: 'parent_id',
        type: 'dropdown',
        props: {
          translateLabel: this.translateService.stream('base-data-form.parent'),
          translatePlaceholder: this.translateService.stream('placeholder.select'),
          disabled: !this.isEditable,
          options: this.parentOptions
        }
      }, ...this._locales.map(locale => {
        return {
          key: `translations.${locale.id}`,
          type: 'input',
          props: {
            translateLabel: locale.name,
            required: true
          }
        };
      })];
      if (this.baseDataAttributes && this.baseDataAttributes.length > 0) {
        this.fields = [...this.fields, {
          template: `<hr><p><b>${this.translateService.instant('base-data-form.attributes.label')}</b></p>`
        }, ...this.baseDataAttributes.map(attr => {
          let type = 'input';
          switch (attr[attr.key]) {
            case 'boolean':
              type = 'inputSwitch';
              break;
          }
          return {
            key: `attributes.${attr.key}`,
            type: type,
            props: {
              translateLabel: of(attr.key)
            }
          };
        })];
      }
    }
    static {
      this.ɵfac = function BaseDataValueFormComponent_Factory(t) {
        return new (t || BaseDataValueFormComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1$2.TranslateService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: BaseDataValueFormComponent,
        selectors: [["emc-base-data-value-form"]],
        inputs: {
          locales: "locales",
          isEditable: "isEditable",
          parentOptions: "parentOptions",
          baseDataAttributes: "baseDataAttributes"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => BaseDataValueFormComponent),
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: forwardRef(() => BaseDataValueFormComponent),
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        decls: 1,
        vars: 3,
        consts: [[3, "form", "model", "fields"]],
        template: function BaseDataValueFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "formly-form", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("form", ctx.form)("model", ctx.formModel)("fields", ctx.fields);
          }
        },
        dependencies: [i4$1.FormlyForm],
        styles: ["[_nghost-%COMP%]     cap-validator{display:none}"],
        changeDetection: 0
      });
    }
  }
  return BaseDataValueFormComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BaseDataTranslationPipe = /*#__PURE__*/(() => {
  class BaseDataTranslationPipe {
    constructor(translateService) {
      this.translateService = translateService;
    }
    /**
     * Append the "base-data" prefix to the translation key and translate it
     *
     * @param baseDataValueId: string
     * @returns string
     */
    transform(baseDataValueId) {
      return this.translateService.instant(`base-data.${baseDataValueId}`);
    }
    static {
      this.ɵfac = function BaseDataTranslationPipe_Factory(t) {
        return new (t || BaseDataTranslationPipe)(i0.ɵɵdirectiveInject(i1$2.TranslateService, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "capBaseDataTranslation",
        type: BaseDataTranslationPipe,
        pure: true
      });
    }
  }
  return BaseDataTranslationPipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BaseDataModule = /*#__PURE__*/(() => {
  class BaseDataModule {
    static {
      this.ɵfac = function BaseDataModule_Factory(t) {
        return new (t || BaseDataModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: BaseDataModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, SharedModule, RouterModule, ProgressSpinnerModule]
      });
    }
  }
  return BaseDataModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RoleFormComponent = /*#__PURE__*/(() => {
  class RoleFormComponent extends CompleteBaseForm {
    constructor(changeDetectorRef, utilService, translateService, permissionService) {
      super(changeDetectorRef);
      this.changeDetectorRef = changeDetectorRef;
      this.utilService = utilService;
      this.translateService = translateService;
      this.permissionService = permissionService;
    }
    ngAfterViewInit() {
      this.listenToFormChanges();
      this.fields = [{
        key: 'name',
        type: 'input',
        props: {
          translateLabel: this.translateService.stream('role.overview.name'),
          required: true
        }
      }, {
        key: 'key',
        type: 'input',
        props: {
          translateLabel: this.translateService.stream('role.overview.key'),
          required: true
        }
      }, {
        key: 'permissions',
        type: 'multiSelect',
        props: {
          options: this.permissionService.getPermissionsOfCurrentTenant().pipe(map(permissions => this.utilService.mapToSelectItem(permissions, 'id', 'name'))),
          styleClass: 'w-100',
          filter: true,
          defaultLabel: this.translateService.instant('placeholder.select'),
          translateLabel: this.translateService.stream('role.detail.select_permissions'),
          translatePlaceholder: this.translateService.instant('placeholder.select'),
          required: true
        }
      }];
      this.changeDetectorRef.detectChanges();
      this.updateFormValue();
    }
    static {
      this.ɵfac = function RoleFormComponent_Factory(t) {
        return new (t || RoleFormComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(UtilService), i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(PermissionService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: RoleFormComponent,
        selectors: [["emc-role-form"]],
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => RoleFormComponent),
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: forwardRef(() => RoleFormComponent),
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 2,
        consts: [[3, "fields", "form"]],
        template: function RoleFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "formly-form", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("fields", ctx.fields)("form", ctx.form);
          }
        },
        dependencies: [i4$1.FormlyForm],
        styles: ["[_nghost-%COMP%]     cap-validator{display:none}"],
        changeDetection: 0
      });
    }
  }
  return RoleFormComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let RoleModule = /*#__PURE__*/(() => {
  class RoleModule {
    static {
      this.ɵfac = function RoleModule_Factory(t) {
        return new (t || RoleModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: RoleModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule, SharedModule, RouterModule]
      });
    }
  }
  return RoleModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const uuid$1 = v4;
let TranslationFormComponent = /*#__PURE__*/(() => {
  class TranslationFormComponent extends CompleteBaseForm {
    constructor(translateService, utilService, changeDetectorRef) {
      super(changeDetectorRef);
      this.translateService = translateService;
      this.utilService = utilService;
      this.changeDetectorRef = changeDetectorRef;
    }
    ngOnInit() {
      this.listenToFormChanges();
    }
    ngOnChanges(changes) {
      if (this.model) {
        this.setFields(changes.locales.currentValue, this.model);
      }
    }
    setFields(locales, model) {
      this.fields = [{
        key: 'key',
        type: 'input',
        props: {
          translateLabel: this.translateService.stream('translation.overview.label'),
          disabled: true
        }
      }];
      if (locales) {
        locales.forEach(locale => {
          let index = model.translations.findIndex(translation => translation.locale_id === locale.id);
          // Add new translation if not exists yet
          if (index === -1) {
            const newTranslation = {
              id: uuid$1(),
              locale_id: locale.id,
              translation_key_id: this.model.id,
              translation: ''
            };
            model.translations.push(newTranslation);
            index = model.translations.findIndex(translation => translation.locale_id === locale.id);
          }
          // Add input for translation
          const field = {
            key: `translations.${index}.translation`,
            type: 'input',
            props: {
              translateLabel: locale.name,
              required: true
            }
          };
          this.fields.push(field);
        });
      }
      this.changeDetectorRef.detectChanges();
      this.updateFormValue();
    }
    static {
      this.ɵfac = function TranslationFormComponent_Factory(t) {
        return new (t || TranslationFormComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(UtilService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: TranslationFormComponent,
        selectors: [["emc-translation-form"]],
        inputs: {
          locales: "locales",
          model: "model"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => TranslationFormComponent),
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: forwardRef(() => TranslationFormComponent),
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        decls: 1,
        vars: 3,
        consts: [[3, "fields", "form", "model"]],
        template: function TranslationFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "formly-form", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("fields", ctx.fields)("form", ctx.form)("model", ctx.model);
          }
        },
        dependencies: [i4$1.FormlyForm],
        styles: ["[_nghost-%COMP%]     cap-validator{display:none}"],
        changeDetection: 0
      });
    }
  }
  return TranslationFormComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const EDIT_TRANSLATION_MODE_KEY = 'editTranslationMode';
let LocaleService = /*#__PURE__*/(() => {
  class LocaleService extends ApiService {
    constructor() {
      super(...arguments);
      this.endpoint = 'tenant/locale';
    }
    /**
     * Get the currently set language
     */
    static getCurrentLocaleCode() {
      const localeId = localStorage.getItem('currentLocaleCode');
      return localeId ? localeId : JSON.parse(localStorage.getItem('user')).locale_id;
    }
    /**
     * Set the current used locale id
     *
     * @param localeId
     */
    static setCurrentLocaleCode(localeId) {
      localStorage.setItem('currentLocaleCode', localeId);
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵLocaleService_BaseFactory;
        return function LocaleService_Factory(t) {
          return (ɵLocaleService_BaseFactory || (ɵLocaleService_BaseFactory = i0.ɵɵgetInheritedFactory(LocaleService)))(t || LocaleService);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: LocaleService,
        factory: LocaleService.ɵfac
      });
    }
  }
  return LocaleService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LocaleModule = /*#__PURE__*/(() => {
  class LocaleModule {
    static {
      this.ɵfac = function LocaleModule_Factory(t) {
        return new (t || LocaleModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: LocaleModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule]
      });
    }
  }
  return LocaleModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TranslationKeyService = /*#__PURE__*/(() => {
  class TranslationKeyService extends ApiService {
    constructor(apiHttp, authService) {
      super(apiHttp);
      this.apiHttp = apiHttp;
      this.authService = authService;
      this.endpoint = 'translation-key';
    }
    index(options) {
      let search = options.search;
      const globalFilter = options.filters.find(filter => {
        return filter.field === 'global';
      });
      if (globalFilter && !options.search) {
        search = globalFilter.value;
      }
      return super.index({
        ...options,
        search
      });
    }
    export() {
      return this.apiHttp.getBlob(`/translation/export`, '');
    }
    import(file) {
      let headers = new HttpHeaders();
      headers = headers.append('Authorization', 'Bearer ' + this.authService.getToken());
      headers.delete('Content-Length');
      const data = new FormData();
      data.append('file', file);
      return this.apiHttp.post(`/translation/import`, data, {
        headers
      });
    }
    getTranslationIdByKey(options) {
      const url = `/${this.endpoint}${this.getOptionsQuery(options)}`;
      return this.apiHttp.get(url);
    }
    static {
      this.ɵfac = function TranslationKeyService_Factory(t) {
        return new (t || TranslationKeyService)(i0.ɵɵinject(i1.ApiHttpService), i0.ɵɵinject(i2$1.AuthService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TranslationKeyService,
        factory: TranslationKeyService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return TranslationKeyService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EditTranslationDialogComponent = /*#__PURE__*/(() => {
  class EditTranslationDialogComponent extends BaseDetailComponent {
    constructor(injector, translateService, localeService, formBuilder, authService, config, apiService, route, dialogRef) {
      super(injector, translateService);
      this.injector = injector;
      this.translateService = translateService;
      this.localeService = localeService;
      this.formBuilder = formBuilder;
      this.authService = authService;
      this.config = config;
      this.apiService = apiService;
      this.route = route;
      this.dialogRef = dialogRef;
      this.locales$ = this.localeService.index().pipe(map$1(response => {
        return response.data;
      }), shareReplay(1));
      this.saveMessage = this.translateService.instant('translation.detail-saved.message');
      this.modelTranslation = this.translateService.instant('translation.detail.title');
      this.model = {};
      this.includes = ['translations'];
      this.loading = true;
      this.fields = [{
        key: 'key',
        type: 'input',
        props: {
          translateLabel: this.translateService.stream('translation.overview.label'),
          disabled: true
        }
      }];
      this.getResourceCallback = resourceResponse => {
        this.model = resourceResponse;
        // Add inputs for each locale
        this.locales$.pipe(take$1(1)).subscribe(locales => {
          locales.forEach(locale => {
            let index = this.model.translations.findIndex(translation => {
              return translation.locale_id === locale.id;
            });
            // Add new translation if not exists yet
            if (index === -1) {
              const newTranslation = {
                id: null,
                locale_id: locale.id,
                translation_key_id: this.model.id,
                translation: ''
              };
              this.model.translations.push(newTranslation);
            }
          });
          this.loading = false;
        });
        return this.model;
      };
    }
    ngOnInit() {
      this.formGroup = new FormGroup({});
      this.isEdit = true;
      this.model[this.idField] = this.config?.data?.id;
      this.getResource(this.config?.data?.id);
      this.formGroup = this.formBuilder.group({
        translation: []
      });
    }
    onCancel() {
      this.submitting = false;
      const currentLangTranslation = this.model?.translations?.find(translation => {
        return translation?.locale_id === this.authService.getUser()?.locale_id;
      })?.translation;
      this.dialogRef.close(currentLangTranslation);
    }
    static {
      this.ɵfac = function EditTranslationDialogComponent_Factory(t) {
        return new (t || EditTranslationDialogComponent)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(LocaleService), i0.ɵɵdirectiveInject(i2$2.UntypedFormBuilder), i0.ɵɵdirectiveInject(i2$1.AuthService), i0.ɵɵdirectiveInject(i5.DynamicDialogConfig), i0.ɵɵdirectiveInject(TranslationKeyService), i0.ɵɵdirectiveInject(i1$1.ActivatedRoute), i0.ɵɵdirectiveInject(i5.DynamicDialogRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EditTranslationDialogComponent,
        selectors: [["emc-edit-translation-dialog"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 11,
        vars: 16,
        consts: [[1, "page__content"], [1, "row"], [1, "col-12", "col-lg-6", "col-xl-4"], [3, "formGroup", "ngSubmit", 4, "ngIf"], [1, "separator"], ["styleClass", "secondary", 1, "d-flex", "mt-3", 3, "ngClass", "label", "icon", "onClick"], [3, "formGroup", "ngSubmit"], ["formControlName", "translation", 3, "locales", "model"]],
        template: function EditTranslationDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2);
            i0.ɵɵtemplate(3, EditTranslationDialogComponent_form_3_Template, 3, 5, "form", 3);
            i0.ɵɵelementEnd()()();
            i0.ɵɵelement(4, "div", 4);
            i0.ɵɵelementStart(5, "cap-button", 5);
            i0.ɵɵlistener("onClick", function EditTranslationDialogComponent_Template_cap_button_onClick_5_listener() {
              return ctx.submit();
            });
            i0.ɵɵpipe(6, "async");
            i0.ɵɵpipe(7, "observablePipe");
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵpipe(9, "async");
            i0.ɵɵpipe(10, "observablePipe");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", !ctx.loading);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c1, i0.ɵɵpipeBind1(6, 4, i0.ɵɵpipeBind1(7, 6, ctx.submitting))))("label", i0.ɵɵpipeBind1(8, 8, "button.submit"))("icon", i0.ɵɵpipeBind1(9, 10, i0.ɵɵpipeBind1(10, 12, ctx.submitting)) ? "fas fa-spinner fa-pulse" : "fas fa-check");
          }
        },
        dependencies: [i3.NgClass, i3.NgIf, i4.CapturumButtonComponent, i2$2.ɵNgNoValidate, i2$2.NgControlStatus, i2$2.NgControlStatusGroup, i2$2.FormGroupDirective, i2$2.FormControlName, TranslationFormComponent, i3.AsyncPipe, i1$2.TranslatePipe, i4$2.ObservablePipe],
        styles: ["[_ngcontent-%COMP%]:root{--cap-input-height: 30px;--cap-dynamic-filter-input-height: 30px;--cap-dynamic-filter-border-radius: 5px;--cap-dynamic-filter-border-width: 1px;--cap-dynamic-filters-hide-filters-on-mobile: false;--cap-dynamic-filters-filter-flex: 1;--cap-dynamic-filters-flex-wrap: wrap;--cap-dynamic-filter-width: 200px;--cap-dynamic-filter-label-font-size: 14px;--cap-dynamic-filter-label-font-weight: 600;--cap-dynamic-filter-label-font-family: \"Source Sans Pro\";--cap-dynamic-filter-label-font-color: #5f6062;--cap-dynamic-filter-placeholder-font-weight: 600;--cap-dynamic-filter-placeholder-font-color: #5f6062;--cap-dynamic-filter-icon-opacity: 1;--cap-dynamic-filter-icon-color: var(--cap-primary-color)}cap-button.submitting[_ngcontent-%COMP%]{pointer-events:none;opacity:.5}.separator[_ngcontent-%COMP%]{width:100%;border-top:1px solid #ddd}"]
      });
    }
  }
  return EditTranslationDialogComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let EditTranslationsTogglerComponent = /*#__PURE__*/(() => {
  class EditTranslationsTogglerComponent {
    constructor(translateService, translationKeyService, dialogService, localStorageService, cdr, renderer2) {
      this.translateService = translateService;
      this.translationKeyService = translationKeyService;
      this.dialogService = dialogService;
      this.localStorageService = localStorageService;
      this.cdr = cdr;
      this.renderer2 = renderer2;
      this.editMode = false;
      this.loading$ = new Subject();
      this.moduleNames = [];
      this.translationClicked$ = new BehaviorSubject(false);
    }
    onBeforeUnload() {
      if (this.editMode) {
        this.translationClicked$.next(false);
        this.clickUnlistener();
      }
    }
    toggleEditMode(isChecked) {
      if (isChecked) {
        this.loading$.next(true);
        this.editMode = true;
        this.localStorageService.setItem(EDIT_TRANSLATION_MODE_KEY, true);
        // Enforce reloading the same language
        const currentLanguage = this.translateService.currentLang;
        this.translateService.currentLang = undefined;
        this.translateService.use(currentLanguage).subscribe(translations => {
          this.setModulesNames(translations);
          setTimeout(() => {
            const rootElement = document.getElementsByTagName('app-root')[0];
            const dialogElement = document.getElementsByTagName('p-dynamicdialog')[0];
            if (dialogElement) {
              this.replaceTranslationsWithLink(dialogElement);
            }
            this.replaceTranslationsWithLink(rootElement);
            this.localStorageService.setItem(EDIT_TRANSLATION_MODE_KEY, false);
            this.clickUnlistener = this.renderer2.listen('document', 'click', event => {
              this.openModal(event);
            });
          }, 10);
          this.loading$.next(false);
          this.cdr.detectChanges();
        });
      }
    }
    openModal({
      target
    }) {
      // if the user clicks on the input switch, reload the page
      if (target.tagName === 'P-INPUTSWITCH') {
        target.getElementsByClassName('p-inputswitch-checked')[0].classList.remove('p-inputswitch-checked');
        this.reloadPage();
        return;
      }
      if (this.translationClicked$.getValue()) {
        return;
      }
      const moduleName = target?.attributes?.['module-name']?.value;
      const key = target?.attributes?.['key']?.value;
      if (!key) {
        return;
      }
      const options = {
        filters: [{
          field: 'key',
          value: key,
          operator: FilterMatchMode.EQUALS
        }]
      };
      if (moduleName) {
        options.filters.push({
          field: 'module.key',
          value: moduleName,
          operator: FilterMatchMode.EQUALS
        });
      }
      this.translationClicked$.next(true);
      this.translationKeyService.getTranslationIdByKey(options).subscribe(({
        data
      }) => {
        if (!data?.length) {
          this.translationClicked$.next(false);
          return;
        }
        this.dialogRef = this.dialogService.open(EditTranslationDialogComponent, {
          header: `${moduleName ? `${moduleName}.` : ''}${key}`,
          data: {
            id: data[0].id
          }
        });
        this.dialogRef?.onClose?.pipe(take$1(1), tap$1(() => {
          this.translationClicked$.next(false);
          this.dialogRef = null;
        }), filter(Boolean)).subscribe(newValue => {
          if (target['innerHTML']) {
            target['innerHTML'] = newValue;
          }
        });
      });
    }
    replaceTranslationsWithLink(element) {
      if (!element?.innerHTML) {
        return;
      }
      // Pattern is looking for: !@![demooij.button.add]-[Add]!@!
      // Where: !@![translation key]-[translation value]!@!
      // ([^="]) is looking for any character except =", to not replace the pattern
      // in attributes
      const translationPattern = /([^="])!@!\[([^<>\]\[]+)\]-\[(.*?)\]\!@!/g;
      element.innerHTML = element.innerHTML.replace(translationPattern, (_match, ...args) => {
        const firstElement = args[0];
        const translationKeyArray = args[1]?.split('.');
        const translationValue = args[2];
        // In the key 'demooij.entity.sales-order.singular',
        // 'demooij' is the moduleName, and 'entity.sales-order.singular' is the key
        // *****
        // If there is no module name, send just key.
        const moduleName = this.moduleNames.includes(translationKeyArray[0]) ? translationKeyArray[0] : '';
        const key = moduleName ? translationKeyArray.slice(1, translationKeyArray.length).join('.') : translationKeyArray.join('.');
        return `${firstElement}<span class="translation-link" editable-translation="true" module-name="${moduleName}" key="${key}">${translationValue}</span>`;
      });
    }
    setModulesNames(translations) {
      if (!translations) {
        return;
      }
      Object.entries(translations).forEach(([key, value]) => {
        if (typeof value !== 'string') {
          this.moduleNames.push(key);
        }
      });
    }
    reloadPage() {
      location.reload();
    }
    static {
      this.ɵfac = function EditTranslationsTogglerComponent_Factory(t) {
        return new (t || EditTranslationsTogglerComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(TranslationKeyService), i0.ɵɵdirectiveInject(i5.DialogService), i0.ɵɵdirectiveInject(i4$2.LocalStorageService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: EditTranslationsTogglerComponent,
        selectors: [["app-edit-translations-toggler"]],
        hostBindings: function EditTranslationsTogglerComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("beforeunload", function EditTranslationsTogglerComponent_beforeunload_HostBindingHandler($event) {
              return ctx.onBeforeUnload($event);
            }, false, i0.ɵɵresolveWindow);
          }
        },
        decls: 6,
        vars: 8,
        consts: [[1, "translation-toggler"], [1, "d-flex", "flex-column", "w-100"], [1, "d-flex", "w-100", 3, "ngModel", "disabled", "label", "ngModelChange", "change"], [4, "ngIf"]],
        template: function EditTranslationsTogglerComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "cap-input-switch", 2);
            i0.ɵɵlistener("ngModelChange", function EditTranslationsTogglerComponent_Template_cap_input_switch_ngModelChange_2_listener($event) {
              return ctx.editMode = $event;
            })("change", function EditTranslationsTogglerComponent_Template_cap_input_switch_change_2_listener($event) {
              return ctx.toggleEditMode($event.checked);
            });
            i0.ɵɵpipe(3, "translate");
            i0.ɵɵelementEnd()()();
            i0.ɵɵtemplate(4, EditTranslationsTogglerComponent_cap_loader_4_Template, 1, 0, "cap-loader", 3);
            i0.ɵɵpipe(5, "async");
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngModel", ctx.editMode)("disabled", ctx.editMode)("label", i0.ɵɵpipeBind1(3, 4, "translation.edit.label"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(5, 6, ctx.loading$));
          }
        },
        dependencies: [i3.NgIf, i6$1.CapturumInputSwitchComponent, i2$2.NgControlStatus, i2$2.NgModel, i5$1.LoaderComponent, i3.AsyncPipe, i1$2.TranslatePipe],
        styles: [":root{--cap-input-height: 30px;--cap-dynamic-filter-input-height: 30px;--cap-dynamic-filter-border-radius: 5px;--cap-dynamic-filter-border-width: 1px;--cap-dynamic-filters-hide-filters-on-mobile: false;--cap-dynamic-filters-filter-flex: 1;--cap-dynamic-filters-flex-wrap: wrap;--cap-dynamic-filter-width: 200px;--cap-dynamic-filter-label-font-size: 14px;--cap-dynamic-filter-label-font-weight: 600;--cap-dynamic-filter-label-font-family: \"Source Sans Pro\";--cap-dynamic-filter-label-font-color: #5f6062;--cap-dynamic-filter-placeholder-font-weight: 600;--cap-dynamic-filter-placeholder-font-color: #5f6062;--cap-dynamic-filter-icon-opacity: 1;--cap-dynamic-filter-icon-color: var(--cap-primary-color)}app-edit-translations-toggler{width:200px;display:flex;background:#fff;padding:20px;border-radius:20px;position:absolute;z-index:99999;top:20px;left:20px;box-shadow:#959da533 0 8px 24px}app-edit-translations-toggler .translation-toggler cap-input-switch .form-element{width:100%;display:flex}app-edit-translations-toggler .translation-toggler .info-message{font-style:italic;font-size:12px}app-edit-translations-toggler .translation-toggler .disabled{pointer-events:none;opacity:.4}app-edit-translations-toggler span.translation-link{cursor:pointer;font-weight:700;text-decoration:underline}app-edit-translations-toggler .overlay{position:absolute;z-index:9999;width:100vw;height:100vh;background-color:#fff;pointer-events:none}.translation-link{text-decoration:underline;font-weight:700}.translation-link:hover{cursor:pointer}\n"],
        encapsulation: 2
      });
    }
  }
  return EditTranslationsTogglerComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TranslationModule = /*#__PURE__*/(() => {
  class TranslationModule {
    static {
      this.ɵfac = function TranslationModule_Factory(t) {
        return new (t || TranslationModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: TranslationModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, CapturumButtonModule, CapturumInputSwitchModule, SharedModule, FormsModule, ReactiveFormsModule, RouterModule]
      });
    }
  }
  return TranslationModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AuthSmsComponent = /*#__PURE__*/(() => {
  class AuthSmsComponent {
    constructor(formBuilder, authService) {
      this.formBuilder = formBuilder;
      this.authService = authService;
      this.method = TwoFactorMethod.sms;
      this.smsCodeEvent = new EventEmitter();
    }
    ngOnInit() {
      this.smsForm = this.formBuilder.group({
        phoneNumber: [null, [Validators.required, Validators.pattern('^[0-9]*$')]]
      });
      this.authService.setupSms().subscribe(response => {
        if (response?.identifier) {
          this.smsForm.patchValue({
            phoneNumber: response.identifier
          });
        }
      });
    }
    submit() {
      if (this.smsForm.valid) {
        this.authService.register('sms', this.smsForm.value.phoneNumber).subscribe(() => {
          this.smsCodeEvent.emit(true);
          this.smsSent = true;
        });
      }
    }
    static {
      this.ɵfac = function AuthSmsComponent_Factory(t) {
        return new (t || AuthSmsComponent)(i0.ɵɵdirectiveInject(i2$2.FormBuilder), i0.ɵɵdirectiveInject(i2$1.TwoFactorAuthService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AuthSmsComponent,
        selectors: [["emc-auth-sms"]],
        inputs: {
          smsCodeShown: "smsCodeShown",
          paragraphNumbers: "paragraphNumbers",
          method: "method"
        },
        outputs: {
          smsCodeEvent: "smsCodeEvent"
        },
        decls: 14,
        vars: 13,
        consts: [[1, "body-part"], [1, "multi-factor-form--section-title"], [1, "multi-factor-form--section-description"], [3, "formGroup"], ["type", "text", "styleClass", "w-100 mt-3", "formControlName", "phoneNumber"], ["type", "submit", "styleClass", "primary w-100", 1, "w-100", 3, "disabled", "label", "click"], ["class", "done-text mt-3 mb-4", 4, "ngIf"], [1, "done-text", "mt-3", "mb-4"], [1, "fas", "fa-check-circle"]],
        template: function AuthSmsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "h5", 1)(2, "span");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "p", 2);
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "form", 3);
            i0.ɵɵelement(10, "cap-input", 4);
            i0.ɵɵelementStart(11, "cap-button", 5);
            i0.ɵɵlistener("click", function AuthSmsComponent_Template_cap_button_click_11_listener() {
              return ctx.submit();
            });
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, AuthSmsComponent_h6_13_Template, 4, 3, "h6", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", ctx.paragraphNumbers == null ? null : ctx.paragraphNumbers.description, ".");
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1("\xA0", i0.ɵɵpipeBind1(5, 7, "auth.2fa." + ctx.method + ".title"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 9, "auth.2fa." + ctx.method + ".description"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("formGroup", ctx.smsForm);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.smsForm.invalid)("label", i0.ɵɵpipeBind1(12, 11, ctx.smsSent ? "auth.2fa." + ctx.method + ".button.resend" : "auth.2fa." + ctx.method + ".button.send"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.smsSent);
          }
        },
        dependencies: [i3.NgIf, i2$2.ɵNgNoValidate, i2$2.NgControlStatus, i2$2.NgControlStatusGroup, i2$2.FormGroupDirective, i2$2.FormControlName, i4.CapturumButtonComponent, i5$2.CapturumInputComponent, i1$2.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return AuthSmsComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AuthEmailComponent = /*#__PURE__*/(() => {
  class AuthEmailComponent {
    constructor(formBuilder, authService, cdr) {
      this.formBuilder = formBuilder;
      this.authService = authService;
      this.cdr = cdr;
      this.emailCodeEvent = new EventEmitter();
      this.method = TwoFactorMethod.email;
    }
    ngOnInit() {
      this.emailForm = this.formBuilder.group({
        email: [null, [Validators.required, Validators.email]]
      });
      this.authService.setupEmail().subscribe(({
        identifier
      }) => {
        this.emailForm.setValue({
          email: identifier
        });
        this.cdr.markForCheck();
      });
    }
    sendEmail() {
      this.authService.register('email', this.emailForm.value.email).subscribe(() => {
        this.emailSent = true;
        this.emailCodeEvent.emit(true);
      });
    }
    static {
      this.ɵfac = function AuthEmailComponent_Factory(t) {
        return new (t || AuthEmailComponent)(i0.ɵɵdirectiveInject(i2$2.FormBuilder), i0.ɵɵdirectiveInject(i2$1.TwoFactorAuthService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AuthEmailComponent,
        selectors: [["emc-auth-email"]],
        inputs: {
          method: "method",
          paragraphNumbers: "paragraphNumbers"
        },
        outputs: {
          emailCodeEvent: "emailCodeEvent"
        },
        decls: 14,
        vars: 13,
        consts: [[1, "body-part"], [1, "multi-factor-form--section-title"], [1, "multi-factor-form--section-description"], [3, "formGroup"], ["type", "text", "styleClass", "w-100 mt-3", "formControlName", "email"], ["type", "submit", "styleClass", "primary w-100", 1, "w-100", 3, "disabled", "label", "click"], ["class", "done-text mt-3 mb-4", 4, "ngIf"], [1, "done-text", "mt-3", "mb-4"], [1, "fas", "fa-check-circle"]],
        template: function AuthEmailComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "h5", 1)(2, "span");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(6, "p", 2);
            i0.ɵɵtext(7);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(9, "form", 3);
            i0.ɵɵelement(10, "cap-input", 4);
            i0.ɵɵelementStart(11, "cap-button", 5);
            i0.ɵɵlistener("click", function AuthEmailComponent_Template_cap_button_click_11_listener() {
              return ctx.sendEmail();
            });
            i0.ɵɵpipe(12, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(13, AuthEmailComponent_h6_13_Template, 4, 3, "h6", 6);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", ctx.paragraphNumbers == null ? null : ctx.paragraphNumbers.description, ".");
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1("\xA0", i0.ɵɵpipeBind1(5, 7, "auth.2fa." + ctx.method + ".title"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(8, 9, "auth.2fa." + ctx.method + ".description"), " ");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("formGroup", ctx.emailForm);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.emailForm.invalid)("label", i0.ɵɵpipeBind1(12, 11, ctx.emailSent ? "auth.2fa." + ctx.method + ".button.resend" : "auth.2fa." + ctx.method + ".button.send"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.emailSent);
          }
        },
        dependencies: [i3.NgIf, i2$2.ɵNgNoValidate, i2$2.NgControlStatus, i2$2.NgControlStatusGroup, i2$2.FormGroupDirective, i2$2.FormControlName, i4.CapturumButtonComponent, i5$2.CapturumInputComponent, i1$2.TranslatePipe],
        encapsulation: 2
      });
    }
  }
  return AuthEmailComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AuthAuthenticatorComponent = /*#__PURE__*/(() => {
  class AuthAuthenticatorComponent {
    constructor(authService) {
      this.authService = authService;
      this.method = TwoFactorMethod.authenticator;
    }
    ngOnInit() {
      this.qrcode$ = this.authService.getOneTimePasswordQrCode();
    }
    static {
      this.ɵfac = function AuthAuthenticatorComponent_Factory(t) {
        return new (t || AuthAuthenticatorComponent)(i0.ɵɵdirectiveInject(i2$1.TwoFactorAuthService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: AuthAuthenticatorComponent,
        selectors: [["emc-auth-authenticator"]],
        inputs: {
          method: "method",
          paragraphNumbers: "paragraphNumbers"
        },
        decls: 25,
        vars: 33,
        consts: [[1, "body-part"], [1, "multi-factor-form--section-title"], [1, "multi-factor-form--section-description", 3, "innerHTML"], [1, "multi-factor-form--section-description"], [1, "qr-code", "d-flex", "flex-column", "align-items-center", "justify-content-center"], [4, "ngIf", "ngIfElse"], ["loadingTemplate", ""], ["alt", "QR code", 3, "src"], [1, "text-center"], [1, "secret-code"], ["styleClass", "cap-progress-spinner"]],
        template: function AuthAuthenticatorComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "h5", 1)(2, "span");
            i0.ɵɵtext(3);
            i0.ɵɵelementEnd();
            i0.ɵɵtext(4);
            i0.ɵɵpipe(5, "translate");
            i0.ɵɵpipe(6, "titlecase");
            i0.ɵɵelementEnd();
            i0.ɵɵelement(7, "p", 2);
            i0.ɵɵpipe(8, "translate");
            i0.ɵɵpipe(9, "titlecase");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(10, "div", 0)(11, "h5", 1)(12, "span");
            i0.ɵɵtext(13);
            i0.ɵɵelementEnd();
            i0.ɵɵtext(14);
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(16, "p", 3);
            i0.ɵɵtext(17);
            i0.ɵɵpipe(18, "translate");
            i0.ɵɵpipe(19, "titlecase");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(20, "div", 4);
            i0.ɵɵtemplate(21, AuthAuthenticatorComponent_ng_container_21_Template, 8, 5, "ng-container", 5);
            i0.ɵɵpipe(22, "async");
            i0.ɵɵtemplate(23, AuthAuthenticatorComponent_ng_template_23_Template, 1, 0, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            const _r1 = i0.ɵɵreference(24);
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1("", ctx.paragraphNumbers == null ? null : ctx.paragraphNumbers.description, ".");
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1("\xA0", i0.ɵɵpipeBind2(5, 8, "auth.2fa." + ctx.method + ".title", i0.ɵɵpureFunction1(27, _c2, i0.ɵɵpipeBind1(6, 11, ctx.method))), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(8, 13, "auth.2fa." + ctx.method + ".description", i0.ɵɵpureFunction1(29, _c2, i0.ɵɵpipeBind1(9, 16, ctx.method))), i0.ɵɵsanitizeHtml);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate1("", (ctx.paragraphNumbers == null ? null : ctx.paragraphNumbers.description) + 1, ".");
            i0.ɵɵadvance(1);
            i0.ɵɵtextInterpolate1("\xA0", i0.ɵɵpipeBind1(15, 18, "auth.2fa." + ctx.method + ".qr.title"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(18, 20, "auth.2fa." + ctx.method + ".qr.description", i0.ɵɵpureFunction1(31, _c2, i0.ɵɵpipeBind1(19, 23, ctx.method))), " ");
            i0.ɵɵadvance(4);
            i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(22, 25, ctx.qrcode$))("ngIfElse", _r1);
          }
        },
        dependencies: [i3.NgIf, i3$1.ProgressSpinner, i3.AsyncPipe, i3.TitleCasePipe, i1$2.TranslatePipe],
        styles: [".qr-code[_ngcontent-%COMP%]{height:calc(200px + 1.5rem)}.qr-code[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{line-height:.75rem}.qr-code[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:200px}"]
      });
    }
  }
  return AuthAuthenticatorComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class UserIndexedDbModel extends IndexedDbModel {
  // Constructor
  constructor(attributes) {
    super(attributes);
    // Configuration
    this.entity = 'user';
    this.table = 'users';
    this.schema = '++id, remote_id, role_id, name_lcase';
    this.sync = false;
  }
}
let UserService = /*#__PURE__*/(() => {
  class UserService extends ApiService {
    constructor(apiHttp, auth) {
      super(apiHttp);
      this.apiHttp = apiHttp;
      this.auth = auth;
      this.endpoint = 'user';
    }
    /**
     * Checks if the current user has the given role
     */
    hasRole(roleCode) {
      const jwt = this.getTokenAsObject();
      return jwt.role === roleCode;
    }
    /**
     * Checks if the current user has superuser rights
     */
    isSuperuser() {
      return this.hasRole('superuser');
    }
    /**
     * Checks if the current user has administrator rights
     */
    isAdministrator() {
      return this.hasRole('superuser') || this.hasRole('administrator');
    }
    /**
     * Get the specialties of the user and store them in the indexedDB
     *
     * @return Promise<void>
     */
    async loadUsers() {
      const users = await this.apiHttp.get(`/${this.endpoint}/sync`).pipe(map(response => response.data)).toPromise();
      await UserIndexedDbModel.query().clear();
      await UserIndexedDbModel.query().bulkAdd(users);
    }
    /**
     * Decodes and returns the current JWT token string as an object
     */
    getTokenAsObject() {
      // Get current JWT token
      const jwtToken = this.auth.getToken();
      // Decode JWT token
      return jwtDecode(jwtToken);
    }
    static {
      this.ɵfac = function UserService_Factory(t) {
        return new (t || UserService)(i0.ɵɵinject(i1.ApiHttpService), i0.ɵɵinject(i2$1.AuthService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: UserService,
        factory: UserService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return UserService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/* tslint:disable:variable-name */
class BaseDataIndexedDbModel extends IndexedDbModel {
  // Constructor
  constructor(attributes) {
    super(attributes);
    // Configuration
    this.entity = 'base-data';
    this.table = 'base_data';
    this.schema = '++id, module_id, key';
    this.sync = true;
  }
  async init() {
    await BaseDataIndexedDbModel.query().where({
      base_data_key_id: this.id
    }).toArray().then(result => {
      this.values = result;
    });
  }
}
let BaseDataService = /*#__PURE__*/(() => {
  class BaseDataService extends ApiService {
    loadBaseData() {
      return forkJoin([from(this.loadBaseDataByRole()), from(this.loadNestedBaseData())]).pipe(map(() => true));
    }
    /**
     * Retrieve baseData and store in indexeddb
     */
    async loadBaseDataByRole() {
      const baseDataValues = await this.apiHttp.get('/role/base-data').pipe(map(response => {
        return response.data.map(baseDataValue => this.transformBaseDataValue(baseDataValue));
      })).toPromise();
      await BaseDataValueIndexedDbModel.query().clear();
      await BaseDataValueIndexedDbModel.query().bulkPut(baseDataValues);
      return true;
    }
    /**
     * Retrieve nested baseData and store in indexeddb
     */
    async loadNestedBaseData() {
      const options = {
        include: ['properties', 'values', 'values.propertyValues'],
        perPage: 99999
      };
      const url = `/base-data-key${this.getOptionsQuery(options)}`;
      const baseDataValues = await this.apiHttp.get(url).pipe(map(response => {
        return response.data.map(baseDataKey => this.transformBaseDataKey(baseDataKey));
      })).toPromise();
      await BaseDataIndexedDbModel.query().clear();
      await BaseDataIndexedDbModel.query().bulkPut(baseDataValues);
      return true;
    }
    transformBaseDataValue(baseDataValue) {
      return {
        ...baseDataValue,
        attributes: baseDataValue.attributes.map(baseDataValueAttribute => {
          baseDataValueAttribute = {
            ...baseDataValueAttribute,
            attribute: baseDataValueAttribute.property
          };
          delete baseDataValueAttribute.property;
          return baseDataValueAttribute;
        })
      };
    }
    transformBaseDataKey(baseDataKey) {
      baseDataKey = {
        ...baseDataKey,
        attributes: baseDataKey.properties,
        values: baseDataKey.values.map(baseDataValue => {
          baseDataValue = {
            ...baseDataValue,
            attributes: baseDataValue.propertyValues
          };
          delete baseDataValue.propertyValues;
          return baseDataValue;
        })
      };
      delete baseDataKey.properties;
      return baseDataKey;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵBaseDataService_BaseFactory;
        return function BaseDataService_Factory(t) {
          return (ɵBaseDataService_BaseFactory || (ɵBaseDataService_BaseFactory = i0.ɵɵgetInheritedFactory(BaseDataService)))(t || BaseDataService);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BaseDataService,
        factory: BaseDataService.ɵfac
      });
    }
  }
  return BaseDataService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TranslationIndexedDbModel = /*#__PURE__*/(() => {
  class TranslationIndexedDbModel extends IndexedDbModel {
    static {
      this.translations = [];
    }
    /**
     * Load current translations in static cache
     *
     * @return Promise<void>
     */
    static async loadTranslations() {
      TranslationIndexedDbModel.translations = await TranslationIndexedDbModel.query().toArray();
    }
    // Constructor
    constructor(attributes) {
      super(attributes);
      // Configuration
      this.entity = 'translation';
      this.table = 'translations';
      this.schema = '++id';
      this.sync = false;
    }
  }
  return TranslationIndexedDbModel;
})();
let TranslationService = /*#__PURE__*/(() => {
  class TranslationService extends ApiService {
    constructor(api, translateService, authService, config) {
      super(api);
      this.api = api;
      this.translateService = translateService;
      this.authService = authService;
      this.config = config;
      this.endpoint = 'role/translation';
      this.translateService.onLangChange.subscribe(({
        translations
      }) => {
        this.setPrimengLocale(translations);
      });
    }
    /**
     * Get the translations for the current user
     *
     * @return Observable<any>
     */
    getTranslations() {
      return this.apiHttp.get(`/${this.endpoint}`).pipe(map(response => response.data), tap(async response => {
        for (const key in response) {
          if (response.hasOwnProperty(key)) {
            TranslationIndexedDbModel.query().put({
              id: key,
              value: response[key]
            });
          }
        }
      }));
    }
    /**
     * Load translations and set default or current users language
     *
     * @return Promise<void>
     */
    loadTranslations() {
      return this.apiHttp.get(`/${this.endpoint}`).pipe(catchError(async () => {
        await TranslationIndexedDbModel.loadTranslations();
        return of(TranslationIndexedDbModel.translations);
      }), map(response => response.data ? response.data : response), this.processTranslationResponse.bind(this));
    }
    loadFilteredTranslations(groups, locale) {
      const params = this.getHttpParams(groups, locale);
      return this.api.get('/translation/filtered', {
        params
      }).pipe(map(response => response.data), this.processTranslationResponse.bind(this));
    }
    setPrimengLocale(translations) {
      this.config.setTranslation({
        dayNames: [translations['calendar-locale.day-names.sunday'], translations['calendar-locale.day-names.monday'], translations['calendar-locale.day-names.tuesday'], translations['calendar-locale.day-names.wednesday'], translations['calendar-locale.day-names.thursday'], translations['calendar-locale.day-names.friday'], translations['calendar-locale.day-names.saturday']],
        dayNamesShort: [translations['calendar-locale.day-names.sun'], translations['calendar-locale.day-names.mon'], translations['calendar-locale.day-names.tue'], translations['calendar-locale.day-names.wed'], translations['calendar-locale.day-names.thu'], translations['calendar-locale.day-names.fri'], translations['calendar-locale.day-names.sat']],
        dayNamesMin: [translations['calendar-locale.day-names.su'], translations['calendar-locale.day-names.mo'], translations['calendar-locale.day-names.tu'], translations['calendar-locale.day-names.we'], translations['calendar-locale.day-names.th'], translations['calendar-locale.day-names.fr'], translations['calendar-locale.day-names.sa']],
        monthNames: [translations['calendar-locale.month-names.january'], translations['calendar-locale.month-names.february'], translations['calendar-locale.month-names.march'], translations['calendar-locale.month-names.april'], translations['calendar-locale.month-names.may'], translations['calendar-locale.month-names.june'], translations['calendar-locale.month-names.july'], translations['calendar-locale.month-names.august'], translations['calendar-locale.month-names.september'], translations['calendar-locale.month-names.october'], translations['calendar-locale.month-names.november'], translations['calendar-locale.month-names.december']],
        monthNamesShort: [translations['calendar-locale.month-names.jan'], translations['calendar-locale.month-names.feb'], translations['calendar-locale.month-names.mar'], translations['calendar-locale.month-names.apr'], translations['calendar-locale.month-names.may'], translations['calendar-locale.month-names.jun'], translations['calendar-locale.month-names.jul'], translations['calendar-locale.month-names.aug'], translations['calendar-locale.month-names.sep'], translations['calendar-locale.month-names.oct'], translations['calendar-locale.month-names.nov'], translations['calendar-locale.month-names.dec']],
        today: translations['calendar-locale.today'],
        weekHeader: translations['calendar-locale.week-header']
      });
    }
    processTranslationResponse(source) {
      return new Observable(subscriber => {
        source.pipe(catchError(async () => {
          await TranslationIndexedDbModel.loadTranslations();
          return of(TranslationIndexedDbModel.translations);
        }), map(translations => {
          return this.mapTranslationResponse(translations);
        }), switchMap(translations => {
          return from(TranslationIndexedDbModel.query().bulkPut(translations)).pipe(catchError(() => of(translations)), map(() => translations));
        }), switchMap(translations => {
          const loggedInUser = this.authService.getUser();
          const localeFromResponse = translations.length === 1 && translations[0].id;
          this.translateService.setDefaultLang('en');
          const language = loggedInUser && loggedInUser.locale ? loggedInUser.locale.code || this.translateService.defaultLang : localeFromResponse || this.translateService.defaultLang;
          // Make sure the translations are loaded correctly
          return this.translateService.reloadLang(language).pipe(take(1), switchMap(() => this.translateService.use(language)));
        })).subscribe({
          next(value) {
            subscriber.next(value);
          },
          error(error) {
            subscriber.error(error);
          },
          complete() {
            subscriber.complete();
          }
        });
      });
    }
    mapTranslationResponse(translations) {
      const translationRecords = [];
      for (const language in translations) {
        if (translations.hasOwnProperty(language)) {
          for (const translationKey in translations[language]) {
            if (translationKey === 'base-data' && typeof translations[language][translationKey] === 'object') {
              // Make sure all keys (GUIDs) are lowercase, because MSSQL returns them in uppercases
              translations[language][translationKey] = Object.keys(translations[language][translationKey]).reduce((destination, key) => {
                destination[key.toLowerCase()] = translations[language][translationKey][key];
                return destination;
              }, {});
            }
          }
          translationRecords.push({
            id: language,
            value: translations[language]
          });
        }
      }
      return translationRecords;
    }
    getHttpParams(groups, locale) {
      const joinedGroups = groups ? groups.join(',') : null;
      const currentLanguage = locale ?? this.translateService.currentLang;
      let params = new HttpParams();
      if (joinedGroups) {
        params = params.append('groups', joinedGroups);
      }
      if (currentLanguage) {
        params = params.append('locale', currentLanguage);
      }
      return params;
    }
    static {
      this.ɵfac = function TranslationService_Factory(t) {
        return new (t || TranslationService)(i0.ɵɵinject(i1.ApiHttpService), i0.ɵɵinject(i1$2.TranslateService), i0.ɵɵinject(i2$1.AuthService), i0.ɵɵinject(i4$3.PrimeNGConfig));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TranslationService,
        factory: TranslationService.ɵfac
      });
    }
  }
  return TranslationService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BaseDataValueService = /*#__PURE__*/(() => {
  class BaseDataValueService extends ApiService {
    constructor(apiHttp, translateService) {
      super(apiHttp);
      this.apiHttp = apiHttp;
      this.translateService = translateService;
      this.endpoint = 'base-data-value';
    }
    /**
     * Return a list of base-data-values filtered by key and optionally translated
     *
     * @param key - the base-data-key
     * @param translate - Whether or not to translate the values
     */
    getListValuesByKey(key, translate = true) {
      return this.list({
        filters: [{
          field: 'key.key',
          value: key
        }]
      }).pipe(map(response => response.data.map(value => ({
        value: value.key,
        label: translate ? this.translateService.instant(`base-data.${value.key.toLowerCase()}`) : value.label
      }))));
    }
    static {
      this.ɵfac = function BaseDataValueService_Factory(t) {
        return new (t || BaseDataValueService)(i0.ɵɵinject(i1.ApiHttpService), i0.ɵɵinject(i1$2.TranslateService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BaseDataValueService,
        factory: BaseDataValueService.ɵfac
      });
    }
  }
  return BaseDataValueService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class BaseDataValueApiModel {}

/* tslint:disable:variable-name */
class BaseDataKeyIndexedDbModel extends IndexedDbModel {
  // Constructor
  constructor(attributes) {
    super(attributes);
    // Configuration
    this.entity = 'base-data-key';
    this.table = 'base_data_keys';
    this.schema = '++id, module_id, key';
    this.sync = true;
  }
  async init() {
    await BaseDataKeyIndexedDbModel.query().where({
      base_data_key_id: this.id
    }).toArray().then(result => {
      this.values = result;
    });
  }
}
class BaseDataApiModel {}
let BaseDataResolver = /*#__PURE__*/(() => {
  class BaseDataResolver {
    constructor(baseDataService) {
      this.baseDataService = baseDataService;
    }
    /**
     * Make sure the base-data is loaded before accessing the route
     */
    resolve(route, state) {
      return this.baseDataService.loadBaseData();
    }
    static {
      this.ɵfac = function BaseDataResolver_Factory(t) {
        return new (t || BaseDataResolver)(i0.ɵɵinject(BaseDataService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BaseDataResolver,
        factory: BaseDataResolver.ɵfac
      });
    }
  }
  return BaseDataResolver;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModuleTenantIndexedDbModel = /*#__PURE__*/(() => {
  class ModuleTenantIndexedDbModel extends IndexedDbModel {
    static {
      this.moduleTenants = [];
    }
    /**
     * Load current modules in static cache
     */
    static async loadModuleTenants() {
      ModuleTenantIndexedDbModel.moduleTenants = await ModuleTenantIndexedDbModel.query().toArray();
    }
    // Constructor
    constructor(attributes) {
      super(attributes);
      // Configuration
      this.entity = 'module-tenant';
      this.table = 'module_tenant';
      this.schema = 'id';
      this.sync = false;
    }
    getData() {
      return {
        id: this.id,
        name: this.name,
        available_offline: this.available_offline,
        translation_key: this.translation_key,
        menu_index: this.menu_index
      };
    }
  }
  return ModuleTenantIndexedDbModel;
})();
let ModuleTenantService = /*#__PURE__*/(() => {
  class ModuleTenantService extends ApiService {
    constructor() {
      super(...arguments);
      this.endpoint = 'tenant/module';
    }
    /**
     * Get the modules of the tenant and store them in the indexedDB
     *
     * @return Observable<ModuleTenant[]>
     */
    loadModuleTenants() {
      return this.apiHttp.get(`/${this.endpoint}`).pipe(map(response => response.data), tap(async moduleTenants => {
        await ModuleTenantIndexedDbModel.query().clear();
        await ModuleTenantIndexedDbModel.query().bulkAdd(moduleTenants);
        await ModuleTenantIndexedDbModel.loadModuleTenants();
      }), catchError(async () => {
        await ModuleTenantIndexedDbModel.loadModuleTenants();
      }));
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵModuleTenantService_BaseFactory;
        return function ModuleTenantService_Factory(t) {
          return (ɵModuleTenantService_BaseFactory || (ɵModuleTenantService_BaseFactory = i0.ɵɵgetInheritedFactory(ModuleTenantService)))(t || ModuleTenantService);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ModuleTenantService,
        factory: ModuleTenantService.ɵfac
      });
    }
  }
  return ModuleTenantService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModuleTenantResolver = /*#__PURE__*/(() => {
  class ModuleTenantResolver {
    constructor(moduleTenantService) {
      this.moduleTenantService = moduleTenantService;
    }
    /**
     * Make sure the module tenants are loaded before accessing the route
     *
     * @param route
     * @param state
     *
     * @return Observable<ModuleTenant[]>
     */
    resolve(route, state) {
      return this.moduleTenantService.loadModuleTenants();
    }
    static {
      this.ɵfac = function ModuleTenantResolver_Factory(t) {
        return new (t || ModuleTenantResolver)(i0.ɵɵinject(ModuleTenantService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ModuleTenantResolver,
        factory: ModuleTenantResolver.ɵfac
      });
    }
  }
  return ModuleTenantResolver;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Tenant {}
class TenantIndexedDbModel extends IndexedDbModel {
  // Constructor
  constructor(attributes) {
    super(attributes);
    // Configuration
    this.entity = 'tenant';
    this.table = 'tenants';
    this.schema = '++id, name';
    this.sync = false;
  }
}
let TranslationResolver = /*#__PURE__*/(() => {
  class TranslationResolver {
    constructor(translationService) {
      this.translationService = translationService;
    }
    /**
     * Make sure the translations are loaded before accessing the route
     */
    resolve(route, state) {
      return this.translationService.loadTranslations();
    }
    static {
      this.ɵfac = function TranslationResolver_Factory(t) {
        return new (t || TranslationResolver)(i0.ɵɵinject(TranslationService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TranslationResolver,
        factory: TranslationResolver.ɵfac
      });
    }
  }
  return TranslationResolver;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let FilteredTranslationResolver = /*#__PURE__*/(() => {
  class FilteredTranslationResolver {
    constructor(translationService) {
      this.translationService = translationService;
    }
    resolve(route, state) {
      return this.translationService.loadFilteredTranslations(route?.data?.groups, route?.data?.locale);
    }
    static {
      this.ɵfac = function FilteredTranslationResolver_Factory(t) {
        return new (t || FilteredTranslationResolver)(i0.ɵɵinject(TranslationService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: FilteredTranslationResolver,
        factory: FilteredTranslationResolver.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return FilteredTranslationResolver;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumTranslateParser = /*#__PURE__*/(() => {
  class CapturumTranslateParser extends TranslateDefaultParser {
    getValue(target, key) {
      if (this.isEditTranslationModeOn()) {
        const translation = super.getValue(target, key);
        return translation ? `!@![${key}]-[${translation}]!@!` : key;
      }
      return super.getValue(target, key);
    }
    isEditTranslationModeOn() {
      const editTranslation = localStorage.getItem(EDIT_TRANSLATION_MODE_KEY);
      return !!editTranslation && JSON.parse(editTranslation) === true;
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵCapturumTranslateParser_BaseFactory;
        return function CapturumTranslateParser_Factory(t) {
          return (ɵCapturumTranslateParser_BaseFactory || (ɵCapturumTranslateParser_BaseFactory = i0.ɵɵgetInheritedFactory(CapturumTranslateParser)))(t || CapturumTranslateParser);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CapturumTranslateParser,
        factory: CapturumTranslateParser.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return CapturumTranslateParser;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class TranslationLoader {
  /**
   * Get the translations for the given language
   *
   * @param lang
   */
  getTranslation(lang) {
    return new Observable(resolver => {
      TranslationIndexedDbModel.query().get(lang).then(result => {
        resolver.next(result.value);
      }, err => {
        resolver.next({});
      }).catch(() => {
        resolver.next({});
      });
    });
  }
}
class FileIndexedDbModel extends IndexedDbModel {
  constructor(attributes) {
    super(attributes);
    this.entity = 'file';
    this.schema = 'id, _deleted, _changed';
    this.table = 'files';
  }
  getData() {
    return {
      id: this.id,
      data: this.data,
      relatedId: this.relatedId,
      relatedTable: this.relatedTable,
      mime_type: this.mime_type,
      filename: this.filename,
      _deleted: this._deleted || 0,
      _changed: this._changed || 0
    };
  }
}
class Store extends Dexie {
  static {
    this.onReady = new Subject();
  }
  /**
   * Return singleton instance
   */
  static getStore(name, id) {
    if (Store._store === null || Store._store && id && !Store._store.name.includes(id)) {
      if (Store._store) {
        if (Store._store.isOpen()) {
          // close if open
          Store._store.close();
        } else {
          // delete if not open
          Store._store.delete();
        }
      }
      if (id) {
        name = `${name}-${id}`;
      }
      Store._store = new Store(name);
      Store._isReady = false;
    }
    return Store._store;
  }
  static {
    this._store = null;
  }
  static {
    this._isReady = false;
  }
  static {
    this._isLoading = false;
  }
  /**
   * Create indexedDB tables
   */
  constructor(name) {
    super(name, {
      autoOpen: true
    });
  }
  /**
   * Set up the indexedDB based on the given config
   *
   * @param config - configuration of module
   * @param id - unique id for the db name
   */
  async setup(config, id) {
    if (Store._isReady) {
      return true;
    }
    if (Store._isLoading) {
      return await Store.onReady.toPromise();
    }
    Store._isLoading = true;
    let databaseName = config.databaseName;
    if (id) {
      databaseName += '-' + id;
    }
    if (await Dexie.exists(databaseName)) {
      await this.open();
      if (this.verno < config.version) {
        // Delete current outdated database if applicable
        await this.delete();
        await this.version(1).stores({});
      } else {
        await this.close();
      }
    }
    // Generate schema object
    const schema = {};
    const customIndexedDbModels = config.indexedDbModels || [];
    const models = [PermissionIndexedDbModel, SettingIndexedDbModel, TenantIndexedDbModel, ModuleTenantIndexedDbModel, ModuleIndexedDbModel, TranslationIndexedDbModel, BaseDataIndexedDbModel, BaseDataValueIndexedDbModel, BaseDataValueIndexedDbModel, BaseDataKeyIndexedDbModel, UserIndexedDbModel, FileIndexedDbModel, ...customIndexedDbModels];
    // Add each model
    models.forEach(model => {
      const m = new model();
      schema[m.table] = m.schema;
    });
    // Create schema
    await this.version(config.version).stores(schema);
    await this.open();
    IndexedDbModel.store = this;
    // Map each table to class model
    models.forEach(model => {
      const m = new model();
      this[m.table].mapToClass(model);
    });
    Store._isReady = true;
    Store._isLoading = false;
    Store.onReady.next(true);
    Store.onReady.complete();
    return true;
  }
}
let IndexedDbService = /*#__PURE__*/(() => {
  class IndexedDbService {
    constructor(config) {
      this.config = config;
    }
    /**
     * Create the indexedDB store
     */
    async createStore(id) {
      this.store = this.getStore(id);
      await this.store.setup(this.config, id);
      return true;
    }
    /**
     * Get the store object
     *
     * @return Store
     */
    getStore(id) {
      return Store.getStore(this.config.databaseName, id);
    }
    /**
     * Reset the store
     */
    async resetStore(id) {
      await this.store.delete();
      await this.store.setup(this.config, id);
    }
    static {
      this.ɵfac = function IndexedDbService_Factory(t) {
        return new (t || IndexedDbService)(i0.ɵɵinject(CompleteConfig));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IndexedDbService,
        factory: IndexedDbService.ɵfac
      });
    }
  }
  return IndexedDbService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SynchronisationService = /*#__PURE__*/(() => {
  class SynchronisationService {
    constructor(api, auth, toastService, utilService, settingService, baseDataService, translationService, permissionService, moduleService, userService, indexedDbService) {
      this.api = api;
      this.auth = auth;
      this.toastService = toastService;
      this.utilService = utilService;
      this.settingService = settingService;
      this.baseDataService = baseDataService;
      this.translationService = translationService;
      this.permissionService = permissionService;
      this.moduleService = moduleService;
      this.userService = userService;
      this.indexedDbService = indexedDbService;
      this.SynchronisingCompleted = new Subject();
      this.showSyncToasts = true;
      this.store = this.indexedDbService.getStore();
      this.state = {
        added: false,
        finished: false
      };
      // Register to internet connection online event
      window.addEventListener('online', e => {
        if (this.shouldSync) {
          this.synchronise();
          this.synchroniseStaticData();
          this.shouldSync = false;
        }
      }, false);
    }
    /**
     * Sync static data attachable in projects
     *
     * Clients, materials, activities, base data
     *
     * @return Promise<any>
     */
    async synchroniseStaticData(showResultToast = true) {
      // Do not synchronize when not authenticated
      if (!this.auth.isAuthenticated()) {
        return;
      }
      // Check internet status, if not online, then sync later
      if (!navigator.onLine) {
        this.shouldSync = true;
        return;
      }
      await this.baseDataService.loadBaseData().toPromise();
      if (showResultToast) {
        this.showSyncStartToast('synchronisation.static-data-synced');
      }
      await this.translationService.getTranslations();
      await this.userService.loadUsers();
      // Reload settings
      await this.settingService.loadAll();
      await this.baseDataService.loadBaseData().toPromise();
      await this.moduleService.loadModules();
      await this.permissionService.loadPermissions();
    }
    /**
     * Sync project data
     *
     * @return Promise<any>
     */
    async synchronise() {
      // Do not synchronize when not authenticated
      if (!this.auth.isAuthenticated()) {
        return;
      }
      // Check internet status, if not online, then sync later
      if (!navigator.onLine) {
        this.shouldSync = true;
        return;
      }
      this.showSyncStartToast('synchronisation.data-synced');
      // First sync new and changed data to backend
      await this.syncToBackend();
      await this.baseDataService.loadBaseData().toPromise();
      this.showSyncResultToast();
      this.SynchronisingCompleted.next(this.state);
    }
    /**
     * Sync stuff to the backend
     *
     * @param clearOnSuccess boolean
     * @return Promise<boolean>
     */
    async syncToBackend(clearOnSuccess = false) {
      // Do your sync stuff here
      return true;
    }
    /**
     * Show sync message
     *
     * @param message string
     * @return void
     */
    showSyncStartToast(message) {
      if (!this.showSyncToasts) {
        return;
      }
      this.toastService.success('synchronisation.title', message);
    }
    /**
     * Show sync result message
     *
     * @return void
     */
    showSyncResultToast() {
      if (!this.showSyncToasts) {
        return;
      }
      if (this.state.added === true) {
        this.toastService.success('synchronisation.title', 'synchronisation.data-imported');
      } else {
        this.toastService.success('synchronisation.title', 'synchronisation.data-uptodate');
      }
    }
    /**
     * State of synchronisation as observable
     *
     * @return Observable<any>
     */
    synchronisationState() {
      return from([this.state]);
    }
    /**
     * Lists all tables containing project data
     *
     * @return Promise<any>
     */
    async getProjectTables() {
      const tables = [];
      const modules = await this.getSyncTables();
      for (const module of modules) {
        tables.push(module.table);
      }
      return tables;
    }
    /**
     * Build a sync model from de database modules
     *
     * @return Promise<any>
     */
    async buildSyncModel() {
      const syncModel = {};
      for (const syncTable of await this.getSyncTables()) {
        if (!syncModel[syncTable.module]) {
          syncModel[syncTable.module] = {};
        }
        syncModel[syncTable.module][syncTable.key] = [];
      }
      return syncModel;
    }
    /**
     * Build sync Tables from the active modules stored in de database
     *
     * @return Promise<any>
     */
    async getSyncTables() {
      const modules = [];
      const activeModules = await ModuleIndexedDbModel.getModules();
      for (const activeModule of activeModules) {
        switch (activeModule.name) {
          case 'inventory-client':
            modules.push({
              module: 'inventory-client',
              key: 'client',
              table: 'clients'
            });
            break;
          case 'inventory-project':
            modules.push({
              module: 'inventory-project',
              key: 'project',
              table: 'projects',
              relations: [{
                module: 'address',
                key: 'address',
                table: 'addresses',
                attribute: 'addressable_id',
                identifier: 'project_id'
              }, {
                module: 'contact',
                key: 'contact',
                table: 'contacts',
                attribute: 'contactable_id',
                identifier: 'project_id'
              }]
            });
            break;
          case 'inventory-inventory':
            modules.push({
              module: 'inventory-inventory',
              key: 'inventory',
              table: 'inventories'
            });
            modules.push({
              module: 'inventory-inventory',
              key: 'inventory_item',
              table: 'inventory_items'
            });
            break;
          case 'inventory-receipt':
            modules.push({
              module: 'inventory-receipt',
              key: 'receipt',
              table: 'receipts'
            });
            break;
          case 'inventory-specialty':
            modules.push({
              module: 'inventory-specialty',
              key: 'project_specialty',
              table: 'project_specialties'
            });
            break;
        }
      }
      return modules;
    }
    /**
     * Store the sync entities
     *
     * @param entities any
     * @param syncTable any
     * @return Promise<any>
     */
    async storeEntities(entities, syncTable) {
      // Get the errors
      let errors = [];
      entities.map(entity => errors = errors.concat(entity.errors));
      if (errors.length > 0) {
        // TODO: Do something with the errors
        console.log('Entity sync error...');
      }
      // Get mutated entities
      let mutated = [];
      entities.map(entity => mutated = mutated.concat(entity.mutated));
      if (syncTable.attribute) {
        mutated.map(entity => {
          entity[syncTable.identifier] = entity[syncTable.attribute];
          return entity;
        });
      }
      // Save mutated
      await this.store.table(syncTable.table).bulkPut(mutated);
      // Get deleted entities
      let deleted = [];
      entities.map(entity => deleted = deleted.concat(entity.deleted));
      // Remove deleted
      await this.store.table(syncTable.table).bulkDelete(deleted);
      // Get "new" entities
      let brandNew = [];
      entities.map(entity => brandNew = brandNew.concat(entity.new));
      if (syncTable.attribute) {
        brandNew.map(entity => {
          entity[syncTable.identifier] = entity[syncTable.attribute];
          return entity;
        });
      }
      await this.store.table(syncTable.table).bulkPut(brandNew);
    }
    /**
     * Get the Diff between two entities
     *
     * @param newData any
     * @param oldData any
     * @return any
     */
    getDiff(newData, oldData) {
      let result;
      if (Array.isArray(newData)) {
        if (!result) {
          result = [];
        }
        for (const item of newData) {
          if (item === null) {
            continue;
          }
          // Find item with same id in old data and compare
          const oldItem = item && oldData ? oldData.find(dataItem => dataItem.id === item.id) : undefined;
          if (!oldItem) {
            // Mark as new
            item._new = true;
            result.push(item);
          } else {
            // Item exists, add differences only
            if (Array.isArray(item)) {
              const itemDiff = this.getDiff(item, oldItem);
              if (itemDiff) {
                // Always add id field
                itemDiff.id = item[0].id;
                result.push(itemDiff);
              }
            }
          }
        }
        // Check if item is deleted and if the old data contains nested data which could have been updated
        if (oldData) {
          for (const oldDataItem of oldData) {
            if (oldDataItem !== null && typeof oldDataItem === 'object') {
              // Compare child elements as well
              for (const objectKey of Object.keys(oldDataItem)) {
                const newDataItem = newData.find(dataItem => dataItem.id === oldDataItem.id);
                if (Array.isArray(oldDataItem[objectKey])) {
                  const itemDiff = this.getDiff(newDataItem ? newDataItem[objectKey] : [], oldDataItem[objectKey]);
                  if (itemDiff) {
                    if (!result[objectKey]) {
                      result[objectKey] = itemDiff;
                    } else {
                      result[objectKey] = [...result[objectKey], ...itemDiff];
                    }
                  }
                } else if (newDataItem && typeof oldDataItem[objectKey] === 'string') {
                  if (oldDataItem[objectKey] !== newDataItem[objectKey]) {
                    result.push(newDataItem);
                  }
                }
              }
            }
            if (oldDataItem !== null && newData.filter(dataItem => dataItem.id === oldDataItem.id).length === 0) {
              result.push({
                _is_deleted: true,
                id: oldDataItem.id
              });
            }
          }
        }
        return Object.keys(result).length === 0 ? undefined : result;
      }
      if (!result) {
        result = {};
      }
      for (const key of Object.keys(newData)) {
        const newEntity = newData[key];
        const oldEntity = oldData[key];
        // Always add if old item not exists
        if (newEntity && !oldEntity) {
          result[key] = newEntity;
          // Mark each array entry as _new if array
          if (Array.isArray(result[key])) {
            for (const item of result[key]) {
              if (typeof item === 'object') {
                // Mark as new
                item._new = true;
              }
            }
          } else if (typeof result[key] === 'object') {
            // Mark as new
            result[key]._new = true;
          }
          continue;
        }
        if (Array.isArray(newEntity)) {
          const itemDiff = this.getDiff(newEntity, oldEntity);
          if (itemDiff) {
            result[key] = itemDiff;
          }
          continue;
        }
        if (newEntity && typeof newEntity === 'object') {
          const itemDiff = this.getDiff(newEntity, oldEntity);
          if (itemDiff) {
            result[key] = itemDiff;
          }
          continue;
        }
        if (newEntity !== oldEntity) {
          result[key] = newEntity;
        }
      }
      if (!result || Object.keys(result).length === 0) {
        return undefined;
      }
      // Add id field if available
      if (newData.id) {
        result.id = newData.id;
      }
      return result;
    }
    static {
      this.ɵfac = function SynchronisationService_Factory(t) {
        return new (t || SynchronisationService)(i0.ɵɵinject(i1.ApiHttpService), i0.ɵɵinject(i2$1.AuthService), i0.ɵɵinject(i3$2.ToastService), i0.ɵɵinject(UtilService), i0.ɵɵinject(SettingService), i0.ɵɵinject(BaseDataService), i0.ɵɵinject(TranslationService), i0.ɵɵinject(PermissionService), i0.ɵɵinject(ModuleService), i0.ɵɵinject(UserService), i0.ɵɵinject(IndexedDbService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SynchronisationService,
        factory: SynchronisationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return SynchronisationService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UserProfileComponent = /*#__PURE__*/(() => {
  class UserProfileComponent extends BaseDetailComponent {
    constructor(injector, route, translateService, apiService, router, authService, synchronisationService, tenantService, confirmationService, indexedDbService) {
      super(injector, translateService);
      this.injector = injector;
      this.route = route;
      this.translateService = translateService;
      this.apiService = apiService;
      this.router = router;
      this.authService = authService;
      this.synchronisationService = synchronisationService;
      this.tenantService = tenantService;
      this.confirmationService = confirmationService;
      this.indexedDbService = indexedDbService;
      this.cancelRedirectRoute = '/admin/users/profile';
      this.modelTranslation = this.translateService.instant('user.profile.title');
      this.createForm();
      this.model = {};
      this.isEdit = true;
    }
    ngOnInit() {
      super.ngOnInit();
      this.currentUser = this.authService.getUser();
      this.model = this.currentUser;
    }
    /**
     * Display confirmation message when database reset button is clicked
     */
    onDatabaseReset() {
      this.confirmationService.confirm({
        message: this.translateService.instant('user.profile.reset_database.message'),
        header: this.translateService.instant('user.profile.reset_database'),
        icon: 'fa fa-question-circle',
        accept: async () => {
          await this.indexedDbService.resetStore();
          window.location.reload();
        }
      });
    }
    /**
     * Display confirmation message when sync button is clicked
     */
    onSyncNow() {
      this.confirmationService.confirm({
        message: this.translateService.instant('user.profile.synchronise.message'),
        header: this.translateService.instant('user.profile.synchronise'),
        icon: 'fa fa-question-circle',
        accept: async () => {
          this.toastService.success(this.translateService.instant('synchronisation.title'), this.translateService.instant('synchronisation.data-synced')), this.synchronisationService.synchronise();
        }
      });
    }
    /**
     * Send password reset mail to current user
     */
    onResetPassword() {
      this.authService.recoverPassword(this.currentUser.email).subscribe(result => {
        if (result) {
          this.toastService.success(this.translateService.instant('toast.success.title'), this.translateService.instant('toast.email-reset.message'));
        }
      }, error => {
        this.toastService.handleError(error, this.translateService.instant('toast.error.title'), this.translateService.instant('toast.error.message'));
      });
    }
    saveUser() {
      if (this.formGroup.valid) {
        const options = {
          include: ['currentRole', 'locale', 'roles']
        };
        this.apiService.update(this.model, options).subscribe(user => {
          this.toastService.success(this.modelTranslation, this.saveMessage);
          localStorage.setItem('user', JSON.stringify(user));
        }, error => {
          this.toastService.error(this.modelTranslation, this.errorMessage);
        });
      }
    }
    /**
     * Create the profile form
     */
    async createForm() {
      this.fields = [{
        type: 'input',
        key: 'name',
        props: {
          translateLabel: this.translateService.stream('user.profile.name'),
          required: true
        }
      }, {
        type: 'input',
        key: 'email',
        props: {
          translateLabel: this.translateService.stream('user.profile.email'),
          type: 'email',
          required: true
        },
        validators: {
          validation: [emailValidator]
        }
      }];
    }
    static {
      this.ɵfac = function UserProfileComponent_Factory(t) {
        return new (t || UserProfileComponent)(i0.ɵɵdirectiveInject(i0.Injector), i0.ɵɵdirectiveInject(i1$1.ActivatedRoute), i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(UserService), i0.ɵɵdirectiveInject(i1$1.Router), i0.ɵɵdirectiveInject(i2$1.AuthService), i0.ɵɵdirectiveInject(SynchronisationService), i0.ɵɵdirectiveInject(TenantService), i0.ɵɵdirectiveInject(i4$3.ConfirmationService), i0.ɵɵdirectiveInject(IndexedDbService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: UserProfileComponent,
        selectors: [["emc-user-profile"]],
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 32,
        vars: 31,
        consts: [[1, "wrapper", "wrapper-content"], [1, "row", "mb-3"], [1, "col"], [1, "ibox"], [1, "ibox-title"], [1, "ibox-content"], [1, "row"], ["icon", "fas fa-database", 1, "mr-3", 3, "label", "click"], ["icon", "fas fa-sync", 1, "mr-3", 3, "label", "click"], ["icon", "fas fa-unlock-alt", 1, "mr-3", 3, "label", "click"], ["class", "row mb-3", 4, "ngIf"], [3, "formGroup", "ngSubmit"], [3, "form", "fields", "model"], ["type", "submit", 3, "disabled", "icon", "label"], ["appendTo", "body", 3, "rejectLabel", "acceptLabel"], [4, "ngIf"]],
        template: function UserProfileComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "div", 3)(4, "div", 4)(5, "h5");
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(8, "div", 5)(9, "div", 6)(10, "cap-button", 7);
            i0.ɵɵlistener("click", function UserProfileComponent_Template_cap_button_click_10_listener() {
              return ctx.onDatabaseReset();
            });
            i0.ɵɵpipe(11, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(12, "cap-button", 8);
            i0.ɵɵlistener("click", function UserProfileComponent_Template_cap_button_click_12_listener() {
              return ctx.onSyncNow();
            });
            i0.ɵɵpipe(13, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(14, "cap-button", 9);
            i0.ɵɵlistener("click", function UserProfileComponent_Template_cap_button_click_14_listener() {
              return ctx.onResetPassword();
            });
            i0.ɵɵpipe(15, "translate");
            i0.ɵɵelementEnd()()()()()();
            i0.ɵɵtemplate(16, UserProfileComponent_div_16_Template, 5, 1, "div", 10);
            i0.ɵɵelementStart(17, "div", 1)(18, "div", 2)(19, "div", 3)(20, "div", 4)(21, "h5");
            i0.ɵɵtext(22);
            i0.ɵɵpipe(23, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(24, "div", 5)(25, "form", 11);
            i0.ɵɵlistener("ngSubmit", function UserProfileComponent_Template_form_ngSubmit_25_listener() {
              return ctx.saveUser();
            });
            i0.ɵɵelementStart(26, "formly-form", 12);
            i0.ɵɵelement(27, "cap-button", 13);
            i0.ɵɵpipe(28, "translate");
            i0.ɵɵelementEnd()()()()()()();
            i0.ɵɵelement(29, "p-confirmDialog", 14);
            i0.ɵɵpipe(30, "translate");
            i0.ɵɵpipe(31, "translate");
          }
          if (rf & 2) {
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 15, "user.profile.settings"), " ");
            i0.ɵɵadvance(4);
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(11, 17, "user.profile.reset_database"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(13, 19, "user.profile.synchronise"));
            i0.ɵɵadvance(2);
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(15, 21, "user.profile.forgot_password"));
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.currentUser.roles.length > 1);
            i0.ɵɵadvance(6);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(23, 23, "user.profile.title"), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("formGroup", ctx.formGroup);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("form", ctx.formGroup)("fields", ctx.fields)("model", ctx.model);
            i0.ɵɵadvance(1);
            i0.ɵɵpropertyInterpolate("label", i0.ɵɵpipeBind1(28, 25, "button.submit"));
            i0.ɵɵproperty("disabled", ctx.submitting)("icon", ctx.submitting ? "fas fa-spinner fa-pulse" : "fa fa-check");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("rejectLabel", i0.ɵɵpipeBind1(30, 27, "general.no"))("acceptLabel", i0.ɵɵpipeBind1(31, 29, "general.yes"));
          }
        },
        dependencies: [i3.NgIf, i2$2.ɵNgNoValidate, i2$2.NgControlStatusGroup, i2$2.FormGroupDirective, i4.CapturumButtonComponent, i4$1.FormlyForm, RoleSelectorComponent, i14.ConfirmDialog, i1$2.TranslatePipe],
        styles: [".ibox-content[_ngcontent-%COMP%]   .row[_ngcontent-%COMP%]{margin:0}"]
      });
    }
  }
  return UserProfileComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// @dynamic
class UserValidator {
  /*
  * Check if user's email is already taken
  * */
  static isEmailTaken(userService, id) {
    return ctrl => {
      const options = {
        filters: [{
          field: 'email',
          value: ctrl.value,
          operator: 'equals'
        }]
      };
      if (id) {
        options.filters.push({
          field: 'id',
          value: id,
          operator: FilterMatchMode.NOT_EQUALS
        });
      }
      return userService.index(options).pipe(map(res => res.data), map(users => users.length === 0 || users.length === 1 && users.some(user => user.id === id)), catchError(err => of(true))).toPromise();
    };
  }
}
let UserFormComponent = /*#__PURE__*/(() => {
  class UserFormComponent extends CompleteBaseForm {
    constructor(translateService, utilService, apiService, changeDetectorRef) {
      super(changeDetectorRef);
      this.translateService = translateService;
      this.utilService = utilService;
      this.apiService = apiService;
      this.changeDetectorRef = changeDetectorRef;
      this.roleList = [];
      this.localesList = [];
    }
    ngAfterViewInit() {
      this.listenToFormChanges();
      this.changeDetectorRef.detectChanges();
    }
    ngOnChanges(changes) {
      if (!!this.localesList && this.localesList.length && !!this.roleList && this.roleList.length && !this.fields) {
        this.createForm();
        this.updateFormValue();
      }
    }
    createForm() {
      this.fields = [{
        type: 'input',
        key: 'name',
        props: {
          translateLabel: this.translateService.stream('user.profile.name'),
          required: true
        }
      }, {
        type: 'input',
        key: 'email',
        props: {
          translateLabel: this.translateService.stream('user.profile.email'),
          type: 'email',
          required: true,
          autocomplete: 'new-email'
        },
        validators: {
          validation: [emailValidator]
        },
        asyncValidators: {
          emailBusy: {
            expression: UserValidator.isEmailTaken(this.apiService, this.userId),
            message: this.translateService.instant('validation-errors.email-in-use')
          }
        }
      }, {
        key: 'role_ids',
        type: 'multiSelect',
        props: {
          options: this.roleList,
          styleClass: 'w-100',
          required: true,
          filter: true,
          translatePlaceholder: this.translateService.instant('placeholder.select'),
          translateLabel: this.translateService.stream('user.profile.select_role')
        }
      }, {
        key: 'locale_id',
        type: 'dropdown',
        props: {
          translateLabel: this.translateService.stream('user.profile.select_language'),
          translatePlaceholder: this.translateService.instant('placeholder.select'),
          options: this.localesList,
          required: true
        }
      }];
    }
    static {
      this.ɵfac = function UserFormComponent_Factory(t) {
        return new (t || UserFormComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(UtilService), i0.ɵɵdirectiveInject(UserService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: UserFormComponent,
        selectors: [["emc-user-form"]],
        inputs: {
          isEdit: "isEdit",
          roleList: "roleList",
          localesList: "localesList",
          userId: "userId"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => UserFormComponent),
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: forwardRef(() => UserFormComponent),
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
        decls: 1,
        vars: 1,
        consts: [[4, "ngIf"], [3, "fields", "form"]],
        template: function UserFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, UserFormComponent_ng_container_0_Template, 2, 2, "ng-container", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", (ctx.roleList == null ? null : ctx.roleList.length) && (ctx.localesList == null ? null : ctx.localesList.length));
          }
        },
        dependencies: [i3.NgIf, i4$1.FormlyForm],
        styles: ["[_nghost-%COMP%]     cap-validator{display:none}"],
        changeDetection: 0
      });
    }
  }
  return UserFormComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PasswordFormComponent = /*#__PURE__*/(() => {
  class PasswordFormComponent extends CompleteBaseForm {
    constructor(translateService, changeDetectorRef) {
      super(changeDetectorRef);
      this.translateService = translateService;
      this.changeDetectorRef = changeDetectorRef;
      this.passwordValidator = passwordValidator;
    }
    ngAfterViewInit() {
      this.listenToFormChanges();
      this.createForm();
      this.updateFormValue();
      this.changeDetectorRef.detectChanges();
    }
    listenToFormChanges() {
      this.formSubscription = this.onFormChange().pipe(delay(0)).subscribe(value => {
        this.formChanged.emit(this.form.value['passwordFields']);
      });
    }
    createForm() {
      this.fields = [{
        key: 'passwordFields',
        validators: {
          fieldMatch: {
            expression: control => {
              const value = control.value;
              return value.password_confirmation === value.password || !value.password_confirmation || !value.password;
            },
            message: this.translateService.instant('user.detail.password-mismatch.message'),
            errorPath: 'password_confirmation'
          }
        },
        fieldGroup: [{
          key: 'password',
          type: 'input',
          props: {
            type: 'password',
            translateLabel: this.translateService.stream('user.detail.password'),
            placeholder: this.translateService.instant('user.detail.password'),
            required: !this.isEdit,
            autocomplete: 'new-password'
          },
          validators: {
            validation: [this.passwordValidator]
          },
          validation: {
            messages: {
              password: (error, field) => this.translateService.instant('validation-errors.password')
            }
          }
        }, {
          key: 'password_confirmation',
          type: 'input',
          props: {
            type: 'password',
            translateLabel: this.translateService.stream('user.detail.password-confirmation'),
            placeholder: this.translateService.instant('user.detail.password-confirmation'),
            required: !this.isEdit,
            autocomplete: 'new-password'
          }
        }]
      }];
    }
    static {
      this.ɵfac = function PasswordFormComponent_Factory(t) {
        return new (t || PasswordFormComponent)(i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PasswordFormComponent,
        selectors: [["emc-password-form"]],
        inputs: {
          isEdit: "isEdit",
          passwordValidator: "passwordValidator"
        },
        features: [i0.ɵɵProvidersFeature([{
          provide: NG_VALUE_ACCESSOR,
          useExisting: forwardRef(() => PasswordFormComponent),
          multi: true
        }, {
          provide: NG_VALIDATORS,
          useExisting: forwardRef(() => PasswordFormComponent),
          multi: true
        }]), i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 2,
        consts: [[3, "fields", "form"]],
        template: function PasswordFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "formly-form", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("fields", ctx.fields)("form", ctx.form);
          }
        },
        dependencies: [i4$1.FormlyForm],
        styles: ["[_nghost-%COMP%]     cap-validator{display:none}"],
        changeDetection: 0
      });
    }
  }
  return PasswordFormComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MultiFactorFormComponent = /*#__PURE__*/(() => {
  class MultiFactorFormComponent {
    get controlMethod() {
      return this.form.get('method');
    }
    get controlKey() {
      return this.form.get('code');
    }
    constructor(twoFactorAuthService, formBuilder) {
      this.twoFactorAuthService = twoFactorAuthService;
      this.formBuilder = formBuilder;
      this.showCode = false;
      this.TwoFactorMethod = TwoFactorMethod;
      this.autoSubmit = new EventEmitter();
      this.types$ = this.twoFactorAuthService.list2faMethods();
    }
    ngOnInit() {
      this.form = this.generateForm();
    }
    changeMethodAuth(method) {
      this.form.get('code').setValue(null);
      this.showCode = method === TwoFactorMethod.google;
    }
    appInputCodeFilled() {
      this.autoSubmit.emit(this.form.value);
    }
    showAndFocusInputCode() {
      this.showCode = true;
      this.form.get('code').setValue(null);
      Promise.resolve(null).then(() => this.inputCodeComponent.focus());
    }
    generateForm() {
      return this.formBuilder.group({
        code: [null, [Validators.required, Validators.minLength(6)]],
        method: [null, Validators.required]
      });
    }
    static {
      this.ɵfac = function MultiFactorFormComponent_Factory(t) {
        return new (t || MultiFactorFormComponent)(i0.ɵɵdirectiveInject(i2$1.TwoFactorAuthService), i0.ɵɵdirectiveInject(i2$2.FormBuilder));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MultiFactorFormComponent,
        selectors: [["emc-multi-factor-form"]],
        viewQuery: function MultiFactorFormComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(CapturumInputCodeComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputCodeComponent = _t.first);
          }
        },
        outputs: {
          autoSubmit: "autoSubmit"
        },
        decls: 1,
        vars: 1,
        consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], [1, "multi-factor-form"], [1, "multi-factor-form--section"], [1, "multi-factor-form--section-title"], [1, "multi-factor-form--section-body"], ["styleClass", "w-100", "formControlName", "method", 3, "options", "placeholder", "change"], ["capTemplate", "item"], ["capTemplate", "selectedItem"], [3, "ngSwitch"], [3, "method", 4, "ngSwitchCase"], [3, "emailCodeEvent", 4, "ngSwitchCase"], [3, "smsCodeEvent", 4, "ngSwitchCase"], [1, "multi-factor-form--section-description"], [1, "input-codes"], ["formControlName", "code", 3, "valuesFilled"], [3, "method"], [3, "emailCodeEvent"], [3, "smsCodeEvent"]],
        template: function MultiFactorFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MultiFactorFormComponent_form_0_Template, 26, 23, "form", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.form);
          }
        },
        dependencies: [i3.NgIf, i3.NgSwitch, i3.NgSwitchCase, i2$2.ɵNgNoValidate, i2$2.NgControlStatus, i2$2.NgControlStatusGroup, i2$2.FormGroupDirective, i2$2.FormControlName, i4$2.CapturumTemplateDirective, i5$3.CapturumDropdownComponent, i6$2.CapturumInputCodeComponent, AuthAuthenticatorComponent, AuthEmailComponent, AuthSmsComponent, i3.AsyncPipe, i1$2.TranslatePipe],
        styles: [".multi-factor-form--section{padding-bottom:.5rem}.multi-factor-form--section-title{font-size:1.25rem;margin-bottom:.75rem}.multi-factor-form--section-description{font-size:.9rem}\n"],
        encapsulation: 2
      });
    }
  }
  return MultiFactorFormComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MultiFactorEnableFormComponent = /*#__PURE__*/(() => {
  class MultiFactorEnableFormComponent extends DestroyBase {
    get controlMethod() {
      return this.formGroup.get('method');
    }
    get controlCode() {
      return this.formGroup.get('code');
    }
    constructor(twoFactorAuthService, formBuilder) {
      super();
      this.twoFactorAuthService = twoFactorAuthService;
      this.formBuilder = formBuilder;
      this.TwoFactorMethod = TwoFactorMethod;
      this.canSelectMethod = true;
      this.autoSubmit = new EventEmitter();
      this.currentForm = new EventEmitter();
    }
    ngOnInit() {
      this.types$ = this.twoFactorAuthService.list2faMethods();
      this.formGroup = this.generateForm();
      this.updateParagraphNumbers();
      this.resetCodeWhenMethodChanges();
      this.onFormGroupChange();
    }
    resetCodeWhenMethodChanges() {
      this.controlMethod.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.resetCode();
        this.updateParagraphNumbers();
      });
    }
    appInputCodeFilled() {
      this.autoSubmit.emit(this.formGroup.value);
    }
    updateParagraphNumbers() {
      const selectionOffset = this.canSelectMethod ? 1 : 0;
      const authMethodOffset = this.controlMethod.value === TwoFactorMethod.google || this.selectedMethod === TwoFactorMethod.microsoft ? 2 : 1;
      this.paragraphNumbers = {
        'method': selectionOffset,
        'description': selectionOffset + 1,
        'code': selectionOffset + authMethodOffset + 1
      };
    }
    showAndFocusInputCode() {
      this.resetCode();
      Promise.resolve(null).then(() => {
        this.inputCodeComponent.focus();
      });
    }
    resetCode() {
      this.controlCode.setValue(null);
    }
    generateForm() {
      return this.formBuilder.group({
        code: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
        method: [this.selectedMethod, Validators.required]
      });
    }
    onFormGroupChange() {
      this.formGroup.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.currentForm.emit({
          code: this.formGroup.value.code,
          method: this.formGroup.value.method,
          isValid: this.formGroup.valid
        });
      });
    }
    static {
      this.ɵfac = function MultiFactorEnableFormComponent_Factory(t) {
        return new (t || MultiFactorEnableFormComponent)(i0.ɵɵdirectiveInject(i2$1.TwoFactorAuthService), i0.ɵɵdirectiveInject(i2$2.FormBuilder));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MultiFactorEnableFormComponent,
        selectors: [["emc-multi-factor-enable-form"]],
        viewQuery: function MultiFactorEnableFormComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(CapturumInputCodeComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputCodeComponent = _t.first);
          }
        },
        inputs: {
          canSelectMethod: "canSelectMethod",
          selectedMethod: "selectedMethod"
        },
        outputs: {
          autoSubmit: "autoSubmit",
          currentForm: "currentForm"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], [1, "multi-factor-form"], ["class", "multi-factor-form--section", 4, "ngIf"], [1, "multi-factor-form--section"], [1, "multi-factor-form--section-title"], [1, "multi-factor-form--section-description"], ["formControlName", "code", 3, "valuesFilled"], [1, "multi-factor-form--section-body"], ["styleClass", "w-100", "formControlName", "method", 3, "options", "placeholder"], ["capTemplate", "item"], ["capTemplate", "selectedItem"], [3, "ngSwitch"], [3, "paragraphNumbers", "method", "emailCodeEvent", 4, "ngSwitchCase"], [3, "paragraphNumbers", "method", "smsCodeEvent", 4, "ngSwitchCase"], [3, "paragraphNumbers", "method", 4, "ngSwitchDefault"], [3, "paragraphNumbers", "method", "emailCodeEvent"], [3, "paragraphNumbers", "method", "smsCodeEvent"], [3, "paragraphNumbers", "method"]],
        template: function MultiFactorEnableFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MultiFactorEnableFormComponent_form_0_Template, 14, 12, "form", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.formGroup);
          }
        },
        dependencies: [i3.NgIf, i3.NgSwitch, i3.NgSwitchCase, i3.NgSwitchDefault, i2$2.ɵNgNoValidate, i2$2.NgControlStatus, i2$2.NgControlStatusGroup, i2$2.FormGroupDirective, i2$2.FormControlName, i4$2.CapturumTemplateDirective, i5$3.CapturumDropdownComponent, i6$2.CapturumInputCodeComponent, AuthAuthenticatorComponent, AuthEmailComponent, AuthSmsComponent, i3.AsyncPipe, i1$2.TranslatePipe],
        styles: [".multi-factor-form--section-title{font-size:1.25rem;margin-bottom:.5rem;font-weight:600}.multi-factor-form--section-description{font-size:.9rem;margin-bottom:.75rem}.multi-factor-form--section{margin:1rem 0}.multi-factor-form--section:first-of-type{margin-top:0}.multi-factor-form--section:last-of-type{margin-bottom:0}\n"],
        encapsulation: 2
      });
    }
  }
  return MultiFactorEnableFormComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MultiFactorDisableFormComponent = /*#__PURE__*/(() => {
  class MultiFactorDisableFormComponent extends DestroyBase {
    get controlMethod() {
      return this.formGroup.get('method');
    }
    get controlCode() {
      return this.formGroup.get('code');
    }
    constructor(twoFactorAuthService, formBuilder) {
      super();
      this.twoFactorAuthService = twoFactorAuthService;
      this.formBuilder = formBuilder;
      this.autoSubmit = new EventEmitter();
      this.currentForm = new EventEmitter();
    }
    ngOnInit() {
      this.types$ = this.twoFactorAuthService.list2faMethods();
      this.formGroup = this.generateForm();
      this.updateParagraphNumbers();
      this.onFormGroupChange();
    }
    appInputCodeFilled() {
      this.autoSubmit.emit(this.formGroup.value);
    }
    updateParagraphNumbers() {
      this.paragraphNumbers = {
        'code': 1
      };
    }
    showAndFocusInputCode() {
      this.resetCode();
      Promise.resolve(null).then(() => {
        this.inputCodeComponent.focus();
      });
    }
    resetCode() {
      this.controlCode.setValue(null);
    }
    generateForm() {
      return this.formBuilder.group({
        code: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
        method: [this.selectedMethod, Validators.required]
      });
    }
    onFormGroupChange() {
      this.formGroup.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.currentForm.emit({
          code: this.formGroup.value.code,
          method: this.formGroup.value.method,
          isValid: this.formGroup.valid
        });
      });
    }
    static {
      this.ɵfac = function MultiFactorDisableFormComponent_Factory(t) {
        return new (t || MultiFactorDisableFormComponent)(i0.ɵɵdirectiveInject(i2$1.TwoFactorAuthService), i0.ɵɵdirectiveInject(i2$2.FormBuilder));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MultiFactorDisableFormComponent,
        selectors: [["emc-multi-factor-disable-form"]],
        viewQuery: function MultiFactorDisableFormComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(CapturumInputCodeComponent, 5);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputCodeComponent = _t.first);
          }
        },
        inputs: {
          selectedMethod: "selectedMethod"
        },
        outputs: {
          autoSubmit: "autoSubmit",
          currentForm: "currentForm"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 1,
        vars: 1,
        consts: [[3, "formGroup", 4, "ngIf"], [3, "formGroup"], [1, "multi-factor-form"], [1, "multi-factor-form--section"], [1, "multi-factor-form--section-title"], [1, "multi-factor-form--section-description"], ["formControlName", "code", 3, "valuesFilled"]],
        template: function MultiFactorDisableFormComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MultiFactorDisableFormComponent_form_0_Template, 10, 8, "form", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.formGroup);
          }
        },
        dependencies: [i3.NgIf, i2$2.ɵNgNoValidate, i2$2.NgControlStatus, i2$2.NgControlStatusGroup, i2$2.FormGroupDirective, i2$2.FormControlName, i6$2.CapturumInputCodeComponent, i1$2.TranslatePipe],
        styles: [_c3],
        encapsulation: 2
      });
    }
  }
  return MultiFactorDisableFormComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let MultiFactorDialogComponent = /*#__PURE__*/(() => {
  class MultiFactorDialogComponent {
    keyEvent(event) {
      if (event.key === 'Enter') {
        this.submitDialog();
      }
    }
    constructor(twoFactorAuthService, dynamicDialogRef, dynamicDialogConfig, translateService, toastService) {
      this.twoFactorAuthService = twoFactorAuthService;
      this.dynamicDialogRef = dynamicDialogRef;
      this.dynamicDialogConfig = dynamicDialogConfig;
      this.translateService = translateService;
      this.toastService = toastService;
      this.code = '';
    }
    ngOnInit() {
      this.isEnabled = this.dynamicDialogConfig.data.isEnabled ?? false;
      this.selectedMethod = this.dynamicDialogConfig.data.selectedMethod ?? null;
      this.canSelectMethod = this.dynamicDialogConfig.data.showSelectMethod ?? true;
      this.submitStyleClass = this.dynamicDialogConfig.data.submitStyleClass ?? 'primary w-100';
      if (this.isEnabled) {
        this.initDisableTimeout();
      }
    }
    updateCode({
      code,
      method,
      isValid
    }) {
      this.code = code;
      this.selectedMethod = method;
      this.isValidFormGroup = isValid;
    }
    closeDialog() {
      this.dynamicDialogRef.close();
    }
    submitDialog() {
      if (!this.isValidFormGroup) {
        return;
      }
      if (this.dynamicDialogConfig.data.isEnabled) {
        this.confirmDisable();
      } else {
        this.confirmEnable();
      }
    }
    initDisableTimeout() {
      this.twoFactorAuthService.requestDisable().pipe(take(1)).subscribe();
    }
    confirmEnable() {
      this.twoFactorAuthService.confirm2fa(this.selectedMethod, this.code).pipe(take(1)).subscribe(({
        success
      }) => {
        this.showToast(success);
        this.dynamicDialogRef.close({
          currentMethod: this.selectedMethod,
          isEnabled: success ? !this.isEnabled : this.isEnabled,
          isSuccess: success
        });
      });
    }
    confirmDisable() {
      this.twoFactorAuthService.confirmDisable(this.selectedMethod, this.code).pipe(take(1)).subscribe(({
        success
      }) => {
        this.showToast(success);
        this.dynamicDialogRef.close({
          currentMethod: null,
          isEnabled: success ? !this.isEnabled : this.isEnabled,
          isSuccess: success
        });
      });
    }
    showToast(success) {
      if (!this.dynamicDialogConfig.data.disableToastNotifications) {
        const responseStatusKey = success ? 'success' : 'error';
        const enableStatusKey = this.isEnabled ? 'disable' : 'enable';
        const defaultTitleKey = `toast.${responseStatusKey}.title`;
        const defaultMessageKey = `auth.2fa.toast.${enableStatusKey}.${responseStatusKey}`;
        const toastTitle = success ? this.dynamicDialogConfig.data.toastSuccesTitle ?? this.translateService.instant(defaultTitleKey) : this.dynamicDialogConfig.data.toastErrorTitle ?? this.translateService.instant(defaultTitleKey);
        const toastMessage = success ? this.dynamicDialogConfig.data.toastSuccesMessage ?? this.translateService.instant(defaultMessageKey) : this.dynamicDialogConfig.data.toastErrorMessage ?? this.translateService.instant(defaultMessageKey);
        this.toastService.success(toastTitle, toastMessage);
      }
    }
    static {
      this.ɵfac = function MultiFactorDialogComponent_Factory(t) {
        return new (t || MultiFactorDialogComponent)(i0.ɵɵdirectiveInject(i2$1.TwoFactorAuthService), i0.ɵɵdirectiveInject(i5.DynamicDialogRef), i0.ɵɵdirectiveInject(i5.DynamicDialogConfig), i0.ɵɵdirectiveInject(i1$2.TranslateService), i0.ɵɵdirectiveInject(i4$2.ToastService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: MultiFactorDialogComponent,
        selectors: [["emc-multi-factor-dialog"]],
        hostBindings: function MultiFactorDialogComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("keyup", function MultiFactorDialogComponent_keyup_HostBindingHandler($event) {
              return ctx.keyEvent($event);
            }, false, i0.ɵɵresolveWindow);
          }
        },
        decls: 8,
        vars: 10,
        consts: [[3, "canSelectMethod", "selectedMethod", "currentForm", 4, "ngIf"], [3, "selectedMethod", "currentForm", 4, "ngIf"], [1, "dialog-footer", "d-flex", "justify-content-between"], ["styleClass", "secondary mr-4", 3, "label", "click"], [1, "flex-grow-1"], [3, "styleClass", "disabled", "label", "click"], [3, "canSelectMethod", "selectedMethod", "currentForm"], [3, "selectedMethod", "currentForm"]],
        template: function MultiFactorDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, MultiFactorDialogComponent_emc_multi_factor_enable_form_0_Template, 1, 2, "emc-multi-factor-enable-form", 0);
            i0.ɵɵtemplate(1, MultiFactorDialogComponent_emc_multi_factor_disable_form_1_Template, 1, 1, "emc-multi-factor-disable-form", 1);
            i0.ɵɵelementStart(2, "div", 2)(3, "cap-button", 3);
            i0.ɵɵlistener("click", function MultiFactorDialogComponent_Template_cap_button_click_3_listener() {
              return ctx.closeDialog();
            });
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 4)(6, "cap-button", 5);
            i0.ɵɵlistener("click", function MultiFactorDialogComponent_Template_cap_button_click_6_listener() {
              return ctx.submitDialog();
            });
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.isEnabled);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngIf", ctx.isEnabled);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("label", i0.ɵɵpipeBind1(4, 6, "button.cancel"));
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("styleClass", ctx.submitStyleClass)("disabled", !ctx.isValidFormGroup)("label", i0.ɵɵpipeBind1(7, 8, "button.submit"));
          }
        },
        dependencies: [i3.NgIf, i4.CapturumButtonComponent, MultiFactorEnableFormComponent, MultiFactorDisableFormComponent, i1$2.TranslatePipe],
        styles: [".dialog-footer{padding-top:1em;margin-top:1em;border-top:1px solid #ddd}\n"],
        encapsulation: 2
      });
    }
  }
  return MultiFactorDialogComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let UserModule = /*#__PURE__*/(() => {
  class UserModule {
    static {
      this.ɵfac = function UserModule_Factory(t) {
        return new (t || UserModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: UserModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, SharedModule, TranslateModule, RouterModule, CapturumInputModule, CapturumInputCodeModule, KeyFilterModule, CapturumButtonModule, ProgressSpinnerModule]
      });
    }
  }
  return UserModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let IndexedDbGuard = /*#__PURE__*/(() => {
  class IndexedDbGuard {
    constructor(domainService, config, authService) {
      this.domainService = domainService;
      this.config = config;
      this.authService = authService;
    }
    /**
     * Make sure the store is created before accessing the route
     *
     * @param route - the activated route
     * @param state - the current state of the router
     * @return Observable<boolean>
     */
    canActivate(route, state) {
      return new Observable(observer => {
        let userId;
        if (this.config.userSpecificDb !== false) {
          const user = this.authService.getUser();
          if (user && user.id) {
            userId = user.id;
          }
        }
        this.domainService.createStore(userId).then(() => {
          observer.next(true);
          observer.complete();
        });
      });
    }
    static {
      this.ɵfac = function IndexedDbGuard_Factory(t) {
        return new (t || IndexedDbGuard)(i0.ɵɵinject(IndexedDbService), i0.ɵɵinject(CompleteConfig), i0.ɵɵinject(i2$1.AuthService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: IndexedDbGuard,
        factory: IndexedDbGuard.ɵfac
      });
    }
  }
  return IndexedDbGuard;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var SyncErrorType = /*#__PURE__*/function (SyncErrorType) {
  SyncErrorType["VALIDATION"] = "validation";
  SyncErrorType["EXCEPTION"] = "exception";
  return SyncErrorType;
}(SyncErrorType || {});
let SyncService = /*#__PURE__*/(() => {
  class SyncService {
    constructor(apiService, coreConfig, indexedDBService) {
      this.apiService = apiService;
      this.coreConfig = coreConfig;
      this.indexedDBService = indexedDBService;
      this.models = [];
      if (this.coreConfig.syncConfig) {
        this.models = this.coreConfig.syncConfig.syncModels;
      }
    }
    /**
     * Send the data to the backend and store the result
     */
    sync(deleteResourcesAfterSync = true) {
      return this.retrieveSyncData().pipe(switchMap(({
        data,
        meta
      }) => this.syncApiPost(data, meta)), switchMap(response => this.storeResponse(response, deleteResourcesAfterSync)));
    }
    /**
     * Retrieve the data from the indexeddb based on the given models
     */
    retrieveSyncData() {
      const data = {};
      const meta = {
        include: {}
      };
      const store = this.indexedDBService.getStore();
      const tables = this.models.map(model => {
        return IndexedDbModel.store.table(new model.modelClass({}).table);
      });
      return new Observable(observer => {
        IndexedDbModel.store.transaction('rw', tables, async () => {
          for (const model of this.models) {
            const table = new model.modelClass({}).table;
            data[table] = await store.table(table).where({
              is_changed: 1
            }).or('_deleted').equals(1).toArray();
            meta.include[table] = model.include.join(',');
          }
        }).then(() => {
          observer.next({
            data,
            meta
          });
        }).catch(error => {
          observer.error(error);
        }).finally(() => {
          observer.complete();
        });
      });
    }
    /**
     * Store the response in the indexeddb
     *
     * @param response - response of the sync call
     * @param deleteResourcesAfterSync - define if the resources should be deleted after a successfull sync
     */
    storeResponse(response, deleteResourcesAfterSync) {
      return new Observable(observer => {
        IndexedDbModel.store.transaction('rw', this.getTables(), async () => {
          if (deleteResourcesAfterSync) {
            for (const {
              modelClass
            } of this.models) {
              if (response.hasOwnProperty(new modelClass({}).table) && response[new modelClass({}).table].hasOwnProperty('errors')) {
                await modelClass.query().where('id').noneOf(response[new modelClass({}).table].errors.map(error => error.data.id)).delete();
              }
            }
          }
        }).then(() => {
          observer.next(response);
        }).catch(error => {
          observer.error(error);
        }).finally(() => observer.complete());
      });
    }
    /**
     * Retrieve all file from files table which are changed or deleted and send those to the backend
     */
    syncFiles() {
      return new Observable(observer => {
        const requests = [];
        FileIndexedDbModel.query().where({
          _changed: 1
        }).or('_deleted').equals(1).toArray().then(fileRecords => {
          if (fileRecords.length === 0) {
            observer.next();
            observer.complete();
            return;
          }
          for (const file of fileRecords) {
            const fileModel = new FileIndexedDbModel({
              ...file
            }).getData();
            const base64 = btoa(new Uint8Array(file.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
            const request = this.syncApiFilePost(fileModel.relatedTable, fileModel.relatedId, {
              id: file.id,
              data: base64,
              mimetype: fileModel.mime_type,
              filename: fileModel.filename,
              _deleted: fileModel._deleted
            }).pipe(map(response => response.data), catchError(error => of(error)));
            requests.push(request);
          }
          forkJoin(requests).subscribe(responses => {
            let errors = responses.filter(response => response.error).map(error => error.id);
            const successResponses = responses.filter(response => !response.error);
            for (const response of successResponses) {
              for (const table in response) {
                if (response.hasOwnProperty(table)) {
                  for (const id in response[table]) {
                    if (response[table][id].errors.length > 0) {
                      errors = errors.concat(response[table][id].errors.map(error => error.data.id));
                    }
                  }
                }
              }
            }
            FileIndexedDbModel.query().where('id').noneOf(errors).delete().then(() => {
              observer.next({
                responses
              });
              observer.complete();
            }).catch(error => {
              observer.error(error);
            });
            observer.next({
              responses
            });
            observer.complete();
          });
        }).catch(error => {
          observer.error(error);
        });
      });
    }
    /**
     * Send sync data to backend
     *
     * @param data - the data to be synced
     * @param meta - this defines what realtions are included
     */
    syncApiPost(data, meta) {
      return this.apiService.apiHttp.post(this.coreConfig.syncConfig.syncUrl, {
        data,
        _meta: meta
      }).pipe(map(response => response.data));
    }
    /**
     * Send the file to the backend
     *
     * @param table - the table the file belongs to
     * @param id - the id of the entity the file belongs to
     * @param data - the file itself as base64
     */
    syncApiFilePost(table, id, data) {
      const postBody = {
        [table]: {
          [id]: [data]
        }
      };
      return this.apiService.apiHttp.post(`${this.coreConfig.syncConfig.syncUrl}/file`, {
        data: postBody
      }).pipe(map(response => response));
    }
    /**
     * Retrieve tables that need to be synced
     */
    getTables() {
      return this.models.map(model => {
        return IndexedDbModel.store.table(new model.modelClass({}).table);
      });
    }
    static {
      this.ɵfac = function SyncService_Factory(t) {
        return new (t || SyncService)(i0.ɵɵinject(i1.ApiService), i0.ɵɵinject(CompleteConfig), i0.ɵɵinject(IndexedDbService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SyncService,
        factory: SyncService.ɵfac
      });
    }
  }
  return SyncService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SettingResolver = /*#__PURE__*/(() => {
  class SettingResolver {
    constructor(settingService) {
      this.settingService = settingService;
    }
    /**
     * Make sure the settings are loaded before accessing the route
     */
    resolve(route, state) {
      return this.settingService.loadAll();
    }
    static {
      this.ɵfac = function SettingResolver_Factory(t) {
        return new (t || SettingResolver)(i0.ɵɵinject(SettingService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SettingResolver,
        factory: SettingResolver.ɵfac
      });
    }
  }
  return SettingResolver;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CompleteResolver = /*#__PURE__*/(() => {
  class CompleteResolver {
    constructor(baseDataResolver, moduleResolver, settingResolver, translationResolver, loadingService, translateService, coreConfig, permissionResolver) {
      this.baseDataResolver = baseDataResolver;
      this.moduleResolver = moduleResolver;
      this.settingResolver = settingResolver;
      this.translationResolver = translationResolver;
      this.loadingService = loadingService;
      this.translateService = translateService;
      this.coreConfig = coreConfig;
      this.permissionResolver = permissionResolver;
    }
    resolve(route, state) {
      this.loadingService.toggleLoading(true, this.coreConfig.useTranslatedLoaderText ? this.translateService.instant(this.coreConfig.loaderText) : this.coreConfig.loaderText, this.coreConfig.loaderImage, 'complete-resolver-loader');
      return forkJoin([this.baseDataResolver.resolve(route, state), this.moduleResolver.resolve(route, state), this.settingResolver.resolve(route, state), this.translationResolver.resolve(route, state), this.permissionResolver.resolve(route, state)]).pipe(finalize(() => this.loadingService.hideLoader()), catchError(() => {
        this.loadingService.hideLoader();
        return of(false);
      }), map(() => {
        this.loadingService.hideLoader();
        return true;
      }));
    }
    static {
      this.ɵfac = function CompleteResolver_Factory(t) {
        return new (t || CompleteResolver)(i0.ɵɵinject(BaseDataResolver), i0.ɵɵinject(ModuleResolver), i0.ɵɵinject(SettingResolver), i0.ɵɵinject(TranslationResolver), i0.ɵɵinject(i5$1.LoadingService), i0.ɵɵinject(i1$2.TranslateService), i0.ɵɵinject(CompleteConfig), i0.ɵɵinject(PermissionResolver));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CompleteResolver,
        factory: CompleteResolver.ɵfac
      });
    }
  }
  return CompleteResolver;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PublicTranslationService = /*#__PURE__*/(() => {
  class PublicTranslationService extends TranslationService {
    constructor() {
      super(...arguments);
      this.endpoint = 'translation';
    }
    static {
      this.ɵfac = /* @__PURE__ */function () {
        let ɵPublicTranslationService_BaseFactory;
        return function PublicTranslationService_Factory(t) {
          return (ɵPublicTranslationService_BaseFactory || (ɵPublicTranslationService_BaseFactory = i0.ɵɵgetInheritedFactory(PublicTranslationService)))(t || PublicTranslationService);
        };
      }();
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PublicTranslationService,
        factory: PublicTranslationService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return PublicTranslationService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PublicTranslationResolver = /*#__PURE__*/(() => {
  class PublicTranslationResolver {
    constructor(publicTranslationService) {
      this.publicTranslationService = publicTranslationService;
    }
    /**
     * Make sure the translations are loaded before accessing the route
     */
    resolve(route, state) {
      return this.publicTranslationService.loadTranslations();
    }
    static {
      this.ɵfac = function PublicTranslationResolver_Factory(t) {
        return new (t || PublicTranslationResolver)(i0.ɵɵinject(PublicTranslationService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: PublicTranslationResolver,
        factory: PublicTranslationResolver.ɵfac
      });
    }
  }
  return PublicTranslationResolver;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ConnectivityService = /*#__PURE__*/(() => {
  class ConnectivityService {
    isOnline() {
      return merge(fromEvent(window, 'offline').pipe(map(() => false)), fromEvent(window, 'online').pipe(map(() => true)), new Observable(sub => {
        sub.next(navigator.onLine);
      }));
    }
    static {
      this.ɵfac = function ConnectivityService_Factory(t) {
        return new (t || ConnectivityService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ConnectivityService,
        factory: ConnectivityService.ɵfac
      });
    }
  }
  return ConnectivityService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const uuid = v4;
/**
 * QueryOptions for sorting and filtering indexedDB based query's
 */
class QueryOptions {
  constructor(options = {}) {
    this.usePaging = true;
    this.pageSize = 10;
    this.pageIndex = 0;
    // Sorting variables
    this.sortColumn = null;
    this.sortOrder = 'desc';
    // Filtering variables
    // columns array contains array of object { name: , filter: , filterMode: }
    this.columns = [];
    Object.assign(this, options);
  }
}
let DataService = /*#__PURE__*/(() => {
  class DataService {
    constructor(api, indexedDbService) {
      this.api = api;
      this.indexedDbService = indexedDbService;
      this.indexedDB = this.indexedDbService.store;
      this.allowBackend = false;
    }
    /**
     * Get data from API or indexedDB with additional filters and sorting.
     *
     * @param tableName indexedDB table name
     * @param options QueryOptions for indexedDB usage
     * @param url URl of API call in case of backend connection
     */
    async get(tableName, options, url) {
      this.indexedDB = this.indexedDbService.store;
      if (!this.allowBackend) {
        this.result = this.indexedDB.table(tableName);
        const items = await this.result.toArray();
        // Init each model for custom processing
        for (const model of items) {
          await model.init();
        }
        this.result = items;
        this.processSearching(options);
        this.processSorting(options);
        this.paginate(options);
        return this.result;
      } else {
        // Use API service
      }
    }
    /**
     * Get data indexedDB by id
     *
     * @param tableName indexedDB table name
     * @param id ID number
     */
    async getById(tableName, id) {
      this.indexedDB = this.indexedDbService.store;
      const item = await this.indexedDB.table(tableName).get(id);
      if (!item) {
        return undefined;
      }
      item.init();
      return item;
    }
    /**
     * Get data indexedDB by id
     *
     * @param tableName indexedDB table name
     * @param column indexedDB columnName
     * @param value indexedDB columnValue
     */
    async getBy(tableName, column, value) {
      this.indexedDB = this.indexedDbService.store;
      const filter = {};
      filter[column] = value;
      const items = await this.indexedDB.table(tableName).where(filter).toArray();
      // Init each model for custom processing
      for (const model of items) {
        await model.init();
      }
      return items;
    }
    /**
     * Perform a lookup in de database by given criteria and return first match
     * http://dexie.org/docs/Table/Table.get()
     *
     * @param tableName indexedDB table name
     * @param criteria indexedDB search criteria
     * @param url Url
     */
    async getWhere(tableName, criteria, url) {
      this.indexedDB = this.indexedDbService.store;
      if (!this.allowBackend) {
        let item = await this.indexedDB.table(tableName).get(criteria).then(data => item = data);
        return item;
      } else {
        // Use API service
      }
    }
    /**
     * Count the number of total records with the applied filters
     *
     * @param tableName indexedDB table name
     * @param options QueryOptions for indexedDB usage
     * @param url URl of API call in case of backend connection
     * @return Promise<number>
     */
    async count(tableName, options, url) {
      this.indexedDB = this.indexedDbService.store;
      if (this.allowBackend) {
        return 0;
      }
      this.result = this.indexedDB.table(tableName);
      const items = await this.result.toArray();
      // Init each model for custom processing
      for (const model of items) {
        await model.init();
      }
      this.result = items;
      this.processSearching(options);
      this.processSorting(options);
      return this.result.length;
    }
    /**
     * Create or update object
     *
     * @param tableName indexedDB table name
     * @param object the object to be written to the indexedDB table
     * @return Promise<any>
     */
    async createOrUpdate(tableName, object) {
      this.indexedDB = this.indexedDbService.store;
      if (!object) {
        return;
      }
      if (!this.allowBackend) {
        if (!object.id) {
          object.id = uuid();
        }
        return await this.indexedDB.table(tableName).put(object);
      } else {
        // Use API service
      }
    }
    /**
     * Add object
     *
     * @param tableName indexedDB table name
     * @param object the object to be written to the indexedDB table
     * @return Promise<any>
     */
    async add(tableName, object) {
      this.indexedDB = this.indexedDbService.store;
      if (!object) {
        return;
      }
      if (!this.allowBackend) {
        return await this.indexedDB.table(tableName).add(object);
      } else {
        // Use API service
      }
    }
    /**
     * Update object
     *
     * @param tableName indexedDB table name
     * @param id primary key id
     * @param attributes object with attributes which need to be updated
     * @return Promise<any>
     */
    async update(tableName, id, attributes) {
      this.indexedDB = this.indexedDbService.store;
      if (!this.allowBackend) {
        return await this.indexedDB.table(tableName).update(id, attributes);
      } else {
        // Use API service
      }
    }
    /**
     * Delete object
     *
     * @param tableName indexedDB table name
     * @param id primary key id
     * @return Promise<void>
     */
    async delete(tableName, id) {
      this.indexedDB = this.indexedDbService.store;
      if (!this.allowBackend) {
        return await this.indexedDB.table(tableName).delete(id);
      } else {
        // Use API service
      }
    }
    /**
     * Process available sorting
     *
     * @param options QueryOptions
     */
    processSorting(options) {
      this.indexedDB = this.indexedDbService.store;
      if (options.sortColumn) {
        this.result.sort((a, b) => {
          return a[options.sortColumn] > b[options.sortColumn];
        });
        if (options.sortOrder !== 'asc') {
          this.result = this.result.reverse();
        }
      }
    }
    /**
     * Paginate result
     *
     * @param options QueryOptions
     */
    paginate(options) {
      if (options.usePaging) {
        const start = options.pageIndex * options.pageSize;
        const end = start + options.pageSize;
        this.result = this.result.slice(start, end);
      }
    }
    processSearching(options) {
      if (!options || options.columns.length === 0) {
        return;
      }
      // Do not process if no filters are given
      if (!options.globalFilter && options.columns.find(column => column.filter !== undefined) === undefined) {
        return;
      }
      this.result = this.result.filter(record => {
        let include = false;
        options.columns.forEach(column => {
          // Skip if no filters are set
          if (!options.globalFilter && !column.filter) {
            return;
          }
          if (!record[column.name]) {
            return;
          }
          if (options.globalFilter && ('' + record[column.name]).includes(options.globalFilter)) {
            include = true;
          }
          if (column.filter && ('' + record[column.name]).includes(column.filter)) {
            include = true;
          }
        });
        return include;
      });
    }
    static {
      this.ɵfac = function DataService_Factory(t) {
        return new (t || DataService)(i0.ɵɵinject(i1.ApiHttpService), i0.ɵɵinject(IndexedDbService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: DataService,
        factory: DataService.ɵfac
      });
    }
  }
  return DataService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class User {}
let CompleteModule = /*#__PURE__*/(() => {
  class CompleteModule {
    static forRoot(config, ngxPermissionService, module) {
      return {
        ngModule: CompleteModule,
        providers: [IndexedDbService, IndexedDbGuard, TenantService, SettingService, BaseDataKeyService, BaseDataValueService, TranslationService, CompleteConfigService, BaseDataService, LocaleService, ModuleService, PermissionService, RoleService, UserService, UtilService, SyncService, CompleteResolver, TranslationResolver, BaseDataResolver, SettingResolver, ModuleResolver, PermissionResolver, PublicTranslationResolver, PublicSettingResolver, ConnectivityService, DataService, {
          provide: CompleteConfig,
          useValue: {
            ...new CompleteConfig(),
            ...config
          }
        }, {
          provide: NgxPermissionsService,
          useClass: ngxPermissionService || NgxPermissionsService
        }, {
          provide: NgxPermissionsModule,
          useValue: module
        }, {
          provide: BaseDataService,
          useClass: config.baseDataService || BaseDataService
        }, {
          provide: BaseDataValueService,
          useClass: config.baseDataValueService || BaseDataValueService
        }, {
          provide: BaseDataKeyService,
          useClass: config.baseDataKeyService || BaseDataKeyService
        }, {
          provide: TranslationKeyService,
          useClass: config.translateKeyService || TranslationKeyService
        }, {
          provide: PermissionService,
          useClass: config.permissionService || PermissionService
        }, {
          provide: ModuleService,
          useClass: config.moduleService || ModuleService
        }, {
          provide: SettingService,
          useClass: config.settingService || SettingService
        }]
      };
    }
    static {
      this.ɵfac = function CompleteModule_Factory(t) {
        return new (t || CompleteModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CompleteModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        providers: [NgxPermissionsGuard],
        imports: [SharedModule, CommonModule, IndexedDbModule, PermissionModule, RouterModule, NgxPermissionsModule.forChild(), TranslateModule, CompleteRoutingModule, BaseDataModule, RoleModule, SettingModule, TenantModule, TranslationModule, UserModule]
      });
    }
  }
  return CompleteModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class Role {}
class SettingApiModel {}
let ModelLogDiffPipe = /*#__PURE__*/(() => {
  class ModelLogDiffPipe {
    constructor(datePipe) {
      this.datePipe = datePipe;
    }
    transform(value, dateFormat) {
      if (isNaN(Date.parse(value))) {
        return value;
      }
      return this.datePipe.transform(value, dateFormat);
    }
    static {
      this.ɵfac = function ModelLogDiffPipe_Factory(t) {
        return new (t || ModelLogDiffPipe)(i0.ɵɵdirectiveInject(i3.DatePipe, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "cacModelLogDiff",
        type: ModelLogDiffPipe,
        pure: true
      });
    }
  }
  return ModelLogDiffPipe;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModelLogTimelineComponent = /*#__PURE__*/(() => {
  class ModelLogTimelineComponent {
    constructor(cdr, keyValuePipe) {
      this.cdr = cdr;
      this.keyValuePipe = keyValuePipe;
      /**
       * The translation key of the title to be displayed
       */
      this.title = 'model-log.title';
      /**
       * The date format to be used in the body of the timeline item
       */
      this.dateFormat = 'dd-MM-yyyy HH:mm';
      /**
       * The date format to be used in the header of the timeline item
       */
      this.headerDateFormat = 'dd - MM - yyyy @ HH:mm';
      /**
       * The translation key to use for the empty results message when there are no results
       */
      this.emptyResultsTranslationKey = 'table.no_results';
      this.originalOrder = (a, b) => {
        return 0;
      };
    }
    ngOnChanges(changes) {
      if (changes?.items?.previousValue !== changes?.items?.currentValue) {
        this.historyItems = this.transformItems(changes.items.currentValue);
        this.historyItemsArray = this.keyValuePipe.transform(this.historyItems);
      }
    }
    ngAfterViewInit() {
      this.templates.forEach(template => {
        switch (template.getType()) {
          case 'header':
            this.headerTemplate = template.template;
            break;
          case 'body':
            this.bodyTemplate = template.template;
            break;
          case 'empty-results':
            this.emptyResultsTemplate = template.template;
            break;
          default:
            break;
        }
        this.cdr.detectChanges();
      });
    }
    trackByIndex(index, item) {
      return index;
    }
    transformItems(items) {
      const historyItems = {};
      if (items) {
        for (const dateTime of Object.keys(items)) {
          let hasDiff = false;
          const modelLogs = items[dateTime].map(item => {
            item.entity_key = this.getEntityKey(item.model_loggable_type);
            if (!item.action) {
              const newModel = JSON.parse(item.new_model);
              item.action = item.original_model ? 'updated' : 'created';
            }
            if (Object.keys(item.diffs).length) {
              hasDiff = true;
            }
            return item;
          });
          historyItems[dateTime] = {
            showDetails: false,
            hasDiff: hasDiff,
            modelLogs: modelLogs
          };
        }
      }
      return historyItems;
    }
    getEntityKey(modelType) {
      const stringParts = modelType.split('\\');
      return stringParts[stringParts.length - 1];
    }
    static {
      this.ɵfac = function ModelLogTimelineComponent_Factory(t) {
        return new (t || ModelLogTimelineComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i3.KeyValuePipe));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ModelLogTimelineComponent,
        selectors: [["emc-model-log-timeline"]],
        contentQueries: function ModelLogTimelineComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, CapturumTemplateDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
          }
        },
        inputs: {
          items: "items",
          title: "title",
          headerTemplate: "headerTemplate",
          bodyTemplate: "bodyTemplate",
          emptyResultsTemplate: "emptyResultsTemplate",
          dateFormat: "dateFormat",
          headerDateFormat: "headerDateFormat",
          translationKeyPrefix: "translationKeyPrefix",
          emptyResultsTranslationKey: "emptyResultsTranslationKey"
        },
        features: [i0.ɵɵProvidersFeature([KeyValuePipe]), i0.ɵɵNgOnChangesFeature],
        decls: 5,
        vars: 2,
        consts: [[4, "ngIf", "ngIfElse"], ["defaultBody", ""], ["emptyMessage", ""], [1, "history"], [1, "timeline"], [4, "ngFor", "ngForOf", "ngForTrackBy"], [4, "ngIf"], [1, "timeline__card"], ["class", "timeline__content", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "timeline__content"], [1, "timeline__title"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["defaultTitle", ""], [1, "timeline__body", "mt-2"], [1, "timeline__created"], [1, "body"], ["class", "row body-row", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "row", "body-row"], [1, "row"], [1, "col-md-6", "semi-bold", "dont-break-out"], [1, "col-md-6", "dont-break-out"], [1, "col-md-6", "semi-bold", "dont-break-out", "diff-value"], [1, "strikethrough"], [1, "timeline__no-results"]],
        template: function ModelLogTimelineComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ModelLogTimelineComponent_ng_container_0_Template, 4, 2, "ng-container", 0);
            i0.ɵɵtemplate(1, ModelLogTimelineComponent_ng_template_1_Template, 1, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵtemplate(3, ModelLogTimelineComponent_ng_template_3_Template, 3, 3, "ng-template", null, 2, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const _r3 = i0.ɵɵreference(4);
            i0.ɵɵproperty("ngIf", ctx.historyItemsArray && ctx.historyItemsArray.length)("ngIfElse", ctx.emptyResultsTemplate || _r3);
          }
        },
        dependencies: [i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i3.LowerCasePipe, i3.DatePipe, i3.KeyValuePipe, i1$2.TranslatePipe, ModelLogDiffPipe],
        styles: ["[_ngcontent-%COMP%]:root{--cap-input-height: 30px;--cap-dynamic-filter-input-height: 30px;--cap-dynamic-filter-border-radius: 5px;--cap-dynamic-filter-border-width: 1px;--cap-dynamic-filters-hide-filters-on-mobile: false;--cap-dynamic-filters-filter-flex: 1;--cap-dynamic-filters-flex-wrap: wrap;--cap-dynamic-filter-width: 200px;--cap-dynamic-filter-label-font-size: 14px;--cap-dynamic-filter-label-font-weight: 600;--cap-dynamic-filter-label-font-family: \"Source Sans Pro\";--cap-dynamic-filter-label-font-color: #5f6062;--cap-dynamic-filter-placeholder-font-weight: 600;--cap-dynamic-filter-placeholder-font-color: #5f6062;--cap-dynamic-filter-icon-opacity: 1;--cap-dynamic-filter-icon-color: var(--cap-primary-color)}.full-history[_ngcontent-%COMP%]{line-height:36px;display:flex;align-content:center;margin-bottom:6px;font-weight:700;max-width:65%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.show-full-history[_ngcontent-%COMP%]{color:var(--cap-primary-color);text-decoration:underline;cursor:pointer;font-weight:600;line-height:36px;margin-bottom:6px;float:right;max-width:35%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.history[_ngcontent-%COMP%]{border-left:2px dashed var(--cap-primary-color);padding-left:15px}.timeline__created[_ngcontent-%COMP%]{font-size:.86rem;color:#33333380;text-align:left;margin-top:5px}.timeline__title[_ngcontent-%COMP%]{color:#595b5d;font-weight:600}.timeline__scheduled[_ngcontent-%COMP%]{color:var(--cap-primary-color);font-weight:600;font-size:1rem;max-width:80%}.timeline__content[_ngcontent-%COMP%]{margin-top:10px}.timeline[_ngcontent-%COMP%]   .strikethrough[_ngcontent-%COMP%]{text-decoration:line-through;color:#5f606240}.timeline__body[_ngcontent-%COMP%]{font-size:1em;color:#333}.timeline__body[_ngcontent-%COMP%]   .body-row[_ngcontent-%COMP%]{padding:7px 0}.timeline[_ngcontent-%COMP%]   .diff-value[_ngcontent-%COMP%]{font-weight:600}.timeline__no-results[_ngcontent-%COMP%]{text-align:center;font-weight:600}"],
        changeDetection: 0
      });
    }
  }
  return ModelLogTimelineComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ModelLogModule = /*#__PURE__*/(() => {
  class ModelLogModule {
    static {
      this.ɵfac = function ModelLogModule_Factory(t) {
        return new (t || ModelLogModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: ModelLogModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, TranslateModule]
      });
    }
  }
  return ModelLogModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let VersionCheckService = /*#__PURE__*/(() => {
  class VersionCheckService {
    constructor(http, coreConfig) {
      this.http = http;
      this.coreConfig = coreConfig;
      this.onUpdateVersion = new EventEmitter();
      if (this.coreConfig?.environment?.currentHash) {
        this.currentHash = this.coreConfig.environment.currentHash;
      } else {
        console.warn('Could not determine currentHash in environment. Make sure to pass the environment with the currentHash');
      }
    }
    /**
     * Checks in every set frequency the version of frontend application
     * @param url
     * @param {number} frequency - in milliseconds, defaults to 30 minutes
     */
    initVersionCheck(url, frequency = 1000 * 60 * 30) {
      if (this.currentHash) {
        setInterval(() => {
          this.checkVersion(url);
        }, frequency);
        this.checkVersion(url);
      }
    }
    /**
     * Will do the call and check if the hash has changed or not
     * @param url
     */
    checkVersion(url) {
      // timestamp these requests to invalidate caches
      this.http.get(url + '?t=' + new Date().getTime()).pipe(take(1)).subscribe(response => {
        const hash = response.hash;
        const hashChanged = this.hasHashChanged(this.currentHash, hash);
        // If new version, do something
        if (hashChanged) {
          this.onUpdateVersion.emit({
            version: response.version,
            hash: response.hash
          });
        }
        // store the new hash so we wouldn't trigger versionChange again
        // only necessary in case you did not force refresh
        this.currentHash = hash;
      }, err => {
        console.error(err, 'Could not get version');
      });
    }
    /**
     * Checks if hash has changed.
     * This file has the JS hash, if it is a different one than in the version.json
     * we are dealing with version change
     * @param currentHash
     * @param newHash
     * @returns {boolean}
     */
    hasHashChanged(currentHash, newHash) {
      const defaultPlaceholder = '[{POST_BUILD_ENTERS_HASH_HERE}}'.replace('[', '{');
      if (!currentHash || currentHash === defaultPlaceholder) {
        return false;
      }
      return currentHash !== newHash;
    }
    static {
      this.ɵfac = function VersionCheckService_Factory(t) {
        return new (t || VersionCheckService)(i0.ɵɵinject(i1$3.HttpClient), i0.ɵɵinject(CompleteConfig));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: VersionCheckService,
        factory: VersionCheckService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return VersionCheckService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BatchStatusNavigateAction = /*#__PURE__*/(() => {
  class BatchStatusNavigateAction {
    constructor(router) {
      this.router = router;
    }
    execute(action) {
      if (action?.action) {
        this.router.navigateByUrl(action.action);
      }
    }
    static {
      this.ɵfac = function BatchStatusNavigateAction_Factory(t) {
        return new (t || BatchStatusNavigateAction)(i0.ɵɵinject(i1$1.Router));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BatchStatusNavigateAction,
        factory: BatchStatusNavigateAction.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BatchStatusNavigateAction;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BatchStatusActionsService = /*#__PURE__*/(() => {
  class BatchStatusActionsService {
    constructor() {
      this._actions = {
        navigate: BatchStatusNavigateAction
      };
    }
    get actions() {
      return this._actions;
    }
    addActions(actions) {
      if (actions) {
        this._actions = {
          ...this.actions,
          ...actions
        };
      }
    }
    static {
      this.ɵfac = function BatchStatusActionsService_Factory(t) {
        return new (t || BatchStatusActionsService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BatchStatusActionsService,
        factory: BatchStatusActionsService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BatchStatusActionsService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let BatchStatusService = /*#__PURE__*/(() => {
  class BatchStatusService extends ApiService {
    constructor(apiHttp, notificationService, translateService, batchStatusActions, injector) {
      super(apiHttp);
      this.apiHttp = apiHttp;
      this.notificationService = notificationService;
      this.translateService = translateService;
      this.batchStatusActions = batchStatusActions;
      this.injector = injector;
      this._endpoint = 'job-batch';
      this.defaultInterval = 3000;
      this.activeBatches = new Map();
    }
    getBatchIdByIdentifier(identifier) {
      return this.activeBatches.get(identifier);
    }
    setActiveBatch(batchId, identifier) {
      this.activeBatches.set(identifier, batchId);
    }
    removeBatch(batchId) {
      let id = null;
      this.activeBatches.forEach((value, key) => {
        if (value === batchId) {
          id = key;
        }
      });
      this.activeBatches.delete(id);
    }
    getBatchStatus(id, options) {
      this.endpoint = `${this._endpoint}/status`;
      return super.get(id, options).pipe(tap(response => {
        if (response.finished_at) {
          this.removeBatch(id);
        }
      }));
    }
    getBatchSize(options) {
      this.endpoint = `${this._endpoint}/size`;
      return this.apiHttp.get(`/${this.endpoint}` + this.getOptionsQuery(options)).pipe(map(result => result.hasOwnProperty('data') ? result.data : result));
    }
    getFailedJobs(options) {
      this.endpoint = `${this._endpoint}/failed`;
      return super.index(options);
    }
    getFailedJob(id, options) {
      this.endpoint = `${this._endpoint}/failed`;
      return super.get(id, options);
    }
    getIsUpdatedBatch(batchId, showSuccessfulMessage = true, successMessageKey = 'toast.success.title', executeAction = true, options) {
      const subject = new BehaviorSubject({
        finished: false,
        progress: 0
      });
      this.getBatchStatus(batchId).pipe(switchMap(response => {
        if (response.finished_at || response.failed_jobs > 0) {
          return of({
            finished: true,
            withFailures: response.failed_jobs > 0,
            action: response.action,
            message: null,
            progress: 100
          });
        } else {
          return this.startInterval(batchId, options?.interval).pipe(map(batchStatus => {
            return {
              finished: !!batchStatus.finished_at || batchStatus.failed_jobs > 0,
              withFailures: batchStatus.failed_jobs > 0,
              action: batchStatus.action,
              message: null,
              progress: batchStatus.progress
            };
          }));
        }
      }), catchError(error => {
        return of({
          finished: true,
          withFailures: true,
          action: null,
          message: error.error || error.message,
          progress: 0
        });
      }), takeUntil(subject.asObservable().pipe(filter$1(status => status.finished === true)))).subscribe(response => {
        if (response.withFailures) {
          this.notificationService.error(this.translateService.instant('toast.error.title'), this.translateService.instant('toast.error.message'));
        } else if (response.finished && showSuccessfulMessage) {
          this.notificationService.success(this.translateService.instant('toast.success.title'), this.translateService.instant(successMessageKey));
        }
        if (response.finished && executeAction && response.action?.type) {
          this.executeAction(response.action);
        }
        subject.next({
          finished: response.finished,
          action: response.action,
          message: response.message,
          progress: response.progress
        });
      });
      return subject.asObservable();
    }
    startInterval(batchId, intervalAmount = this.defaultInterval) {
      return interval(intervalAmount ?? this.defaultInterval).pipe(switchMap(() => this.getBatchStatus(batchId)));
    }
    executeAction(action) {
      if (action) {
        if (this.batchStatusActions.actions[action.type]) {
          const instance = this.injector.get(this.batchStatusActions.actions[action.type]);
          if (instance) {
            instance.execute(action);
          }
        } else {
          throw Error(`Action "${action.type}" not found. Make sure to provide the action in the BatchStatusActionsService`);
        }
      }
    }
    static {
      this.ɵfac = function BatchStatusService_Factory(t) {
        return new (t || BatchStatusService)(i0.ɵɵinject(i1.ApiHttpService), i0.ɵɵinject(i4$2.ToastService), i0.ɵɵinject(i1$2.TranslateService), i0.ɵɵinject(BatchStatusActionsService), i0.ɵɵinject(i0.Injector));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: BatchStatusService,
        factory: BatchStatusService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return BatchStatusService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TableService = /*#__PURE__*/(() => {
  class TableService {
    constructor() {
      this.updateTableSubject = new BehaviorSubject(null);
      this.paginatorSubject = new BehaviorSubject({
        rows: 20,
        total: 0,
        total_pages: 0,
        first: 1,
        per_page: 20,
        current_page: 1
      });
    }
    updateTableByLazyLoadEvent(event) {
      const apiOptions = {
        ...this.updateTableSubject.getValue()
      };
      if (event) {
        if (event.sortField) {
          apiOptions.sort = [{
            field: event.sortField,
            direction: event.sortOrder === 1 ? 'asc' : 'desc'
          }];
        }
        if (event.first !== undefined) {
          apiOptions.page = Math.floor(event.first / event.rows) + 1;
        }
        apiOptions.perPage = event.rows;
      }
      this.updateTableSubject.next(apiOptions);
    }
    updateTableByFilters(filters) {
      const optionFilters = filters.reduce((acc, activeFilter) => {
        let value = activeFilter.value;
        if (value !== null) {
          if (activeFilter.matchMode === FilterMatchMode.LIKE) {
            value = `%${value}%`;
          }
          return [...acc, {
            field: activeFilter.field,
            value,
            operator: activeFilter.matchMode
          }];
        } else {
          return acc;
        }
      }, []);
      this.updateTableSubject.next({
        ...this.updateTableSubject.getValue(),
        filters: optionFilters
      });
    }
    getUpdateTable() {
      return this.updateTableSubject.asObservable();
    }
    resetUpdateTable() {
      return this.updateTableSubject.next(null);
    }
    refreshTable() {
      this.updateTableSubject.next(this.updateTableSubject.getValue());
    }
    getPaginator() {
      return this.paginatorSubject.asObservable();
    }
    setPaginator(meta) {
      this.paginatorSubject.next({
        rows: meta?.pagination.per_page,
        total: meta?.pagination.total,
        total_pages: meta?.pagination.total_pages,
        first: (meta?.pagination.current_page - 1) * meta?.pagination.per_page,
        per_page: meta?.pagination.per_page,
        current_page: meta?.pagination.current_page
      });
    }
    static {
      this.ɵfac = function TableService_Factory(t) {
        return new (t || TableService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: TableService,
        factory: TableService.ɵfac
      });
    }
  }
  return TableService;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ErrorMessageInterceptor = /*#__PURE__*/(() => {
  class ErrorMessageInterceptor {
    constructor(router, toastService, translateService, authService) {
      this.router = router;
      this.toastService = toastService;
      this.translateService = translateService;
      this.authService = authService;
    }
    intercept(request, next) {
      return next.handle(request).pipe(catchError(err => {
        this.handleError(err, request);
        this.catchErrorLogic(err, request);
        return throwError(err);
      }));
    }
    defaultParsingErrors(err) {
      if (this.exceptionUrls(err)) {
        if (err.error && err.error.hasOwnProperty('errors')) {
          const errorKeys = Object.keys(err.error.errors);
          if (errorKeys && errorKeys.length) {
            const firstError = err.error.errors[errorKeys[0]][0];
            this.toastService.error(this.translateService.instant('toast.error.title'), firstError);
          }
        } else if (err.error && err.error.message) {
          this.toastService.error(this.translateService.instant('toast.error.title'), err.error.message);
        }
      }
    }
    exceptionUrls(err) {
      let response = false;
      response = (err.status === 422 || err.status === 500) && (err.url.endsWith('/auth/login') || err.url.endsWith('/auth/recovery'));
      return !response;
    }
    notAuthorizeHandle(err) {
      this.authService.logout().subscribe(result => {
        if (result) {
          // Navigate to login
          this.router.navigate([`auth/login`]).then(() => {
            // Hotfix: reload page because of user specific indexDB issue
            window.location.reload();
          });
        }
      });
    }
    handleError(err, request) {
      if (err instanceof HttpErrorResponse && err.error instanceof Blob && err.headers.get('Content-Type') === 'application/json') {
        const reader = new FileReader();
        reader.addEventListener('loadend', e => {
          const errorFromBlob = {
            error: JSON.parse(e.srcElement['result'])
          }; /* tslint:disable-line deprecation */
          this.catchErrorLogic(errorFromBlob, request);
        });
        reader.readAsText(err.error);
      }
    }
    catchErrorLogic(err, request) {
      switch (err.status) {
        case 401:
          this.notAuthorizeHandle(err);
          break;
        default:
          this.defaultParsingErrors(err);
      }
    }
    static {
      this.ɵfac = function ErrorMessageInterceptor_Factory(t) {
        return new (t || ErrorMessageInterceptor)(i0.ɵɵinject(i1$1.Router), i0.ɵɵinject(i4$2.ToastService), i0.ɵɵinject(i1$2.TranslateService), i0.ɵɵinject(i2$1.AuthService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: ErrorMessageInterceptor,
        factory: ErrorMessageInterceptor.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ErrorMessageInterceptor;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumHttpCodeInterceptor = /*#__PURE__*/(() => {
  class CapturumHttpCodeInterceptor {
    constructor(toastService, validatorService, translateService) {
      this.toastService = toastService;
      this.validatorService = validatorService;
      this.translateService = translateService;
    }
    intercept(request, next) {
      return next.handle(request).pipe(tap(() => null, error => {
        if (error instanceof HttpErrorResponse) {
          switch (error.status) {
            case 400:
            case 403:
            case 422:
            case 401:
              this.parseValidations(error.error);
              break;
            default:
              break;
          }
        }
      }));
    }
    parseValidations(response) {
      const keys = response.errors && Object.keys(response.errors);
      const nonField = response.errors && +Object.keys(response.errors)[0] === 0;
      if (keys && keys.length) {
        const fieldErrors = keys.reduce((accumulator, key) => ({
          ...accumulator,
          [key]: response.errors[key]
        }), {});
        this.validatorService.backendValidation.next(fieldErrors);
      }
      if (nonField) {
        const message = response.errors[0].join('\n');
        this.onNonFieldError(message);
      }
    }
    onNonFieldError(message) {
      this.toastService.error(this.translateService.instant('toast.error.title'), message);
    }
    static {
      this.ɵfac = function CapturumHttpCodeInterceptor_Factory(t) {
        return new (t || CapturumHttpCodeInterceptor)(i0.ɵɵinject(i4$2.ToastService), i0.ɵɵinject(i4$2.ValidatorService), i0.ɵɵinject(i1$2.TranslateService));
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: CapturumHttpCodeInterceptor,
        factory: CapturumHttpCodeInterceptor.ɵfac
      });
    }
  }
  return CapturumHttpCodeInterceptor;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NotFoundComponent = /*#__PURE__*/(() => {
  class NotFoundComponent {
    constructor() {
      this.titleTranslationKey = 'not-found.header';
      this.textTranslationKey = 'not-found.text';
      this.image = 'data:image/png;base64,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';
    }
    static {
      this.ɵfac = function NotFoundComponent_Factory(t) {
        return new (t || NotFoundComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NotFoundComponent,
        selectors: [["emc-not-found"]],
        inputs: {
          titleTranslationKey: "titleTranslationKey",
          textTranslationKey: "textTranslationKey",
          image: "image"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 8,
        vars: 7,
        consts: [[1, "cap-not-found"], ["alt", "not-found", 3, "src"], [1, "cap-not-found-header"], [1, "cap-not-found-text"]],
        template: function NotFoundComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵelement(1, "img", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 3);
            i0.ɵɵtext(6);
            i0.ɵɵpipe(7, "translate");
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("src", ctx.image, i0.ɵɵsanitizeUrl);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 3, ctx.titleTranslationKey), " ");
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(7, 5, ctx.textTranslationKey), " ");
          }
        },
        dependencies: [CommonModule, TranslateModule, i1$2.TranslatePipe],
        styles: [".cap-not-found{margin-top:150px;width:100%;text-align:center}.cap-not-found img{width:80%}@media only screen and (min-width: 600px){.cap-not-found img{width:45%}}.cap-not-found .cap-not-found-header{font-size:2.1rem;margin-top:80px;font-weight:600;color:#5f6062}.cap-not-found .cap-not-found-text{margin-top:20px;color:#5f6062;font-size:1.5rem;font-weight:400;text-align:center}\n"],
        encapsulation: 2,
        changeDetection: 0
      });
    }
  }
  return NotFoundComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let JobsListComponent = /*#__PURE__*/(() => {
  class JobsListComponent {
    constructor(batchStatusService, tableService, translateService) {
      this.batchStatusService = batchStatusService;
      this.tableService = tableService;
      this.translateService = translateService;
      this.loading = true;
      this.tableColumns = [];
      this.dateFormat = DateFormat;
    }
    ngOnInit() {
      this.paginator$ = this.tableService.getPaginator();
      this.tableColumns = this.generateColumns();
      this.pendingJobsCount$ = this.batchStatusService.getBatchSize().pipe(map$1(response => response.pending_jobs));
      this.data$ = this.tableService.getUpdateTable().pipe(skip(1), switchMap(options => {
        return this.batchStatusService.getFailedJobs(options).pipe(tap(({
          meta
        }) => {
          this.tableService.setPaginator(meta);
        }), map$1(response => response?.data));
      }), tap(() => {
        this.loading = false;
      }));
    }
    loadTableData(event) {
      if (!event?.sortField) {
        event.sortField = 'failed_at';
        event.sortOrder = 0;
      }
      this.tableService.updateTableByLazyLoadEvent(event);
    }
    generateColumns() {
      return [{
        field: 'connection',
        title: this.translateService.instant('jobs.list.column.connection.label')
      }, {
        field: 'queue',
        title: this.translateService.instant('jobs.list.column.queue.label')
      }, {
        field: 'failed_at',
        title: this.translateService.instant('jobs.list.column.failed-at.label'),
        type: InfoTableColumnType.Template
      }];
    }
    static {
      this.ɵfac = function JobsListComponent_Factory(t) {
        return new (t || JobsListComponent)(i0.ɵɵdirectiveInject(BatchStatusService), i0.ɵɵdirectiveInject(TableService), i0.ɵɵdirectiveInject(i1$2.TranslateService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: JobsListComponent,
        selectors: [["cap-jobs-list"]],
        features: [i0.ɵɵProvidersFeature([TableService])],
        decls: 8,
        vars: 6,
        consts: [[1, "back-btn", "text-left", "page__main", "main", "ml-5", "mb-n3", "mt-2"], ["routerLink", "/config"], [1, "fa", "fa-chevron-left"], [3, "title"], ["capTemplate", "first-content"], [1, "jobs-status"], [1, "title"], [3, "columns", "stateKey", "data", "sortable", "loading", "paginator", "lazyLoading", "onLazyLoad"], ["infoTable", ""], ["capTemplate", "failed_at"]],
        template: function JobsListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "a", 1);
            i0.ɵɵelement(2, "i", 2);
            i0.ɵɵtext(3);
            i0.ɵɵpipe(4, "translate");
            i0.ɵɵelementEnd()();
            i0.ɵɵelementStart(5, "cap-layout-details", 3);
            i0.ɵɵpipe(6, "translate");
            i0.ɵɵtemplate(7, JobsListComponent_ng_template_7_Template, 13, 20, "ng-template", 4);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(4, 2, "button.back-to-overview"), "");
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("title", i0.ɵɵpipeBind1(6, 4, "jobs.status.label"));
          }
        },
        dependencies: [i1$1.RouterLink, i5$4.CapturumLayoutDetailsComponent, i6$3.CapturumInfoTableComponent, i4$2.CapturumTemplateDirective, i3.AsyncPipe, i3.DatePipe, i1$2.TranslatePipe],
        styles: [".jobs-status[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{padding-bottom:1rem}"],
        changeDetection: 0
      });
    }
  }
  return JobsListComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const routes = [{
  path: '',
  component: JobsListComponent
}];
let JobsRoutingModule = /*#__PURE__*/(() => {
  class JobsRoutingModule {
    static {
      this.ɵfac = function JobsRoutingModule_Factory(t) {
        return new (t || JobsRoutingModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: JobsRoutingModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [RouterModule.forChild(routes), RouterModule]
      });
    }
  }
  return JobsRoutingModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let JobsModule = /*#__PURE__*/(() => {
  class JobsModule {
    static {
      this.ɵfac = function JobsModule_Factory(t) {
        return new (t || JobsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: JobsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, JobsRoutingModule, NgxPermissionsModule, RouterModule, CapturumLayoutDetailsModule, CapturumInfoTableModule, SharedModule]
      });
    }
  }
  return JobsModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let SentryErrorHandler = /*#__PURE__*/(() => {
  class SentryErrorHandler {
    handleError(error) {
      const exception = error?.error || error?.message || error?.originalError || '';
      let chunkFailedMessage = /Loading chunk .+ failed|Failed to fetch dynamically imported module/;
      if (chunkFailedMessage.test(exception)) {
        this.reloadPage();
        return;
      }
      if (error instanceof HttpErrorResponse) {
        // Handle the HTTP errors without logging the error to Sentry
        return;
      } else if (error) {
        let errorReason = 'Unknown reason';
        // Handle all errors and set as much information as possible in tags
        if (error.name === 'EmptyError') {
          errorReason = 'No data or empty array returned';
        } else if (error.name === '<unknown>' || error.title === 'unknown') {
          errorReason = `The <unknown> title usually means that there was no error message when the error was
                       generated or is not caught and handled by the error handling system`;
        }
        this.captureSentryException(exception, errorReason);
      }
    }
    reloadPage() {
      window.location.reload();
    }
    captureSentryException(error, errorReason) {
      captureException(error, {
        tags: {
          headers: error.headers,
          message: error.message,
          name: error.name,
          reason: errorReason
        }
      });
    }
    static {
      this.ɵfac = function SentryErrorHandler_Factory(t) {
        return new (t || SentryErrorHandler)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: SentryErrorHandler,
        factory: SentryErrorHandler.ɵfac
      });
    }
  }
  return SentryErrorHandler;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AuthAuthenticatorComponent, AuthEmailComponent, AuthSmsComponent, BaseDataApiModel, BaseDataFormComponent, BaseDataIndexedDbModel, BaseDataKeyIndexedDbModel, BaseDataKeyService, BaseDataModule, BaseDataResolver, BaseDataService, BaseDataTranslationPipe, BaseDataValueApiModel, BaseDataValueFormComponent, BaseDataValueIndexedDbModel, BaseDataValueService, BatchStatusActionsService, BatchStatusService, CapturumHttpCodeInterceptor, CapturumTranslateParser, CompleteConfig, CompleteConfigService, CompleteModule, CompleteResolver, ConfigOverviewComponent, ConnectivityService, DataService, EditTranslationDialogComponent, EditTranslationsTogglerComponent, ErrorMessageInterceptor, FileIndexedDbModel, FilteredTranslationResolver, IfSettingDirective, IndexedDbGuard, IndexedDbModel, IndexedDbModule, IndexedDbService, JobsListComponent, JobsModule, JobsRoutingModule, LocaleModule, LocaleService, ModelLogDiffPipe, ModelLogModule, ModelLogTimelineComponent, ModuleIndexedDbModel, ModuleResolver, ModuleService, ModuleTenantIndexedDbModel, ModuleTenantResolver, ModuleTenantService, MultiFactorDialogComponent, MultiFactorDisableFormComponent, MultiFactorEnableFormComponent, MultiFactorFormComponent, NotFoundComponent, PasswordFormComponent, PermissionGuard, PermissionIndexedDbModel, PermissionModule, PermissionResolver, PermissionService, PublicSettingResolver, PublicSettingService, PublicTranslationResolver, PublicTranslationService, QueryOptions, Role, RoleFormComponent, RoleModule, RoleService, SentryErrorHandler, SettingApiModel, SettingColorDirective, SettingFormComponent, SettingIndexedDbModel, SettingModule, SettingPipe, SettingResolver, SettingService, Store, SyncErrorType, SyncService, SynchronisationService, TableService, Tenant, TenantFormComponent, TenantIndexedDbModel, TenantModule, TenantService, TranslationFormComponent, TranslationIndexedDbModel, TranslationKeyService, TranslationLoader, TranslationModule, TranslationResolver, TranslationService, User, UserFormComponent, UserIndexedDbModel, UserModule, UserProfileComponent, UserService, UserValidator, UtilService, VersionCheckService };
